/**
* -----------------------------------------------------------------------------
DeclarativeShadowElement
0. Base
1. Component carousel
2. Image behavior
3. Image with text
4. Marquee
5. Countdown timer
6. Multimedia player
7. Gallery modal
8. Product media
9. Product card
10. Before after
11. Dialog
12. Accordion
13. Tab player list
14. Copy button and share button
15. Lazy HTML
16. Customer JS
ease = [0.25, 0.1, 0.25, 1.0]
* -----------------------------------------------------------------------------
**/

/**
* 0. Base
* -----------------------------------------------------------------------------
*/
import { $4, $$4, $id4, debounce, throttle, fetchCache, fetchConfig, currency, matchMediaQuery, createImg, renderSrcset, requestIdleCallback, checkImagesLoaded, getArrVisible, AutoplayElement, animationContent, admEvts, expiresManager, announce } from '@theme/utilities';
import { ThemeEvents, CartUpdateEvent, CartCountEvent, QuantitySelectorUpdateEvent, MediaStartedPlayingEvent, DiscountUpdateEvent } from '@theme/events';
import { animate, stagger, scroll, inView, frame, resize, delay, motionValue, hover, springValue, styleEffect } from "@theme/m";
import { trapFocus, removeTrapFocus, elFocus } from '@theme/focus';
const  { cartUpdate, cartReload, cartCount, cartError, currencyUpdate, cartDrawerRender, cartMainRender, loadingStart, loadingEnd, dialogOpening, dialogOpen, dialogClosing, dialogClose, discountUpdate } = ThemeEvents;
const html = document.documentElement,
isRTL = ("rtl" == html.getAttribute("dir"));

// Memory leaks
var getterAdd = (ww, key, value, override = false) => {
  //console.log('override', override );
  if (!override && ww.has(key) ) return;
  //console.log('addd', !override, ww.has(key), value );
  (ww instanceof WeakSet) ? ww.add(key) : ww.set(key, value);
};
var getterGet = (wm, key, value) => {
  if ( !wm.has(key)) {
    if (value) {
      getterAdd(wm, key, value, true);
    } else {
      return null;
    }
  }
  return wm.get(key);
};
var getterRunFn = (ww, key, fn) => {
  if ( !ww.has(key)) throw TypeError(ww + "no exist");
  return fn;
};
var getterDelete = (ww, key) => {
  if ( ww.has(key)) ww.delete(key);
};
// var _thu = { nvt: 1 };

// function isFunction(functionToCheck) {
//   return (typeof functionToCheck === "function");
// }
// function loadScript(src) {
//   return new Promise(function(resolve, reject) {
//   const script = document.createElement('script');
//   script.async = true;
//   script.src = src;
//   script.onload = resolve;
//   script.onerror = reject;
//   document.head.appendChild(script);
//   });
// }

// const JSONProducts = {};
// class getJSONProduct {
//   static load(productHandle) {
//     if (!productHandle) {
//       return;
//     }
//     if (JSONProducts[productHandle]) {
//       return JSONProducts[productHandle];
//     }
//     JSONProducts[productHandle] = new Promise(async (resolve, reject) => {
//       const response = await fetch(`${Shopify.routes.root}products/${productHandle}.js`);
//       if (response.ok) {
//         const responseAsJson = await response.json();
//         resolve(responseAsJson);
//       } else {
//         reject(`${productHandle} not loaded json`);
//       }
//     });
//     return JSONProducts[productHandle];
//   }
// };

// Visibilitychange
// function visibilitychangeFn(options) {
//   if (!options.observes) return;
//   const checkVisibility = () => {
//     if (document.visibilityState === 'visible') {
//       if (isFunction(options.play) && options.observes.isInview) options.play();
//     } else if (isFunction(options.pause)) {
//       options.pause();
//     }
//   }
//   document.addEventListener('visibilitychange', checkVisibility);

// }

/**
 * Wrap tables in a container div to make them scrollable when needed
 */
function rteWrapTable(doc = document) {
  const tables = $$4('.rte table:not(.hdt-wrapper-added)', doc);
  if (tables.length == 0) return
  tables.forEach((table) => {
    table.classList.add('hdt-wrapper-added');
    table.outerHTML = `<div class="hdt-scrollable-wrapper">${table.outerHTML}</div>`;
  });
}

/**
 * Add aria-describedby attribute to external and new window links
 */
function accessibleLinks(doc = document) {
  const { hostname } = window.location,
  links = $$4('a[href]:not([aria-describedby])', doc);
  if (links.length == 0) return;

  links.forEach((link) => {
    const isExternal  = link.hostname !== hostname,
        isTargetBlank = link.getAttribute('target') === '_blank';

    if (isTargetBlank) {
      link.setAttribute('aria-describedby', isExternal ? 'a11y-new-window-external-message' : 'a11y-new-window-message');
      const rel = link.getAttribute('rel');
      if (!rel || rel.indexOf('noopener') === -1) {
        link.setAttribute('rel',`${rel ? rel + ' '  : ''}noopener`);
      }
    } else if (isExternal) {
      link.setAttribute('aria-describedby', 'a11y-external-message');
    }
  });
}

/** Link Mylti Lang **/
function localeUrl(doc = document) {
  const {root} = Shopify.routes,
        {hostname} = window.location;
  if ( root == '/' ) return;
  $$4('a[href="/"]', doc).forEach((el) => el.setAttribute('href', root ));
  $$4(`a[href*="${hostname}/"]:not([unless-url],[href*="${hostname + root}"],[href*="@"],[href*="preview_theme_id="])`, doc).forEach((el) => el.setAttribute('href', el.getAttribute('href').replace( `${hostname}/`, hostname + root ) ));
};
/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends HTMLElement {
  connectedCallback() {
    $$4('table', this).forEach(this.#formatTable);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    // const wrapper = document.createElement('div');
    // wrapper.classList.add('rte-table-wrapper');
    // const parent = table.parentNode;
    // if (parent) {
    //   parent.insertBefore(wrapper, table);
    //   wrapper.appendChild(table);
    // }
    table.classList.add('hdt-wrapper-added');
    table.outerHTML = `<div class="hdt-scrollable-wrapper">${table.outerHTML}</div>`;
  }
}

customElements.define('rte-formatter', RTEFormatter);
// https://web.dev/articles/declarative-shadow-dom
// class attachShadowRoots extends HTMLElement {
//   connectedCallback(){
//     if (!HTMLTemplateElement.prototype.hasOwnProperty('shadowRootMode') ) this.attachShadowRoots();
//     if (Shopify.designMode) {
//       this.closest('.shopify-section')?.addEventListener(admEvts.seLoad, (evt) => {
//         //console.log('attachShadowRoots seLoad', evt);
//         this.attachShadowRoots();
//       });
//       // this.closest('.shopify-section')?.addEventListener(admEvts.seSelect, (evt) => {
//       //   console.log('attachShadowRoots seSelect', evt);
//       // });
//       // this.addEventListener(admEvts.select, (evt) => {
//       //   console.log('attachShadowRoots select', evt);
//       // });
//       // this.addEventListener(admEvts.deselect, (evt) => {
//       //   console.log('attachShadowRoots deselect', evt);
//       // });
//     }
//   }
//   attachShadowRoots() {
//     //console.log('attachShadowRoots', this.shadowRoot);
//     if (this.shadowRoot) return;
//     const tmp = $4('template[shadowrootmode]', this);
//     const shadowRoot = tmp.parentNode.attachShadow({ mode: "open" });
//     shadowRoot.appendChild(tmp.content);
//     tmp.remove();
//   }
// }
// customElements.define('hdt-tmp', attachShadowRoots);

let cartPromise = null;
function getCart() {
  if (!cartPromise) {
    cartPromise = fetch(`${Shopify.routes.root}cart.js`)
    .then(r => r.json())
    .finally(() => {
      // Detete cache after when resolve/reject done
      setTimeout( ()=> {
        cartPromise = null;
      }, 200)
    });
  }
  return cartPromise;
}

class DragCursor extends HTMLElement {
  #controller;
  #x = springValue(0);
  #y = springValue(0);
  #scale = springValue(0);
  #opacity = springValue(0);
  #initialX;
  #initialY;
  constructor() {
    super();
  }
  connectedCallback() {
    this.#controller = new AbortController();
    if (!matchMediaQuery("hover")) return;
    const { top, left, width, height } = this.getBoundingClientRect();
    this.#initialX = left + width / 2;
    this.#initialY = top + height / 2;
    styleEffect(this, { x: this.#x, y: this.#y, scale: this.#scale, opacity: this.#opacity })
  }
  disconnectedCallback() {
   this.#controller.abort();
  }

  // get isPointerSupported() {
  //   return (
  //     !('ontouchstart' in window) &&
  //     !(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) &&
  //     window.matchMedia('(pointer: fine)').matches
  //   );
  // }

  setupCursorElement(parentEl) {
    if (!matchMediaQuery("hover")) return;
    if (!this.inited) {
      document.addEventListener('mousemove', this.handleMouseMove.bind(this), { signal: this.#controller.signal });
      this.inited = true;
    }
    hover(parentEl, () => {
      if (parentEl.mousemove) this.handleCursor(parentEl)
      //console.log('hover in')
      return () => {
        //console.log('hover out')
        this.handleCursor(parentEl, false);
      }
    })
    // parentEl.addEventListener('mouseenter', this.handleCursor.bind(this, parentEl));
    // parentEl.addEventListener('mouseleave', this.handleCursor.bind(this, parentEl));
    parentEl.mousemove = false;
    parentEl.addEventListener('mousemove', ()=> {
      //this.handleCursor.bind(this, parentEl)
      parentEl.mousemove = true;;
      this.handleCursor(parentEl);
    }, { once: true });
    $$4('a:not([unless]), button, [role="button"], [hide-cursor-drag]', parentEl).forEach(element => {
      hover(element, () => {
        this.handleLinkHover(parentEl)
        return () => this.handleLinkHover(parentEl, true);
      })
      // element.addEventListener('mouseenter', this.handleLinkHover.bind(this, parentEl));
      // element.addEventListener('mouseleave', this.handleLinkHover.bind(this, parentEl));
    });
  }

  handleMouseMove(e) {
    this.#x.set(e.clientX - this.#initialX)
    this.#y.set(e.clientY - this.#initialY)
    // requestAnimationFrame(() => {
    //   animate(this, { left: [null, `${e.clientX}px`], top: [null, `${e.clientY}px`] }, { duration: .03, ease: 'easeOut' });
    // });
  }
  // handleCursor(el, e) {
  //   if (!el?.isActive) return;
  //   this.classList.toggle('crs-drag-active', e.type !== 'mouseleave');
  //   el.classList.toggle('crs-drag-active', e.type !== 'mouseleave');
  // }
  handleCursor(el, add = true) {
    //console.log(el, add)
    if (!el?.isActive) return;
    this.classList.toggle('crs-drag-active', add);
    el.classList.toggle('crs-drag-active', add);
    this.#scale.set(add ? 1 : 0.5);
    this.#opacity.set(add ? 1 : 0);
  }
  // handleLinkHover(el, e) {
  //   //console.log(el)
  //   if (!el?.isActive) return;
  //   this.classList.toggle('crs-drag-active', e.type === 'mouseleave');
  //   el.classList.toggle('crs-drag-active', e.type === 'mouseleave');
  // }
  handleLinkHover(el, add = false) {
    //console.log(el)
    if (!el?.isActive) return;
    this.classList.toggle('crs-drag-active', add);
    el.classList.toggle('crs-drag-active', add);
    this.#scale.set(add ? 1 : 0.5);
    this.#opacity.set(add ? 1 : 0);
  }
}
customElements.define('hdt-drag-cursor', DragCursor);

/**
* 1. Component carousel
*/
const aniClipPath = {
  "none": "none",
  "ani1": "inset(0 0 100% 0)", // Top to bottom
  "ani2": "inset(100% 0 00)", // Bottom to top
  "ani3": "inset(0 100% 0 0)", // Left to right
  "ani4": "inset(0 0 0 100%)" // Right to left
}

/**
* 2. Image behavior
* -----------------------------------------------------------------------------
*/
var _image_behavior = new WeakSet(),
_image_behavior_fn, _img_effect = new WeakMap(),
_behavior_effect  = new WeakMap();
class ImageBehavior extends HTMLElement {
  constructor() {
    super();
    getterAdd(_image_behavior, this);
    getterAdd(_img_effect, this, $4('img[is="img-effect"]', this));
  }
  connectedCallback() {
    if (!getterGet(_img_effect, this)) return;
    getterAdd(_behavior_effect, this, this.getAttribute('eff') || getterGet(_img_effect, this).getAttribute('eff'));
    if (getterGet(_behavior_effect, this) != 'none' && matchMediaQuery("motion")) getterRunFn(_image_behavior, this, _image_behavior_fn).call(this);
  }
};
_image_behavior_fn = function(){
  if ( getterGet(_behavior_effect, this) === 'ambient' ) {
    // ambient
    animate(getterGet(_img_effect, this), { transform: ["rotate(0deg) translateX(1em) rotate(0deg) scale(1.2)", "rotate(360deg) translateX(1em) rotate(-360deg) scale(1.2)"] }, {
      duration: 30,
      ease: "linear",
      repeat: Infinity
    });
  } else if ( getterGet(_behavior_effect, this) === 'parallax' ) {
    // parallax
    const getScale = parseFloat(this.style.getPropertyValue("--parallax-scale") || 1.3),
    [scale, translate] = [getScale, 0.15 * 100 / getScale],
    isFirstSection = this.closest(".hdt-section")?.matches(":first-child");
    scroll(
      animate(getterGet(_img_effect, this), { transform: [`scale(${scale}) translateY(-${translate}%)`, `scale(${scale}) translateY(${translate}%)`] }, { ease: "linear" }),
      {
        target: getterGet(_img_effect, this),
        offset: [isFirstSection ? "start start" : "start end", "end start"]
      }
    );
  }

};
customElements.define("hdt-effect-img", ImageBehavior);

/**
* 3. Image with text
* -----------------------------------------------------------------------------
*/
var _image_with_text_inView = new WeakSet(), image_with_text_inView_fn;
class ImageWithText extends HTMLElement {
  constructor() {
    super();
    getterAdd(_image_with_text_inView, this);
  }
  connectedCallback() {
    if (matchMediaQuery("motion") && this.hasAttribute('reveal-on-scroll') ) inView(this, getterRunFn(_image_with_text_inView, this, image_with_text_inView_fn).bind(this), { margin: "-50px 0px" });
  }
  get revealStr() {
    return '[reveal], [can-reveal]';
  }
};
image_with_text_inView_fn = async function(){
  const sequence = []
  const media = $4('.hdt-media-wrapper[reveal-invisible]', this);
  if (media) sequence.push([media, { visibility: ["hidden", "visible"], clipPath: [aniClipPath[this.getAttribute('ani-img')], "inset(0 -1px 0 0)"] }, { duration: 1.85, ease: [0.25,1,0.5,1] }]);
  sequence.push([
    getArrVisible($$4(this.revealStr, this)),
    { opacity: [0, 1], transform: animationContent[this.getAttribute('ani') || 'ani1'] },
    {
      duration: 1,
      delay: stagger(0.1, { startDelay: 0.4, ease: [0.25, 0.1, 0.25, 1.0]} ),
      transform: { ease: [0, 0.87, 0.58, 1], duration: 0.6 },
      ...(media && { at: "<" }) // add at: "<" if media is exists
    }
  ]);
  animate(sequence);
};
class MediaOverlay extends ImageWithText {};
customElements.define('hdt-image-with-text', ImageWithText);
customElements.define('hdt-media-overlay', MediaOverlay);

/**
* 4. Marquee
* -----------------------------------------------------------------------------
* https://github.com/ezekielaquino/Marquee3000/tree/master
* https://stackoverflow.com/questions/71165923/how-do-i-make-an-infinite-marquee-with-js
* https://stackoverflow.com/questions/337330/javascript-marquee-to-replace-marquee-tags
*/
// var _marquee_old_width = new WeakMap(),
// _marquee_animation = new WeakMap(),
// _marquee_create_content = new WeakSet(), marquee_create_content_fn,
// _marquee_destroy_content = new WeakSet(), marquee_destroy_content_fn,
// _marquee_enter = new WeakSet(), marquee_enter_fn,
// _marquee_leave = new WeakSet(), marquee_leave_fn;
// class Marquee extends HTMLElement {
//   constructor() {
//     super();
//     this.classes = {
//       enabled  : 'hdt-marquee--enabled',
//       duplicate: 'hdt-marquee--duplicate'
//     };
//     getterAdd(_marquee_old_width, this, 0);
//     getterAdd(_marquee_animation, this, void 0);
//     getterAdd(_marquee_create_content, this);
//     getterAdd(_marquee_destroy_content, this);
//     getterAdd(_marquee_enter, this);
//     getterAdd(_marquee_leave, this);
//     this.attachShadow({ mode: "open" }).appendChild(document.createRange().createContextualFragment("<slot part='wrapper'></slot>"));
//     this.init();
//     let resizeObserver = new ResizeObserver(entries => this.init());
//     resizeObserver.observe(this);
//     this.addEventListener('unobserve', (e)=> {
//       //console.log(e.composed,e.bubbles,e.cancelable);
//       resizeObserver.unobserve(this); resizeObserver = null });

//     if (matchMediaQuery("motion")) {
//       inView(this, (info) => {

//         getterGet(_marquee_animation, this)?.play();
//         this.isInview = true;
//         // console.log('play')
//         return (leaveInfo) =>  {
//           getterGet(_marquee_animation, this)?.pause();
//           this.isInview = false;
//           //console.log('pause')
//         }
//       }, { margin: "250px" })

//       // listen for visibility change event
//       visibilitychangeFn({
//         observes: this,
//         play: getterGet(_marquee_animation, this)?.play(),
//         pause: getterGet(_marquee_animation, this)?.pause()
//       });
//     }
//   }
//   connectedCallback() {
//     if (Shopify.designMode) this.init();
//   }
//   disconnectedCallback() {
//     this.removeEventListener("mouseenter", getterRunFn(_marquee_enter, this, marquee_enter_fn).bind(this));
//     this.removeEventListener("touchstart", getterRunFn(_marquee_enter, this, marquee_enter_fn).bind(this));
//     this.dispatchEvent(new CustomEvent("unobserve"));
//   }
//   init() {
//     if (this.clientWidth < getterGet(_marquee_old_width, this) ) return;
//     getterAdd(_marquee_old_width, this, this.clientWidth, true);
//     getterRunFn(_marquee_destroy_content, this, marquee_destroy_content_fn).call(this);
//     getterRunFn(_marquee_create_content, this, marquee_create_content_fn).call(this);
//   }
//   get wrapper() {
//     return this.shadowRoot.querySelector('[part="wrapper"]');
//   }
// };
// marquee_create_content_fn = function(){
//   let multiply = Math.max((Math.ceil(this.clientWidth / this.firstElementChild.offsetWidth)+1), 2),
//   clone,
//   i;
//   // calc speed
//   // https://stackoverflow.com/questions/38118002/css-marquee-speed
//   // By dividing the width by a certain value (100 in the example), we can adjust the speed of the "marquee" effect

//   // Duplicate content at least once
//   const frag = document.createDocumentFragment();
//   for (i = 0; i < multiply; i++) {
//     clone = this.firstElementChild.cloneNode(true);
//     clone.setAttribute('aria-hidden',true);
//     clone.classList.add(this.classes.duplicate);
//     clone.style.setProperty('--index', i + 1);
//     frag.appendChild(clone);
//   }
//   this.append(frag);

//   // Add holder init class
//   this.classList.add(this.classes.enabled);

//   if (matchMediaQuery("motion")) {
//     getterAdd(
//       _marquee_animation, this,
//       animate(this.wrapper, { transform: ["translateX(0)", `translateX(calc(var(--value-logical-flip) * var(--dir-logical) * 100%))`] }, {
//         duration: 1 / parseFloat(this.getAttribute("speed") || 0.4) * (this.wrapper.clientWidth / 350),
//         ease: "linear",
//         repeat: Infinity
//       })
//     , true);
//     //getterGet(_marquee_animation, this)?.pause();
//     if (this.hasAttribute('pausable')) {
//       this.addEventListener("mouseenter", getterRunFn(_marquee_enter, this, marquee_enter_fn).bind(this));
//       this.addEventListener("touchstart", getterRunFn(_marquee_enter, this, marquee_enter_fn).bind(this));
//     }
//   }
// }
// marquee_destroy_content_fn = function(){
//   // Remove holder init class
//   this.classList.remove(this.classes.enabled);
//   // Remove duplicated content
//   const boxes = $$4('.'+this.classes.duplicate, this);
//   if (boxes.length) boxes.forEach(e => e.remove() );
// }
// marquee_enter_fn = function(){
//   getterGet(_marquee_animation, this)?.pause();
//   this.addEventListener("mouseleave", getterRunFn(_marquee_leave, this, marquee_leave_fn).bind(this));
//   this.addEventListener("touchend", getterRunFn(_marquee_leave, this, marquee_leave_fn).bind(this));
// }
// marquee_leave_fn = function(){
//   getterGet(_marquee_animation, this)?.play();
//   this.removeEventListener("mouseleave", getterRunFn(_marquee_leave, this, marquee_leave_fn).bind(this));
//   this.removeEventListener("touchend", getterRunFn(_marquee_leave, this, marquee_leave_fn).bind(this));
// }
class Marquee extends HTMLElement {
 #resizeObserver;
  constructor() {
    super();
    const rawDirection = this.getAttribute('direction') || 'ltr';
    this._speed = 300 * parseFloat(this.getAttribute('speed-factor') || 0.4); // Move 300px/s
    this._direction = isRTL ? rawDirection === 'ltr' ? 'rtl' : 'ltr' : rawDirection;
    this._animation = null;
    this.#resizeObserver = null,
    this._lastWidth = 0;
  }

  connectedCallback() {
    this._inner = $4('.hdt-marquee-inner', this);
    //console.log(this)
    if (!this._inner) {
      let _originalItem = $4('.hdt-marquee-item', this);
      this.innerHTML = '';
      this._inner = document.createElement('div');
      this._inner.className = 'hdt-marquee-inner';
      this.appendChild(this._inner);
      this._inner.appendChild(_originalItem.cloneNode(true));
    }

    this._setup();
    this.#resizeObserver = resize(this, this._setup.bind(this));
    // this.#resizeObserver = new ResizeObserver(this._setup.bind(this));
    // this.#resizeObserver.observe(this);
    //window.addEventListener('resize', this._setup.bind(this));
    // Hover pause
    if (this.hasAttribute('pausable') && matchMediaQuery("motion")) {
      this.addEventListener('mouseenter', () => this._animation?.pause());
      this.addEventListener('mouseleave', () => this._animation?.play());
    }
  }

  disconnectedCallback() {
    this._lastWidth = 0;
    this._animation?.cancel();
    //window.removeEventListener('resize', this._setup);
    if (this.#resizeObserver) this.#resizeObserver();
  }

  _setup() {
    let firstWidth = this._inner.firstElementChild.offsetWidth;
    if (firstWidth === 0 || this._lastWidth == firstWidth) return;
    this._lastWidth = firstWidth;
    $$4('.hdt-marquee--duplicate', this).forEach(e => e.remove() );
    //this._inner.innerHTML = '';
    //console.log(this._inner?.firstElementChild)
    const clonesNeeded = Math.ceil((this.offsetWidth * 3) / firstWidth);

    const frag = document.createDocumentFragment();
    let i;
    let clone;
    for (i = 0; i < clonesNeeded; i++) {
      clone = this._inner.firstElementChild.cloneNode(true);
      clone.setAttribute('aria-hidden',true);
      clone.classList.add('hdt-marquee--duplicate');
      frag.appendChild(clone);
    }
    this._inner.append(frag);
    clone = null;

    if (!matchMediaQuery("motion")) return;

    const moveDistance = this._inner.scrollWidth / 3;
    const duration = moveDistance / this._speed; // seconds
    //console.log(duration)

    const from = this._direction === 'rtl' ? '0px' : `-${moveDistance}px`;
    const to = this._direction === 'rtl' ? `-${moveDistance}px` : '0px';
    //console.log(from, to, this._direction)

    this._animation?.stop();
    this._animation = animate(this._inner, {
      transform: [`translateX(${from}) translateZ(0)`, `translateX(${to}) translateZ(0)`]
    }, {
      duration: duration,
      ease: 'linear',
      repeat: Infinity
    });
  }
}

customElements.define('hdt-marquee', Marquee);
/**
* 5. Countdown timer
* -----------------------------------------------------------------------------
*/

const countdown = {
  selectors: {
    "days": "[is='days']",
    "hours": "[is='hours']",
    "minutes": "[is='minutes']",
    "seconds": "[is='seconds']"
  },
  classes: {
    "enabled": "hdt-cd--enabled",
    "hide": "hdt-cd--hide",
    "complete": "hdt-cd--complete"
  },
  defaults: {
    "idTmp": null,
    "hasZero": true,
    "actionElapsed": 'zero'
  }
};
var _ending_date = new WeakMap(),
_timer_frame = new WeakMap(), _timer_playing = new WeakMap(),
_timer_loop = new WeakSet(), timer_loop_fn,
_timer_play = new WeakSet(), timer_play_fn,
_timer_pause = new WeakSet(), timer_pause_fn,
_timer_destroy = new WeakSet(), timer_destroy_fn,
_timer_in_view = new WeakMap(), _timer_doc_hidden = new WeakMap(),
_timer_options = new WeakMap(),
_timer_days_el = new WeakMap(), _timer_hours_el = new WeakMap(), _timer_minutes_el = new WeakMap(), _timer_seconds_el = new WeakMap();
const { daysMax } = themeHDN.settings;
class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    getterAdd(_timer_loop, this);
    getterAdd(_timer_play, this);
    getterAdd(_timer_pause, this);
    getterAdd(_timer_destroy, this);
    getterAdd(_timer_playing, this, false);
    getterAdd(_timer_in_view, this, false);
    getterAdd(_timer_doc_hidden, this, false);

    getterAdd(_timer_options, this, Object.assign({}, countdown.defaults,  JSON.parse(this.getAttribute('config') || '{}')));
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#date_time_string_format
    // YYYY-MM-DDTHH:mm:ssZ
    //const endingDate = new Date('2024-08-05T00:00:00-04:00');
    const endingDate = new Date(getterGet(_timer_options, this).datetime+(themeHDN.settings.shopTimezone || ""));
    //console.log(endingDate)
    if (isNaN(endingDate)) return;
    getterAdd(_ending_date, this, endingDate);

    if (getterGet(_timer_options, this).idTmp) {
      const idTmp = $id4(getterGet(_timer_options, this).idTmp);
      if (idTmp) this.innerHTML = idTmp.innerHTML;
    }

    getterAdd(_timer_days_el, this, $4(countdown.selectors.days,this));
    getterAdd(_timer_hours_el, this, $4(countdown.selectors.hours,this));
    getterAdd(_timer_minutes_el, this, $4(countdown.selectors.minutes,this));
    getterAdd(_timer_seconds_el, this, $4(countdown.selectors.seconds,this));
    if (this.daysEl) {
      this.daysEl.isDay = true;
      this.daysEl.max = daysMax;
    } else {
      this.hrsEl.isHour = true;
      //this.hrsEl.max = 24 * daysMax;
      this.hrsEl.max = daysMax == 99 ? 99 : 24 * daysMax;
    }

    // int
    // console.log(!getterGet(_timer_frame, this))
    if (!getterGet(_timer_frame, this)) this.classList.add(countdown.classes.enabled);
    getterRunFn(_timer_play, this, timer_play_fn).call(this);

    inView(this, () => {
       getterAdd(_timer_in_view, this, true, true);
      this.isInview = true;
      return () =>  {
       getterAdd(_timer_in_view, this, false, true);
      }
    }, { margin: "444px" });

    // Listen for visibility change event
    document.addEventListener("visibilitychange", () => getterAdd(_timer_doc_hidden, this, document.hidden, true));
  }
  connectedCallback() {
    // Fixed
  }
  disconnectedCallback() {
    //getterRunFn(_timer_destroy, this, timer_destroy_fn).call(this);
    if (typeof _timer_destroy !== 'undefined' && typeof timer_destroy_fn === 'function') {
      try {
        getterRunFn(_timer_destroy, this, timer_destroy_fn).call(this);
      } catch (e) {
        console.warn("Timer cleanup failed", e);
      }
    }
  }
  get daysEl() {
    return getterGet(_timer_days_el, this);
  }
  get hrsEl() {
    return getterGet(_timer_hours_el, this);
  }
};
timer_loop_fn = function(){
  const { actionElapsed, hasZero } = getterGet(_timer_options, this);
  // Get today's date and time
  const nowDate = new Date();
  if (getterGet(_ending_date, this) < nowDate) {
    getterRunFn(_timer_destroy, this, timer_destroy_fn).call(this);

    // If the count down is finished, write some text
    // actionElapsed: hide, hide_cd_show_mess, zero
    this.classList.add(countdown.classes.complete);
    if (actionElapsed == 'hide') {
      const hideEl = this.classList.contains('hide-cd-elapsed') ? this : this.closest('.hide-cd-elapsed');
      if (Shopify.designMode) {
        hideEl?.setAttribute('hidden', '');
      } else {
        hideEl?.remove();
      }
    } else {
      if (actionElapsed == 'hide_cd_show_mess') {
        this.style.opacity = 0;
        this.nextElementSibling?.removeAttribute('hidden');
      }
      return clearInterval(getterGet(_timer_frame, this));
    }
  }

  if (!getterGet(_timer_in_view, this) || getterGet(_timer_doc_hidden, this)) return;

  let diff = Math.abs((getterGet(_ending_date, this).getTime() - nowDate.getTime()) / 1e3);  // Time calculations for days, hours, minutes and seconds

  const totalHours  = Math.floor(diff / 3600);
  const days        = Math.floor(diff / 86400);
        diff       -= days * 86400;
  let   hours       = Math.floor(diff / 3600);
        diff       -= hours * 3600;
  const minutes     = Math.floor(diff / 60);
        diff       -= minutes * 60;
  const seconds     = Math.floor(diff);

  //if (!this.daysEl) hours = totalHours;
  //console.log(hours)
  if (this.daysEl) {
    this.daysEl.updateAttr(days, hasZero);
  } else {
    hours = Math.min(totalHours, this.hrsEl.max); // Limit hours to this.hrsEl.max
  }
  this.hrsEl?.updateAttr(hours, hasZero);
  getterGet(_timer_minutes_el, this)?.updateAttr(minutes, hasZero);
  getterGet(_timer_seconds_el, this)?.updateAttr(seconds, hasZero);
};
timer_play_fn = function(){
  if (getterGet(_timer_playing,this)) return;
  //console.log('play')
  getterAdd(_timer_frame, this, setInterval(getterRunFn(_timer_loop, this, timer_loop_fn).bind(this), 1e3), true);
  getterRunFn(_timer_loop, this, timer_loop_fn).call(this); // Run first when load site
  getterAdd(_timer_playing, this, true, true);
};
timer_pause_fn = function(){
  if (!getterGet(_timer_playing, this)) return;
  //console.log('pause')
  //this.timerInterval && clearInterval(this.timerInterval);
  clearInterval(getterGet(_timer_frame, this));
  getterAdd(_timer_playing, this, false, true);
};
timer_destroy_fn = function(){
  this.classList.remove(countdown.classes.enabled);
  getterRunFn(_timer_pause, this, timer_pause_fn).call(this);
};

var _numlist = new WeakMap();
class CountdownTimeItem extends HTMLElement {
  static observedAttributes = ["numbers"];
  #hasZero = true;
  constructor() {
    super();
  }
  get #max() {
    return this.max || 99;
  }
  get #padded() {
    return this.padded ??= this.isDay ? 3 : this.isHour ? 5 : 2;
  }
  updateAttr(newValue, hasZero) {
    if (this.getAttribute('numbers') == newValue ) return;
    this.#hasZero = hasZero;
    this.setAttribute('numbers', newValue);
  }
  async attributeChangedCallback(name, oldValue, newValue) {
     //console.log('1', oldValue, newValue)
    if (oldValue === newValue) return;

    let num = String(Math.min(this.#max, newValue)),
    numPad = num.padStart(this.#padded, "0");
    if (this.max && (this.isDay || this.isHour)) this.setAttribute('show-el', num.length);
    [...numPad].forEach((num, index) => {
      this.firstElementChild.children[index].setAttribute("num", num);
      //this.children[index].textContent = num;
    });
    // Update Unit
    if (this.childElementCount > 1 && this.lastElementChild.shadowRoot) {
      this.lastElementChild.setAttribute("numbers", numPad);
    }
    // End Update Unit
    //console.log(this.#hasZero, !this.#hasZero)
    if (!this.#hasZero) this.firstElementChild.children[this.isDay ? 1 : this.isHour ? 3 : 0].style.display = (numPad < 10 ) ? 'none' : 'inline-block';
  }
};
class CountdownTimerNumber extends HTMLElement {
  static observedAttributes = ["num"];
  constructor() {
    super();
    let tmp = '', i, limit = parseInt(this.getAttribute('limit')) || 10;
    for (i = 1; i < limit; i++) { tmp += `<span part="num" style="opacity: 0">${i}</span>`; }
    this.attachShadow({ mode: "open" }).appendChild(document.createRange().createContextualFragment(`<span part="numlist"><span part="num">0</span>${tmp}</span>`));
    tmp = ''; // remove cache

    getterAdd(_numlist, this, this.shadowRoot.firstElementChild);
  }
  async attributeChangedCallback(name, oldValue, newValue) {
    //console.log(oldValue, newValue, this)
    if (oldValue == null || oldValue === newValue) return;
    animate(getterGet(_numlist, this).children[parseInt(oldValue)], { opacity: [1, 0], transform: ["translateY(0) scale(1)", "translateY(-100%) scale(.3)"] }, { duration: this.hasAttribute('eff') ? 0.3 : 0, ease: [0.25, 0.1, 0.25, 1.0] }); // .34,.78,.45,.98
    animate(getterGet(_numlist, this).children[parseInt(newValue)], { opacity: [0, 1], transform: ["translateY(100%) scale(.5)", "translateY(0) scale(1)"] }, { duration: this.hasAttribute('eff') ? 0.3 : 0, ease: [0.25, 0.1, 0.25, 1.0] }); // .34,.78,.45,.98
  }
};
// plural singular
class CountdownTimerText extends HTMLElement {
  static observedAttributes = ["numbers"];
  constructor() {
    super();
    if (!this.hasAttribute('singular')) return;
    this.attachShadow({ mode: "open" });
    let i = 0;
    let textHtml = "";
    for (; i < 2; i++) {
      textHtml += `<span part="unit" style="grid-area: 1 / -1; will-change: opacity; opacity: ${ i ? 0 : 1 };">${ i ? this.getAttribute('singular') : this.textContent }</span>`;
    }
    this.shadowRoot.appendChild(document.createRange().createContextualFragment(textHtml));
  }
  async attributeChangedCallback(name, oldValue, newValue) {
    // if (oldValue === null || oldValue === newValue) {
    //   return;
    // }
    if (oldValue === newValue) return;
    this.shadowRoot.children[0].style.opacity = (newValue > 1) ? 1 : 0;
    this.shadowRoot.children[1].style.opacity = (newValue < 2) ? 1 : 0;
  }
};

customElements.define('hdt-countdown-text', CountdownTimerText);
customElements.define('hdt-countdown-number', CountdownTimerNumber);
customElements.define('hdt-countdown-item', CountdownTimeItem);
customElements.define('hdt-countdown', CountdownTimer);


/**
* 6. Multimedia player
* -----------------------------------------------------------------------------
*/
class MediaManager extends HTMLElement {
  #controller;
  constructor() {
    super();
    this.isPlayingState = false;
    this.type = this.getAttribute('type');
  }

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.media = $4('video, iframe', this);
    if (this.type === "html5") {
      this.dispatchEvent(new CustomEvent('media:ready'));
      if (this.hasAttribute('duration')) this.media.addEventListener("loadedmetadata", () => this.#duration = this.media.duration);
      this.media.addEventListener("play", () => this.#setPlaying(true), { signal });
      this.media.addEventListener("pause", () => this.#setPlaying(false), { signal });
      this.media.addEventListener("ended", () => this.#setPlaying(false), { signal });
    } else if (this.type === "youtube" ) {
      this.media.addEventListener("load", () => this.media.contentWindow.postMessage(JSON.stringify({ event: "listening", id: this.dataset.id }), "*"), { once: true, signal });
    }

    //document.addEventListener(ThemeEvents.mediaStartedPlaying, this.pause.bind(this), { signal });
    document.addEventListener(dialogClose, this.pause.bind(this), { signal });

    if (!this.hasAttribute('media-group')) return;
    document.addEventListener('shopify_xr_launch', this.pause.bind(this), { signal });
    this.addEventListener('media:hidden', this.pause.bind(this), { signal });
    if (this.hasAttribute('autoplay')) this.addEventListener('media:visible', this.play.bind(this), { signal });
  }
  disconnectedCallback() {
    this.#controller.abort();
  }
  #setPlaying(state) {
    this.isPlayingState = state;
    if (state) {
      this.setAttribute("playing", "");
      if (this.hasAttribute('media-group')) this.dispatchEvent(new MediaStartedPlayingEvent(this));
      //if (this.hasAttribute('media-group') && !this.closest('hdt-slider-media')?.isActive) this.dispatchEvent(new MediaStartedPlayingEvent(this));
    } else {
      this.removeAttribute("playing");
    }
  }

  #postMessage(msg) {
    this.media?.contentWindow?.postMessage(msg, "*");
  }

  onMessage(data) {
    const { event } = data;
    if (this.type === "youtube") {
      //console.log('Youtube message event: ', event, data)
      //if ( data.id != this.dataset.id) return; // pick only messages for this instance
      if (event === "initialDelivery") {
        if (this.hasAttribute('duration')) this.#duration = data.info.duration;
        this.dispatchEvent(new CustomEvent('media:ready'));
      } else if (event === "infoDelivery" && data.info && "playerState" in data.info) {
        //console.log('duration: ', data.info, data.info.duration)
        switch (data.info.playerState) {
          case 1:
            this.#setPlaying(true); break;   // PLAYING
          case 2:
          case 0:
            this.#setPlaying(false); break;// PAUSED or ENDED
        }
      }
    } else {
      //if ( data.player_id != this.dataset.id) return; // pick only messages for this instance
      //console.log('Vimeo message event: ', event, data)
      switch (event) {
        case "ready":
          ["play", "pause", "ended"].forEach(value => {
            this.media.contentWindow.postMessage({ method: "addEventListener", value }, "*");
          });
          this.dispatchEvent(new CustomEvent('media:ready'));
          //console.log('Vimeo ready');
          if (this.hasAttribute('duration')) this.#postMessage({ method: "getDuration" });
          break;
        case "play":
          this.#setPlaying(true); break;
        case "pause":
        case "ended":
          this.#setPlaying(false); break;
        default:
          // if (data.method === 'play' && !this.hasAttribute('playing')) {
          //   this.#setPlaying(true);
          // } else
          if (data.method === 'getDuration' && typeof data.value === 'number') {
            this.#duration = data.value;
          }
      }
    }
  }

  #stringJson(func) {
    return JSON.stringify({ event: "command", func, args: [] });
  }

  async play() {
    if (this.isPlayingState) return false;
    if (this.type === "html5") {
      this.media.play();
    } else if (this.type === "vimeo") {
      this.#postMessage({ method: "play" });
    } else if (this.type === "youtube") {
      this.#postMessage(this.#stringJson("playVideo"));
    }
    return new Promise((resolve) => {
      let count = 0;
      const checkPlay = () => {
          count++;
          //console.log('checkPlay '+ this.type + ': ', this.hasAttribute('playing'))
          if (this.hasAttribute('playing')) {
            this.#setPlaying(true);
            resolve(true);
          } else if (count > 15) { // 1.5s
            this.#setPlaying(false);
            resolve(false);
          } else {
            setTimeout(checkPlay, 100);
          }
      };
      checkPlay();
    });
  }

  pause() {
    if (!this.isPlayingState) return
    if (this.type === "html5") {
      this.media.pause();
    } else if (this.type === "vimeo") {
      this.#postMessage({ method: "pause" });
    } else if (this.type === "youtube") {
      this.#postMessage(this.#stringJson("pauseVideo"));
    }
    this.#setPlaying(false);
  }

  isPlaying() {
    //if (this.type === "html5") return !(this.media.paused || this.media.ended);
    return this.isPlayingState;
  }

  /**
   * @param {number} second
   */
  set #duration(second) {
    this.style.setProperty('--hdt-media-duration', `${second * 1000}ms`);
  }
}
window.addEventListener("message", (evt) => {
  //console.log(evt)
  if (evt.data && (evt.origin.includes('www.youtube') || evt.origin.includes('vimeo.com')) ) {
    let data;
    try { data = typeof evt.data === "string" ? JSON.parse(evt.data) : evt.data; } catch { return; }
    $4(`hdt-video[data-id="${data.player_id || data.id}"]`)?.onMessage(data);
  }
});

// Video, YouTube, Vimeo
var _size_bg_video = new WeakSet(), size_bg_video_fn,
_setup_play_btn = new WeakSet(), setup_play_btn_fn;
class VideoPlayer extends MediaManager {
  #controller;
  constructor() {
    super();
    getterAdd(_size_bg_video, this);
    getterAdd(_setup_play_btn, this);
  }
  async connectedCallback () {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    const tmp = $4("template", this);
    tmp?.replaceWith(tmp.content.firstElementChild.cloneNode(true));
    if (this.hasAttribute('background')) {
      getterRunFn(_size_bg_video, this, size_bg_video_fn).call(this);
      // Listen to resize to keep a background-size:cover-like layout
      window.addEventListener('resize', debounce(getterRunFn(_size_bg_video, this, size_bg_video_fn).bind(this), 300), { signal });
    }
    if (this.type === 'html5') inView(this, () => this.media?.setAttribute("preload", "metadata"), { margin: "666px" });
    if (this.hasAttribute('autoplay')) {
      if (this.hasAttribute('media-group')) {
        this.#autoPlay(true);
      } else {
        this.addEventListener("media:ready", () => this.#autoPlay(), { once: true, signal });
      }
    }
    super.connectedCallback();
  };
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller.abort();
  }
  // #waitForIframeLoad(iframe, signal) {
  //   return new Promise((resolve) => {
  //     if (iframe.contentWindow && iframe.contentDocument?.readyState === "complete") {
  //       resolve();
  //     } else {
  //       iframe.addEventListener("load", () => resolve(), { once: true, signal });
  //     }
  //   });
  // }
  #autoPlay(group = false) {
    if (group) {
      this.slider.addEventListener('reInit', ()=> {
        if (this.slider.isActive) {
          if (this.slider.apiS.selectedScrollSnap() === 0 && this.closest('.hdt-product__media-item').classList.contains('is-selected')) {
            this.playHandle();
          }
        } else {
          inView(this, () => {
              this.playHandle();
              return () => this.pause();
            },
            { margin: "15px 0px" }
          )
        }
      }, { once: false});
    } else if (this.hasAttribute('notInView')) {
      this.playHandle();
    } else {
      inView(this, () => {
          this.playHandle();
          return () => {
            this.pause();
          }
        },
        { margin: '888px' }
      )
    }
  }
  async playHandle() {
    this.play().then((canPlay) => {
      if (!canPlay) {
        // console.log('Autoplay blocked: ', this.type, canPlay);
        if (this.hasAttribute("show-controls") && !this.hasAttribute("has-controls")) getterRunFn(_setup_play_btn, this, setup_play_btn_fn).call(this);
      } else {
        // console.log('Autoplay allowed: ', this.type, canPlay);
      }
    }).catch(() => {
      // console.log('Autoplay blocked catch: ', this.type);
      // throw new Error("Autoplay blocked: " + this.type);
    });
  }
  get slider () {
    return this._slider ??= this.closest('hdt-slider-media');
  }
};
size_bg_video_fn = function(){
  var iframeW  ,
  iframeH      ,
  marginLeft   ,
  marginTop    ,
  containerW   = this.clientWidth,
  containerH   = this.clientHeight;

  containerW / containerH < 16 / 9 ?
  (
     iframeW = containerH * (16 / 9),
     iframeH = containerH,
     marginLeft = -Math.round((iframeW - containerW) / 2),
     marginTop = -Math.round((iframeH - containerH) / 2)
  ) : (
     iframeH = (iframeW = containerW) * (9 / 16),
     marginTop = -Math.round((iframeH - containerH) / 2),
     marginLeft = -Math.round((iframeW - containerW) / 2)
  );
  $4("iframe", this).style.cssText = `max-width: 1000%; margin-left: ${marginLeft}px; margin-top: ${marginTop}px; width: ${iframeW}px; height: ${iframeH}px;`;
};
setup_play_btn_fn = function(){
  if (this.shadowRoot) return;
  const videoOrIframe = $4('video, iframe', this);
  this.attachShadow({ mode: "open" }).appendChild($id4("video-play-df").content.cloneNode(true));
  const btnPlay  = this.shadowRoot.lastElementChild,
        playText = btnPlay.getAttribute('aria-label'),
        des      = $4('video', this)?.getAttribute('aria-label') || videoOrIframe.title || videoOrIframe.dataset.title || '';
  btnPlay.setAttribute('aria-label', playText.replace('[description]', des));
  if (!this.hasAttribute("show-controls")) this.removeAttribute('ready');

  //console.log('1', this, this.closest('[data-wrapp-video]'))
  const elClick = this.hasAttribute('sp-toogle-play') ? btnPlay : this.closest('[data-wrapp-video]');
  elClick?.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (this.hasAttribute('playing')) {
      this.pause();
      btnPlay.setAttribute('aria-label', playText.replace('[description]', des));
    } else {
      this.play();
      btnPlay.setAttribute('aria-label', btnPlay.dataset.pause.replace('[description]', des));
    }
    this.setAttribute('ready', '');
  }, { once: !this.hasAttribute('sp-toogle-play'), signal: this.abortController.signal });
};
class ModelPlayer extends MediaManager {
  #controller;
  connectedCallback() {
    this.#controller = new AbortController();
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.#setupShopifyXr.bind(this)
      },
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: this.#setupModelViewerUI.bind(this),
      },
    ]);
    super.connectedCallback();
  }

  async play() {
    this.modelViewerUI?.play();
  }

  pause() {
    this.modelViewerUI?.pause();
  }
  #setupShopifyXr() {
    if (!window.ShopifyXR) return document.addEventListener('shopify_xr_initialized', this.#setupShopifyXr.bind(this), { once: true, signal: this.#controller.signal });
    const modelJson = $id4('ModelJson-' + this.getAttribute('section-id'));
    window.ShopifyXR.addModels(JSON.parse(modelJson.textContent));
    window.ShopifyXR.setupXRElements();
  }

  /**
   * @param {Error[]} errors
   */
  async #setupModelViewerUI(errors) {
    if (errors) return;

    if (!Shopify.ModelViewerUI) {
      await this.#waitForModelViewerUI();
    }

    if (!Shopify.ModelViewerUI) return;

    const model = $4("model-viewer", this);
    if (!model) return;

    const { signal } = this.#controller;

    this.modelViewerUI = new Shopify.ModelViewerUI(model, { focusOnPlay: false });
    if (!this.modelViewerUI) return;
    $4('.shopify-model-viewer-ui__button', this)?.setAttribute('inert', '');
    // Events: shopify_model_viewer_ui_toggle_play, shopify_model_viewer_ui_toggle_pause
    model.addEventListener("shopify_model_viewer_ui_toggle_play", () => this.setAttribute('playing', ''), { signal });
    model.addEventListener("shopify_model_viewer_ui_toggle_pause", () => this.removeAttribute('playing'), { signal });
    // return;
    // this.play();

    // // Track pointer events to detect taps
    // let pointerStartX = 0;
    // let pointerStartY = 0;

    // model.addEventListener('pointerdown',(/** @type {PointerEvent} */ event) => {
    //   pointerStartX = event.clientX;
    //   pointerStartY = event.clientY;
    // }, { signal });

    // model.addEventListener('click', (/** @type {PointerEvent} */ event) => {
    //   const distanceX = Math.abs(event.clientX - pointerStartX);
    //   const distanceY = Math.abs(event.clientY - pointerStartY);
    //   const totalDistance = Math.sqrt(distanceX * distanceX + distanceY * distanceY);

    //   // Try to ensure that this is a tap, not a drag.
    //   if (totalDistance < 10) {
    //     // When the model is paused, it has its own button overlay for playing the model again.
    //     // If we're receiving a click event, it means the model is playing, all we can do is pause it.
    //     this.pause();
    //   }
    // },{ signal });
  }

  /**
   * Waits for Shopify.ModelViewerUI to be defined.
   * This seems to be necessary for Safari since Shopify.ModelViewerUI is always undefined on the first try.
   * @returns {Promise<void>}
   */
  async #waitForModelViewerUI() {
    const maxAttempts = 10;
    const interval = 50;

    for (let i = 0; i < maxAttempts; i++) {
      if (Shopify.ModelViewerUI) {
        return;
      }
      await new Promise((resolve) => setTimeout(resolve, interval));
    }
  }
  // async createPlayer() {
  //   window.Shopify.loadFeatures([
  //     {
  //       name: 'shopify-xr',
  //       version: '1.0',
  //       onLoad: this.setupShopifyXr.bind(this)
  //     },
  //     {
  //       name: 'model-viewer-ui',
  //       version: '1.0',
  //       onLoad: this.setupModelViewerUi.bind(this)
  //     }
  //   ]);
  // }
  // setupShopifyXr() {
  //   if (!window.ShopifyXR) return document.addEventListener('shopify_xr_initialized', this.setupShopifyXr.bind(this), { once: true, signal: this.abortController.signal });
  //   const modelJson = $id4('ModelJson-' + this.getAttribute('section-id'));
  //   window.ShopifyXR.addModels(JSON.parse(modelJson.textContent));
  //   window.ShopifyXR.setupXRElements();
  //   //this.closest('hdt-slider-media')?.reInit()
  // }
  // setupModelViewerUi() {
  //   this.setAttribute('ready', '');
  //   const model = $4("model-viewer", this);
  //   // config: {
  //   //   controls: ["zoom-in", "zoom-out", "fullscreen"],
  //   //   iconUrl: "https://cdn.shopify.com/shopifycloud/model-viewer-ui/".concat("assets/v1.0/sprites.svg"),
  //   //   focusOnPlay: !0
  //   // }
  //   // Events: shopify_model_viewer_ui_toggle_play, shopify_model_viewer_ui_toggle_pause
  //   model.addEventListener("shopify_model_viewer_ui_toggle_play", () => this.setAttribute('playing', ''), { signal: this.abortController.signal });
  //   model.addEventListener("shopify_model_viewer_ui_toggle_pause", () => this.removeAttribute('playing'), { signal: this.abortController.signal });

  //   getterAdd(_media_player, this, new Shopify.ModelViewerUI(model, { focusOnPlay: false }));
  //   this.setAttribute('can-player', '');

  //   // https://shopify.dev/docs/storefronts/themes/product-merchandising/media/support-media#launch-the-display
  //   //document.addEventListener('shopify_xr_launch', ()=> {});

  //   // document.addEventListener('shopify_xr_launch', (event) => {
  //   //   if (this.playing) getterGet(_media_player, this).pause();
  //   // }, { signal: this.abortController.signal });
  // }

};
class BtnVideo extends HTMLElement {
  constructor() {
    super();
    const hdtVideo = this.closest('hdt-video');
    if (!hdtVideo) return;
    const btnPlay   = this.firstElementChild,
          des       = $4('video', hdtVideo)?.getAttribute('aria-label') || $4('iframe, video', hdtVideo).title || '',
          playText  = btnPlay.getAttribute('aria-label').replace('[description]', des),
          pauseText = btnPlay.dataset.pause.replace('[description]', des);

    btnPlay.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (hdtVideo.hasAttribute('playing')) {
        hdtVideo.pause();
        btnPlay.setAttribute('aria-label', playText);
      } else {
        hdtVideo.play();
        btnPlay.setAttribute('aria-label', pauseText);
      }
      hdtVideo.setAttribute('ready', '');
    });
  }
}
customElements.define('hdt-video', VideoPlayer);
customElements.define('hdt-model', ModelPlayer);
customElements.define('hdt-btn-video', BtnVideo);

class MediaProducts extends HTMLElement {
  connectedCallback(){
    if (!this.hasAttribute('reveal-on-scroll')) return;
    inView(this, () => {
      //console.log(this, enterInfo)
      animate($4('.hdt-full-width-image', this), {
        visibility: ["hidden", "visible"],
        zIndex: [0, 1],
        clipPath: ["circle(5% at 50% 50%)","circle(100% at 50% 50%)"]
      }, {
        duration: 1,
        ease: [0.87, 0, 0.13, 1]
      });
      //console.log('ss finished')
      animate($$4('.hdt-section__header > *, hdt-card-product[can-reveal]:nth-child(-n+4), .hdt-collection__view-all', this), {
        transform: ["translateY(2rem)", "translateY(0)"],
        opacity: [.01, 1]
      }, {
        duration: 0.6,
        delay: stagger(0.09, { startDelay: 0.6}),
        //ease: [0, 0, .3, 1]
      });
      // return (leaveInfo) => {
      //   console.log(this, leaveInfo, $4('.hdt-full-width-image', this))
      // }
    }, {
      margin: `-${matchMediaQuery("mobile") ? 20 : Math.min(this.clientHeight/2, 150)}px 0px`
    });
  }
};
customElements.define('hdt-media-with-products', MediaProducts);

class RichText extends HTMLElement {
  connectedCallback(){
    if (!this.hasAttribute('reveal-on-scroll')) return;
    inView(this, () => {
      animate(
          $$4('[can-reveal]', this),
          {
            opacity: [0, 1],
            y: [10, 0],
            filter: ["blur(10px)", "blur(0px)"],
          },
          {
            type: "spring",
            visualDuration: 0.4,
            bounce: 0,
            delay: stagger(0.08, { startDelay: 0.2 }),
            y: { type: "spring", visualDuration: 0.4, bounce: 0.8 },
            // onComplete: () => {
            //     elements.forEach(el => {
            //         el.style.willChange = ""
            //     })
            // }
          }
      )
    }, {
      margin: `-${matchMediaQuery("mobile") ? Math.min(50, this.clientHeight/2) : this.clientHeight/1.4}px 0px`
    });
  }
}
customElements.define('hdt-rich-text', RichText);

class Overlapping extends HTMLElement {
  #scroll;
  #resize;
  connectedCallback() {
    // this.#scroll = scroll(animate(this, { opacity: [0, 1, 1, 0], scale: [0.8, 1, 1, 0.8] }), {
    //     target: this,
    //     offset: ["start end", "center 70%", "center 30%", "end 20%"],
    // })
    const imageWrap = $id4(this.dataset.id);
    if (!imageWrap) return;
    this.#resize = resize(this, () => {
      if (this.clientHeight == 0) return;
      imageWrap.style.minHeight = null;
      frame.render(() => {
        const overheight = window.innerWidth >= 1024 && this.parentElement.clientHeight > imageWrap.clientHeight;
        imageWrap.classList.toggle('is-hdt-overheight', overheight);
        if (overheight) imageWrap.style.minHeight = `${this.parentElement.clientHeight}px`;
        if (this.#scroll) this.#scroll();
        if (overheight) return;
        this.#scroll = scroll(animate(this, { opacity: [0, 1, 1, 0], scale: [0.8, 1, 1, 0.8] }), {
            target: this,
            offset: ["start end", "center 70%", "center 30%", "end 20%"],
        });
      })
    })
  }
  disconnectedCallback() {
    if (this.clientHeight > 0) {
      this.#scroll();
      if (this.#resize) this.#resize();
    }
  }
}
customElements.define('hdt-overlapping', Overlapping);

!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(t="undefined"!=typeof globalThis?globalThis:t||self).SplitType=e()}(this,(function(){"use strict";function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function e(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}function n(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function r(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function o(t){for(var e=1;e<arguments.length;e++){var o=null!=arguments[e]?arguments[e]:{};e%2?r(Object(o),!0).forEach((function(e){n(t,e,o[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(o)):r(Object(o)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(o,e))}))}return t}function i(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){if("undefined"==typeof Symbol||!(Symbol.iterator in Object(t)))return;var n=[],r=!0,o=!1,i=void 0;try{for(var a,c=t[Symbol.iterator]();!(r=(a=c.next()).done)&&(n.push(a.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{r||null==c.return||c.return()}finally{if(o)throw i}}return n}(t,e)||c(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function a(t){return function(t){if(Array.isArray(t))return s(t)}(t)||function(t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(t))return Array.from(t)}(t)||c(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function c(t,e){if(t){if("string"==typeof t)return s(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);return"Object"===n&&t.constructor&&(n=t.constructor.name),"Map"===n||"Set"===n?Array.from(t):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?s(t,e):void 0}}function s(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,r=new Array(e);n<e;n++)r[n]=t[n];return r}function l(t,e){return Object.getOwnPropertyNames(Object(t)).reduce((function(n,r){var o=Object.getOwnPropertyDescriptor(Object(t),r),i=Object.getOwnPropertyDescriptor(Object(e),r);return Object.defineProperty(n,r,i||o)}),{})}function u(t){return"string"==typeof t}function f(t){return Array.isArray(t)}function p(){var t,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=l(e);return void 0!==n.types?t=n.types:void 0!==n.split&&(t=n.split),void 0!==t&&(n.types=(u(t)||f(t)?String(t):"").split(",").map((function(t){return String(t).trim()})).filter((function(t){return/((line)|(word)|(char))/i.test(t)}))),(n.absolute||n.position)&&(n.absolute=n.absolute||/absolute/.test(e.position)),n}function d(t){var e=u(t)||f(t)?String(t):"";return{none:!e,lines:/line/i.test(e),words:/word/i.test(e),chars:/char/i.test(e)}}function h(t){return null!==t&&"object"==typeof t}function y(t){return h(t)&&/^(1|3|11)$/.test(t.nodeType)}function g(t){return f(t)?t:null==t?[]:function(t){return h(t)&&function(t){return"number"==typeof t&&t>-1&&t%1==0}(t.length)}(t)?Array.prototype.slice.call(t):[t]}function v(t){var e=t;return u(t)&&(e=/^(#[a-z]\w+)$/.test(t.trim())?document.getElementById(t.trim().slice(1)):document.querySelectorAll(t)),g(e).reduce((function(t,e){return[].concat(a(t),a(g(e).filter(y)))}),[])}!function(){function t(){for(var t=arguments.length,e=0;e<t;e++){var n=e<0||arguments.length<=e?void 0:arguments[e];1===n.nodeType||11===n.nodeType?this.appendChild(n):this.appendChild(document.createTextNode(String(n)))}}function e(){for(;this.lastChild;)this.removeChild(this.lastChild);arguments.length&&this.append.apply(this,arguments)}function n(){for(var t=this.parentNode,e=arguments.length,n=new Array(e),r=0;r<e;r++)n[r]=arguments[r];var o=n.length;if(t)for(o||t.removeChild(this);o--;){var i=n[o];"object"!=typeof i?i=this.ownerDocument.createTextNode(i):i.parentNode&&i.parentNode.removeChild(i),o?t.insertBefore(this.previousSibling,i):t.replaceChild(i,this)}}"undefined"!=typeof Element&&(Element.prototype.append||(Element.prototype.append=t,DocumentFragment.prototype.append=t),Element.prototype.replaceChildren||(Element.prototype.replaceChildren=e,DocumentFragment.prototype.replaceChildren=e),Element.prototype.replaceWith||(Element.prototype.replaceWith=n,DocumentFragment.prototype.replaceWith=n))}();var m=Object.entries,b="_splittype",w={},O=0;function j(t,e,n){if(!h(t))return console.warn("[data.set] owner is not an object"),null;var r=t[b]||(t[b]=++O),i=w[r]||(w[r]={});return void 0===n?e&&Object.getPrototypeOf(e)===Object.prototype&&(w[r]=o(o({},i),e)):void 0!==e&&(i[e]=n),n}function C(t,e){var n=h(t)?t[b]:null,r=n&&w[n]||{};return void 0===e?r:r[e]}function E(t){var e=t&&t[b];e&&(delete t[e],delete w[e])}var S="\\ud800-\\udfff",x="\\u0300-\\u036f\\ufe20-\\ufe23",T="\\u20d0-\\u20f0",W="\\ufe0e\\ufe0f",k="[".concat(S,"]"),A="[".concat(x).concat(T,"]"),P="\\ud83c[\\udffb-\\udfff]",D="(?:".concat(A,"|").concat(P,")"),N="[^".concat(S,"]"),R="(?:\\ud83c[\\udde6-\\uddff]){2}",$="[\\ud800-\\udbff][\\udc00-\\udfff]",B="\\u200d",F="".concat(D,"?"),I="[".concat(W,"]?"),L=I+F+("(?:\\u200d(?:"+[N,R,$].join("|")+")"+I+F+")*"),H="(?:".concat(["".concat(N).concat(A,"?"),A,R,$,k].join("|"),"\n)"),M=RegExp("".concat(P,"(?=").concat(P,")|").concat(H).concat(L),"g"),z=RegExp("[".concat([B,S,x,T,W].join(""),"]"));function V(t){return z.test(t)}function q(t){return V(t)?function(t){return t.match(M)||[]}(t):function(t){return t.split("")}(t)}function U(t){return null==t?"":String(t)}function X(t,e){var n=document.createElement(t);return e?(Object.keys(e).forEach((function(t){var r=e[t],o=u(r)?r.trim():r;null!==o&&""!==o&&("children"===t?n.append.apply(n,a(g(o))):n.setAttribute(t,o))})),n):n}var Y={splitClass:"",lineClass:"line",wordClass:"word",charClass:"char",types:["lines","words","chars"],absolute:!1,tagName:"div"};function _(t,e){var n,r=d((e=l(Y,e)).types),o=e.tagName,i=t.nodeValue,c=document.createDocumentFragment(),s=[];return/^\s/.test(i)&&c.append(" "),n=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:" ";return(t?String(t):"").trim().replace(/\s+/g," ").split(e)}(i).reduce((function(t,n,i,l){var f,p;return r.chars&&(p=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"";return(t=U(t))&&u(t)&&!e&&V(t)?q(t):t.split(e)}(n).map((function(t){var n=X(o,{class:"".concat(e.splitClass," ").concat(e.charClass),style:"display: inline-block;",children:t});return j(n,"isChar",!0),s=[].concat(a(s),[n]),n}))),r.words||r.lines?(j(f=X(o,{class:"".concat(e.wordClass," ").concat(e.splitClass),style:"display: inline-block; ".concat(r.words&&e.absolute?"position: relative;":""),children:r.chars?p:n}),{isWord:!0,isWordStart:!0,isWordEnd:!0}),c.appendChild(f)):p.forEach((function(t){c.appendChild(t)})),i<l.length-1&&c.append(" "),r.words?t.concat(f):t}),[]),/\s$/.test(i)&&c.append(" "),t.replaceWith(c),{words:n,chars:s}}function G(t,e){var n=t.nodeType,r={words:[],chars:[]};if(!/(1|3|11)/.test(n))return r;if(3===n&&/\S/.test(t.nodeValue))return _(t,e);var o=g(t.childNodes);if(o.length&&(j(t,"isSplit",!0),!C(t).isRoot)){t.style.display="inline-block",t.style.position="relative";var i=t.nextSibling,c=t.previousSibling,s=t.textContent||"",l=i?i.textContent:" ",u=c?c.textContent:" ";j(t,{isWordEnd:/\s$/.test(s)||/^\s/.test(l),isWordStart:/^\s/.test(s)||/\s$/.test(u)})}return o.reduce((function(t,n){var r=G(n,e),o=r.words,i=r.chars;return{words:[].concat(a(t.words),a(o)),chars:[].concat(a(t.chars),a(i))}}),r)}function J(t){C(t).isWord?(E(t),t.replaceWith.apply(t,a(t.childNodes))):g(t.children).forEach((function(t){return J(t)}))}function K(t,e,n){var r,o,a,c=d(e.types),s=e.tagName,l=t.getElementsByTagName("*"),u=[],f=[],p=null,h=[],y=t.parentElement,v=t.nextElementSibling,m=document.createDocumentFragment(),b=window.getComputedStyle(t),w=b.textAlign,O=.2*parseFloat(b.fontSize);return e.absolute&&(a={left:t.offsetLeft,top:t.offsetTop,width:t.offsetWidth},o=t.offsetWidth,r=t.offsetHeight,j(t,{cssWidth:t.style.width,cssHeight:t.style.height})),g(l).forEach((function(r){var o=r.parentElement===t,a=function(t,e,n,r){if(!n.absolute)return{top:e?t.offsetTop:null};var o=t.offsetParent,a=i(r,2),c=a[0],s=a[1],l=0,u=0;if(o&&o!==document.body){var f=o.getBoundingClientRect();l=f.x+c,u=f.y+s}var p=t.getBoundingClientRect(),d=p.width,h=p.height,y=p.x;return{width:d,height:h,top:p.y+s-u,left:y+c-l}}(r,o,e,n),s=a.width,l=a.height,d=a.top,h=a.left;/^br$/i.test(r.nodeName)||(c.lines&&o&&((null===p||d-p>=O)&&(p=d,u.push(f=[])),f.push(r)),e.absolute&&j(r,{top:d,left:h,width:s,height:l}))})),y&&y.removeChild(t),c.lines&&(h=u.map((function(t){var n=X(s,{class:"".concat(e.splitClass," ").concat(e.lineClass),style:"display: block; text-align: ".concat(w,"; width: 100%;")});j(n,"isLine",!0);var r={height:0,top:1e4};return m.appendChild(n),t.forEach((function(t,e,o){var i=C(t),a=i.isWordEnd,c=i.top,s=i.height,l=o[e+1];r.height=Math.max(r.height,s),r.top=Math.min(r.top,c),n.appendChild(t),a&&C(l).isWordStart&&n.append(" ")})),e.absolute&&j(n,{height:r.height,top:r.top}),n})),c.words||J(m),t.replaceChildren(m)),e.absolute&&(t.style.width="".concat(t.style.width||o,"px"),t.style.height="".concat(r,"px"),g(l).forEach((function(t){var e=C(t),n=e.isLine,r=e.top,o=e.left,i=e.width,c=e.height,s=C(t.parentElement),l=!n&&s.isLine;t.style.top="".concat(l?r-s.top:r,"px"),t.style.left="".concat(n?a.left:o-(l?a.left:0),"px"),t.style.height="".concat(c,"px"),t.style.width="".concat(n?a.width:i,"px"),t.style.position="absolute"}))),y&&(v?y.insertBefore(t,v):y.appendChild(t)),h}var Q=l(Y,{});return function(){function t(e,n){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.isSplit=!1,this.settings=l(Q,p(n)),this.elements=v(e),this.split()}return e(t,null,[{key:"clearData",value:function(){Object.keys(w).forEach((function(t){delete w[t]}))}},{key:"setDefaults",value:function(t){return Q=l(Q,p(t)),Y}},{key:"revert",value:function(t){v(t).forEach((function(t){var e=C(t),n=e.isSplit,r=e.html,o=e.cssWidth,i=e.cssHeight;n&&(t.innerHTML=r,t.style.width=o||"",t.style.height=i||"",E(t))}))}},{key:"create",value:function(e,n){return new t(e,n)}},{key:"data",get:function(){return w}},{key:"defaults",get:function(){return Q},set:function(t){Q=l(Q,p(t))}}]),e(t,[{key:"split",value:function(t){var e=this;this.revert(),this.elements.forEach((function(t){j(t,"html",t.innerHTML)})),this.lines=[],this.words=[],this.chars=[];var n=[window.pageXOffset,window.pageYOffset];void 0!==t&&(this.settings=l(this.settings,p(t)));var r=d(this.settings.types);r.none||(this.elements.forEach((function(t){j(t,"isRoot",!0);var n=G(t,e.settings),r=n.words,o=n.chars;e.words=[].concat(a(e.words),a(r)),e.chars=[].concat(a(e.chars),a(o))})),this.elements.forEach((function(t){if(r.lines||e.settings.absolute){var o=K(t,e.settings,n);e.lines=[].concat(a(e.lines),a(o))}})),this.isSplit=!0,window.scrollTo(n[0],n[1]),m(w).forEach((function(t){var e=i(t,2),n=e[0],r=e[1],o=r.isRoot,a=r.isSplit;o&&a||(w[n]=null,delete w[n])})))}},{key:"revert",value:function(){this.isSplit&&(this.lines=null,this.words=null,this.chars=null,this.isSplit=!1),t.revert(this.elements)}}]),t}()}));
class MediaReadingText extends HTMLElement {
  #scroll;
  #spliter;
  #opacityStart;
  connectedCallback(){
    this.#opacityStart = parseFloat(this.style.getPropertyValue('--text-opacity-start'));
    if (this.#text) {
      this.#spliter = new SplitType(this.#text, {
        types: 'lines, words, chars',
        tagName: 'span',
        lineClass: 'hdt-split-line',
        wordClass: 'hdt-split-word',
        charClass: 'hdt-split-char',
        //splitClass: 'hdt-split-token'
      });
      this.#resize(false);
      resize(this, () => this.#resize());
    } else if (this.#btn) {
      const animation = animate(
        this.#btn,
        { opacity: [this.#opacityStart, 1], y: [8, 0] },
        { duration: 1, ease: "linear", type: "tween" }
      );
      this.#scroll = scroll(animation, { target: this, offset: [0, 0.8], });
    }
  }
  get #text() {
    return $4('.hdt-showcase-text', this);
  }
  get #btn() {
    return $4('.hdt-btn', this);
  }
  #resize(split = true) {
    frame.render(() => {
      //console.log('resize media reading text', split);
      if (split) {
        if (this.#scroll) this.#scroll();
        this.#text.removeAttribute('is-splited');
        this.#spliter.split();
      }
      this.#text.setAttribute('is-splited', '');

      const animation = animate(
        [...this.#spliter.chars, ...(this.#btn ? [this.#btn] : [])].map((char, i) => ([
          char,
          { opacity: [this.#opacityStart, 1], y: [8, 0] },
          { duration: 1, at: 0.1 * i, ease: "linear", type: "tween" }
        ])),
      );
      this.#scroll = scroll(animation, { target: this, offset: [0, 0.8], });
    });
  }
};
customElements.define('hdt-media-reading-text', MediaReadingText);
class ScrollHint extends HTMLElement {
  connectedCallback() {
    this.addEventListener('scroll', this.#update);
    this.#resizeObserver.observe(this);
  }

  disconnectedCallback() {
    this.removeEventListener('scroll', this.#update);
    this.#resizeObserver.disconnect();
  }

  #update = () => {
    const { scrollTop, scrollHeight, clientHeight, scrollLeft, scrollWidth, clientWidth } = this;
    const scrollDirection = scrollWidth > clientWidth ? 'horizontal' : 'vertical';
    const scrollPercentage = scrollDirection === 'vertical' ? scrollTop / (scrollHeight - clientHeight) : scrollLeft / (scrollWidth - clientWidth);
    this.style.maskImage = Number.isNaN(scrollPercentage) ? '' : `linear-gradient(to ${scrollDirection === 'vertical' ? 'bottom' : 'right'}, transparent ${scrollPercentage > 0 ? 1 : 0}%, black ${scrollPercentage < 0.1 ? scrollPercentage * 100 : 10}%, black ${scrollPercentage > 0.9 ? scrollPercentage * 100 : 90}%, transparent 100%)`;
  };

  #resizeObserver = new ResizeObserver(this.#update);
}
customElements.define('hdt-scroll-hint', ScrollHint);


class inviewStagger extends HTMLElement {
  connectedCallback() {
    if (!matchMediaQuery("motion") || !this.hasAttribute('ani')) return;
    inView(this, () => {
      animate($$4('.hdt-theme-block, .hdt-caption, .hdt-subheading, .hdt-heading, .hdt-description, .hdt-btn', this), {
        y: [20, 0],
        opacity: [0, 1]
      }, {
        duration: 0.6,
        delay: stagger(0.15, { startDelay: 0.2 }),
        //ease: [0, 0, .3, 1]
      }).then(() => {
        this.setAttribute('staggered', '');
      });
    }, {
      margin: "0px 0px -50px 0px"
    })
  }
}
customElements.define('hdt-inview-stagger', inviewStagger);

/**
* 7. Gallery modal
* -----------------------------------------------------------------------------
*/
import { Lightbox, Zoom } from "@theme/zoom-psw";
const svgPath = `<svg aria-hidden="true" viewBox="0 0 24 24" stroke="currentColor" stroke-width="0.8" fill="none" stroke-linecap="round" stroke-linejoin="round" class="pswp__icn"`;
var _img_lightbox = new WeakSet(), img_lightbox_fn,
_img_lightbox_list = new WeakMap();
class ImageLightbox extends HTMLElement {
  #controller;
  constructor() {
    super();
    getterAdd(_img_lightbox, this);
  }
  connectedCallback() {
    this.#controller = new AbortController();
    if (!this.dataset.objImg) return;
    getterRunFn(_img_lightbox, this, img_lightbox_fn).call(this);
    this.addEventListener("click", () => this.lightBox?.loadAndOpen(this.dataset.index || 0), { signal: this.#controller.signal });
  }
  disconnectedCallback() {
    this.#controller.abort();
  }
  get lightBox() {
    return getterGet(_img_lightbox_list, this);
  }
  // get objImg() {
  //   return this.getAttribute('obj-img');
  // }
};
img_lightbox_fn = function(){
  let dataSource = null,
   secondaryZoomLevel = parseInt(this.getAttribute("max-zoom")) || 2;
   const {close, zoom, prev, next, errorMsg} = themeHDN.strings.pswp,
    _objImg = JSON.parse(this.dataset.objImg);
    _objImg.srcset = renderSrcset(_objImg.src, JSON.parse(this.dataset.widths || `[246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1426, 1646, 1946, 2200, 2500, 3000, 3500, 4000, ${_objImg.width}]`));
     dataSource = [_objImg];
  const options = {
    showHideAnimationType: 'fade', // 'zoom', 'fade', 'none
    pswpModule: () => import("@theme/psw"),
    dataSource,
    bgOpacity: 1,
    secondaryZoomLevel,
    maxZoomLevel: ++secondaryZoomLevel,
    closeTitle: close,
    zoomTitle: zoom,
    arrowPrevTitle: prev,
    arrowNextTitle: next,
    errorMsg: errorMsg,
    // UX - https://photoswipe.com/styling/
    closeSVG: `${svgPath} width="28" height="28"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`,
    zoomSVG: `${svgPath} width="22" height="22"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line id="pswp__icn-plus" x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>`,
  };
  getterAdd(_img_lightbox_list, this, new Lightbox(options));
  this.lightBox.init();
  // Clear memory
  dataSource = null;
};

var _lightbox_psw_init = new WeakMap(),
_ui_register = new WeakSet(), ui_register_fn;
class GalleryModal extends HTMLElement {
  #controller;
  constructor() {
    super();
    getterAdd(_ui_register, this);
  }
  connectedCallback() {
    this.#controller = new AbortController();
    this.updateImageClick(true);
  }
  disconnectedCallback() {
    this.#controller.abort();
  }
  updateImageClick(firstTime = false) {
    if (this.images.length == 0 || this.hasAttribute('set-disabled') ) return;
    if (!firstTime) {
      getterDelete(_lightbox_psw_init, this);
      this.#controller.abort();
      this.#controller = new AbortController();
    }
    this.images.forEach( (image, index) => image.addEventListener('click', (e) => {
      if (this.imageZoom == 'zoom' && matchMediaQuery("hover")) return;
      e.preventDefault();
      this.openLightBox(index)
    }, { signal: this.#controller.signal }
    ));
  }
  get slider() {
    return $4('hdt-slider', this);
  }
  get images() {
    return $$4(this.getAttribute("selector") || "img", this)
  }
  get lightBox() {
    if (getterGet(_lightbox_psw_init, this)) return getterGet(_lightbox_psw_init, this);
    const {close, zoom, prev, next, errorMsg} = themeHDN.strings.pswp;

    let secondaryZoomLevel = parseInt(this.getAttribute("max-zoom")) || 2,
    dataSource = this.images.map((image) => {
      const {src, currentSrc, alt} = image;
      const srcset = renderSrcset(src, JSON.parse(image.dataset.widths || `[140, 246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1426, 1646, 1946, 2200, 2500, 3000, 3500, 4000, ${image.getAttribute("width")}]`));
      return {
        thumbnailElement: image,
        src,
        srcset,
        msrc: currentSrc || src,
        width: parseInt(image.getAttribute("width")),
        height: parseInt(image.getAttribute("height")),
        alt,
        thumbCropped: true
      };
    });
    getterAdd(_lightbox_psw_init, this, new Lightbox({
      pswpModule: () => import("@theme/psw"),
     // showHideAnimationType: 'zoom', // 'zoom', 'fade', 'none
      dataSource,
      bgOpacity: 1,
      secondaryZoomLevel,
      maxZoomLevel: ++secondaryZoomLevel,
      closeTitle: close,
      zoomTitle: zoom,
      arrowPrevTitle: prev,
      arrowNextTitle: next,
      errorMsg: errorMsg,
      // UX - https://photoswipe.com/styling/
      arrowPrevSVG: `${svgPath} width="24" height="24"><polyline points="15 18 9 12 15 6"></polyline></svg>`,
      arrowNextSVG: `${svgPath} width="24" height="24"><polyline points="9 18 15 12 9 6"></polyline></svg>`,
      closeSVG: `${svgPath} width="28" height="28"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`,
      zoomSVG: `${svgPath} width="22" height="22"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line id="pswp__icn-plus" x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>`,
    }));
    getterGet(_lightbox_psw_init, this).addFilter('thumbEl', (thumbEl, data) => thumbEl || data.thumbnailElement);
    getterGet(_lightbox_psw_init, this).on('uiRegister', getterRunFn(_ui_register, this, ui_register_fn).bind(this));
    getterGet(_lightbox_psw_init, this).on('openingAnimationEnd', ()=> getterGet(_lightbox_psw_init, this).pswp.template.classList.add('hdt-psw-animate'));
    getterGet(_lightbox_psw_init, this).on('closingAnimationStart', ()=> getterGet(_lightbox_psw_init, this).pswp.template.classList.remove('hdt-psw-animate'));
    getterGet(_lightbox_psw_init, this).init();
    // Clear memory
    dataSource = null;
    return getterGet(_lightbox_psw_init, this);
  }
  openLightBox(index = 0) {
    this.lightBox.loadAndOpen(index);
  }
};
ui_register_fn = function(){
  if (getterGet(_lightbox_psw_init, this).pswp.options.dataSource.length < 2 || !this.hasAttribute('show-thumb')) return;

  getterGet(_lightbox_psw_init, this).pswp.ui.registerElement({
    name: 'thumbnails',
    className: 'pswp__thumbnails',
    appendTo: 'root',
    //tagName: 'hdt-slider',
    onInit: (el, pswp) => {
      let prevIndex = -1,
      stringHTMl = '',
      i,
      l = pswp.getNumItems();

      for (i = 0; i < l; i++) {
        const { src, srcset, alt } = pswp.options.dataSource[i];
        stringHTMl += `<div class="hdt-slider__slide" can-reveal><div class="pswp__thumbnail" data-index="${i}"><img src="${src}" srcset="${srcset}" alt="${alt}" loading="lazy" sizes="70px"></div></div>`;
      }
      el.insertAdjacentHTML(
        'beforeend',
        `<hdt-slider-reveal reveal-on-scroll="true" class="hdt-slider" config='{"dragFree": true,"slidesToScroll": 1,"ntCenter": true}'><div class='hdt-slider__viewport'><div class='hdt-slider__container'>${stringHTMl}</div></div></hdt-slider-reveal>`,
      );
      stringHTMl = ''; //reset cache
      pswp.thumbs = $$4('.pswp__thumbnail', el);
      const mediaSelector = '.hdt-product__media-item[data-media-type="image"]:not([hidden])';

      pswp.on('change', () => {
        const {currIndex} = pswp;
        if (prevIndex >= 0) {
          pswp.thumbs[prevIndex].classList.remove('pswp__thumbnail--active');
        }
        pswp.thumbs[currIndex].classList.add('pswp__thumbnail--active');
        prevIndex = currIndex;
        const target = $$4(mediaSelector, this)[pswp.currIndex];
        if (target) this?.slider?.goToTarget(target, true)
      });
      pswp.on('openingAnimationEnd', () => {
        $4('.hdt-slider', el)?.reveal();
      });
      pswp.on('close', () => {
        const target = $$4(mediaSelector, this)[pswp.currIndex];
        if (target) this?.slider?.goToTarget(target, true)
      });
    },
   // when user clicks or taps on element
    onClick: function (e, el, pswp) {
      const {index} = e.target.dataset;
      if (index) pswp.goTo(parseInt(index));
    }
  });
}

customElements.define('hdt-img-psw', ImageLightbox); // wrapp-open-pswp-btn
customElements.define('hdt-gallery-modal', GalleryModal);

/**
* 8. Product media
* -----------------------------------------------------------------------------
*/
var _allow_update_progress_bar= new WeakMap(),
_update_progress_bar = new WeakSet(), update_progress_bar_fn,
_color_progress_bar = new WeakMap();
class ProgressBar extends HTMLElement {
  constructor() {
    super();
    getterAdd(_update_progress_bar, this);
    getterAdd(_allow_update_progress_bar, this, !this.hasAttribute("reveal-in-view"));
    getterAdd(_color_progress_bar, this, this.getAttribute('data-colors'));
  }
  static get observedAttributes() {
    return ["aria-valuenow", "aria-valuemax"];
  }
  connectedCallback() {
    if (this.hasAttribute("reveal-in-view")) {
      inView(this, () => {
        getterAdd(_allow_update_progress_bar, this, true, true);
        getterRunFn(_update_progress_bar, this, update_progress_bar_fn).call(this);
      }, { margin: "-50px 0px" });
    } else {
      // Update immediately if not using reveal-in-view
      getterRunFn(_update_progress_bar, this, update_progress_bar_fn).call(this);
    }
  }
  get progress() {
    return Math.min(1, this.getAttribute("aria-valuenow") / this.getAttribute("aria-valuemax"));
  }
  /**
   * @param {string} value
   */
  set max(value) {
    this.setAttribute("aria-valuemax", value);
  }
  /**
   * @param {string} value
   */
  set now(value) {
    this.setAttribute("aria-valuenow", value);
  }
  attributeChangedCallback() {
    if (getterGet(_allow_update_progress_bar, this)) {
      getterRunFn(_update_progress_bar, this, update_progress_bar_fn).call(this);
    }
  }
};
update_progress_bar_fn = function() {
  const colors = JSON.parse(getterGet(_color_progress_bar, this)),
  fixed = (this.progress+'').slice(0,3);
  if ( colors && colors[fixed] ) {
    for (let [key, item] of Object.entries(colors)) {
      this.parentElement.classList.toggle(item, key == fixed);
    }
  }
  this.style.setProperty("--progress-rate", `${this.progress}`);
};

var _qty_forms = new WeakMap(),
_qty_labels = new WeakMap(),
_qty_inputs = new WeakMap(),
_update_quantity_rules = new WeakSet(),
_set_quantity_boundries = new WeakSet();
class QuantityWrapp extends HTMLElement {
  #controller;
  constructor() {
    super(...arguments);
    getterAdd(_qty_inputs, this, $4('input', this));
    getterAdd(_update_quantity_rules, this);
    getterAdd(_set_quantity_boundries, this);
  }
  get input() {
    return getterGet(_qty_inputs, this);
  }
  get quantityForm() {
    return $id4(`Quantity-Form-${this.getAttribute('section-id')}`);
  }
  get form() {
    return this._form = this._form || document.forms[this.input.getAttribute("form")];
  }
  get qty() {
    return this.input.value;
  }
  get cart() {
    return $4('[ref="hdt-cart"]');
  }
  set qty(value) {
   this.input.value = value,
   this.input.dispatchEvent(new Event("change"));
  }
  connectedCallback() {
    this.#controller = new AbortController();
    if (!this.input) return;
    const { signal } = this.#controller;
    if (this.hasAttribute('qty-in-cart') && this.input.hasAttribute('form')) {
      getterAdd(_qty_forms, this, document.forms[(this.input.getAttribute("form") || '')]);
      getterAdd(_qty_labels, this, $4(`label[for="${this.input.id}"]`));

      document.addEventListener('cart:live', (evt)=> {
        this.#cartUpdateQty(evt.detail.items);
      }, { signal });

      document.addEventListener('cart:tab', (evt)=> {
        this.#cartUpdateQty(evt.detail.items);
      }, { signal });

      if (themeHDN.cartItems && getterGet(_qty_labels, this)) {
        this.#cartUpdateQty(themeHDN.cartItems);
      }
    }
    this.input.addEventListener('change', this.onInputChange.bind(this), { signal });
    $$4('button', this).forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this), { signal })
    );
    this.buttonMinus = $4("[name='minus']", this);
    this.buttonPlus = $4("[name='plus']", this);
    this.validateQtyRules();

    this.debouncedOnChange = debounce(() => {
      this.input.dispatchEvent(new CustomEvent("change", { bubbles: true, detail: { target: this.input } }));
    }, 300);
  }
  disconnectedCallback() {
    this.#controller.abort();
  }

  onInputChange(event) {
    this.validateQtyRules();
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    const button = event.currentTarget;

    // In the cart, decreasing the last item should remove the line item.
    // Product quantity selectors keep their regular minimum quantity behavior.
    if (button.name === 'minus' && Number(previousValue) <= 1 && this.input.dataset.key) {
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      if (cartItems) {
        cartItems.updateQuantity(event, this.input.dataset.key, 0, '', this.input.dataset.variantId, this.input.dataset.index);
        return;
      }
    }

    button.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    let value = this.input.value;
    if (this.alert) {
      this.alert.hidden = !(previousValue == value && value == this.input.max);
      if (this.alert.hidden && this.cart && this.cart.error == this.input.dataset.key && value == this.input.max) this.alert.hidden = false;
      if (this.cart) this.cart.error = this.alert.hidden ? '19041994' : this.input.dataset.key;
    }
    if (previousValue !== value) {
      this.debouncedOnChange();
    }
  }
  validateQtyRules() {
    const value = parseInt(this.input.value),
    _max = this.input.max || 9999,
    max = parseInt(String(_max) != 'null' ? _max : 9999);
    if (this.alert) {
      this.alert.hidden = value <= max;
      if (this.alert.hidden && this.cart && this.cart.error == this.input.dataset.key && value == max) this.alert.hidden = false;
      if (this.cart) this.cart.error = this.alert.hidden ? '19041994' : this.input.dataset.key;
    }
    this.input.value = Math.min(value, max);
    if (this.hasAttribute('form')) {
      getterGet(_qty_forms, this)?.dispatchEvent(new CustomEvent("change", { bubbles: true, detail: { target: this.input } }));
    }
    // Cart rows can remove the item when its quantity reaches 1, so their
    // minus button must remain clickable at the regular cart minimum.
    this.buttonMinus.classList.toggle('disabled', !this.input.dataset.key && this.input.min && value <= parseInt(this.input.min));
    this.buttonPlus.classList.toggle('disabled', value >= parseInt(max));
  }
  #cartUpdateQty(items) {
    const itemCountForVariant = items.find((item) => item.id == this.dataset.variantId);
    $4('.hdt-quantity__rules-cart', getterGet(_qty_labels, this)).hidden = !itemCountForVariant;
    if (itemCountForVariant) $4('.hdt-quantity-cart', getterGet(_qty_labels, this)).textContent = itemCountForVariant.quantity;
  }
  get alert() {
    return this._alert ??= $id4(`Cart-LineItemError-${this.input.dataset.index}`);
  }
};

var _on_recipient_form_changed = new WeakSet(), on_recipient_form_changed_fn,
_cart_error2 = new WeakSet(), _cart_error2_fn,
_displayErrorMessage = new WeakSet(), displayErrorMessage_fn,
_createErrorListItem = new WeakSet(), createErrorListItem_fn,
_clearErrorMessage = new WeakSet(), clearErrorMessage_fn;
// https://github.com/Shopify/dawn/blob/main/assets/recipient-form.js
class RecipientForm extends HTMLElement {
  #controller;
  constructor() {
    super();
    getterAdd(_on_recipient_form_changed, this);
    getterAdd(_cart_error2, this);
    getterAdd(_displayErrorMessage, this);
    getterAdd(_createErrorListItem, this);
    getterAdd(_clearErrorMessage, this);
    this.recipientFieldsLiveRegion = $4(`#Recipient-fields-live-region-${this.blockId}`, this);
    this.checkboxInput = $4(`#Recipient-checkbox-${this.blockId}`, this);
    this.checkboxInput.disabled = false;
    this.hiddenControlField = $4(`#Recipient-control-${this.blockId}`, this);
    this.hiddenControlField.disabled = true;

    this.emailInput = $4(`#Recipient-email-${this.blockId}`, this);
    this.nameInput = $4(`#Recipient-name-${this.blockId}`, this);
    this.messageInput = $4(`#Recipient-message-${this.blockId}`, this);
    this.sendonInput = $4(`#Recipient-send_on-${this.blockId}`, this);
    this.offsetProperty = $4(`#Recipient-timezone-offset-${this.blockId}`);
    if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();

    this.errorMessageWrapper = $4('.hdt-form__message-wrapper', this);
    this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
    this.errorMessage = this.errorMessageWrapper?.querySelector('.hdt-error-message');
    this.defaultErrorHeader = this.errorMessage?.innerText;
  }
  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.checkboxInput.addEventListener('change', getterRunFn(_on_recipient_form_changed, this, on_recipient_form_changed_fn).bind(this), { signal });
    this.form?.addEventListener(cartError, getterRunFn(_cart_error2, this, _cart_error2_fn).bind(this), { signal });
    this.form?.addEventListener(cartUpdate, getterRunFn(_clearErrorMessage, this, clearErrorMessage_fn).bind(this), { signal });
  }
  disconnectedCallback() {
    this.#controller.abort();
  }
  get form() {
    return this.closest('form');
  }
  get blockId() {
    return this.dataset.blockId;
  }

  get inputFields() {
    return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput];
  }

  get disableableFields() {
    return [...this.inputFields, this.offsetProperty];
  }

  // clearInputFields() {
  //   this.inputFields.forEach((field) => (field.value = ''));
  // }

  enableInputFields() {
    this.disableableFields.forEach((field) => (field.disabled = false));
  }

  disableInputFields() {
    this.disableableFields.forEach((field) => (field.disabled = true));
  }
};
on_recipient_form_changed_fn = function() {
  if (this.checkboxInput.checked) {
    this.enableInputFields();
    this.recipientFieldsLiveRegion.innerText =  this.recipientFieldsLiveRegion.dataset.expanded;
  } else {
    this.disableInputFields();
    this.recipientFieldsLiveRegion.innerText = this.recipientFieldsLiveRegion.dataset.collapsed
  }
};
_cart_error2_fn = function(event) {
  if (event.detail.source === 'product-form') getterRunFn(_displayErrorMessage, this, displayErrorMessage_fn).call(this, event.detail.errors);
};
displayErrorMessage_fn = function(body) {
  getterRunFn(_clearErrorMessage, this, clearErrorMessage_fn).call(this);
  this.errorMessageWrapper.hidden = false;
  if (typeof body === 'object') {
    this.errorMessage.innerText = this.defaultErrorHeader;
    return Object.entries(body).forEach(([key, value]) => {
      const errorMessageId = `RecipientForm-${key}-error-${this.blockId}`;
      const fieldSelector = `#Recipient-${key}-${this.blockId}`;
      const message = `${value.join(', ')}`;
      const errorMessageElement = this.querySelector(`#${errorMessageId}`);
      const errorTextElement = errorMessageElement?.querySelector('.hdt-error-message');
      if (!errorTextElement) return;

      if (this.errorMessageList) {
        this.errorMessageList.appendChild(getterRunFn(_createErrorListItem, this, createErrorListItem_fn).call(this, fieldSelector, message));
      }

      errorTextElement.innerText = `${message}.`;
      errorMessageElement.removeAttribute('hidden');

      const inputElement = this[`${key}Input`];
      if (!inputElement) return;

      inputElement.setAttribute('aria-invalid', true);
      inputElement.setAttribute('aria-describedby', errorMessageId);
    });
  }

  this.errorMessage.innerText = body;
};
createErrorListItem_fn = function(target, message) {
  const li = document.createElement('li');
  const a = document.createElement('a');
  a.setAttribute('href', target);
  a.innerText = message;
  li.appendChild(a);
  li.className = 'hdt-error-message';
  return li;
};
clearErrorMessage_fn = function() {
  this.errorMessageWrapper.hidden = true;

  if (this.errorMessageList) this.errorMessageList.innerHTML = '';

  $$4('.hdt-recipient-fields .hdt-form__message').forEach((field) => {
    field.setAttribute('hidden', '');
    const textField = $4('.hdt-error-message', field);
    if (textField) textField.innerText = '';
  });

  this.inputFields.forEach((inputElement) => {
    inputElement.setAttribute('aria-invalid', false);
    inputElement.removeAttribute('aria-describedby');
  });
};

var _slider_main_select = new WeakSet(), slider_main_select_fn,
_slide_media_main = new WeakMap(),
_xr_button = new WeakMap(),
_media_image_zoom = new WeakSet, media_image_zoom_fn,
_variants_options = new Map();

class ProductMedia extends GalleryModal {
  #controller;
  #_medias;
  #_thumbnailMedias;
  constructor() {
    super();
    getterAdd(_slider_main_select, this);
    getterAdd(_slide_media_main, this, $4(`hdt-slider-media`, this));
    getterAdd(_xr_button, this, $4('[data-shopify-xr]', this));
    getterAdd(_media_image_zoom, this);
  }
  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    getterGet(_slide_media_main, this)?.addEventListener('select', getterRunFn(_slider_main_select, this, slider_main_select_fn).bind(this), { signal });
    this.addEventListener(ThemeEvents.mediaStartedPlaying, (event)=> {
      const { resource } = event.detail;
      $$4('hdt-video[playing], hdt-model[playing]', this).forEach( (media) => {
        if (resource !== media) {
          //console.log(media)
          media.pause();
        }
      });
    }, { signal })

    // Handler for variant change
    // this.closest('hdt-product-observe')?.addEventListener("variant-change", (event) => {
    //   const {variant} = event.detail;
    //   if (!variant) return;
    //   this.#updateGroupMediaFilter(variant);
    //   if (!variant.featured_media) return;
    //   const media = $4(`.hdt-product-media__main [data-media-id="${variant.featured_media.id}"]`, this);
    //   if (!media) return;
    //   frame.render(() => {
    //     //console.log(media, variant)
    //     if (this.slider.isActive) {
    //       this.slider.goToTarget(media, !matchMediaQuery("motion"), true);
    //     } else {
    //       media.scrollIntoView({ block: "start", behavior: "smooth" });
    //     }
    //   })
    // }, { signal });
    document.forms[this.getAttribute("form")]?.addEventListener("product:updateNow", (event) => {
      //console.log('Media: ', event.detail.variant);
      const {variant} = event.detail;
      this.#updateGroupMediaFilter(variant);
      if (!this.hasAttribute('scroll-to-variant-image') || this.#hasVariantAltFilter) return;
      const media = this.#getVariantMedia(variant);
      if (!media) return;
      frame.render(() => {
        //console.log(media, variant)
        if (this.slider.isActive) {
          this.slider.goToTarget(media, !matchMediaQuery("motion"), true);
        } else {
          media.scrollIntoView({ block: "start", behavior: "smooth" });
        }
      })
    }, { signal });

    // Handler for slider
    if (this.hasAttribute('update-image-on-slide-change')) {
      this.slider?.apiS?.on('pointerDown', (event) => {
        this.sliderUseronChange = true;
      });
      this.slider?.apiS?.on('pointerUp', (event) => {
        this.sliderUseronChange = false;
      });
      $4('hdt-slider-thumb', this)?.addEventListener('click', () => {
        this.sliderUseronChange = true;
      }, { signal });
      $4('hdt-slider-thumb', this)?.apiS?.on('select', (event) => {
        this.sliderUseronChange = false;
      });
    }

    // Handler for image zoom, lightBox
    if (this.imageZoom != 'no') super.connectedCallback();
    if ((this.imageZoom == 'zoom' || this.imageZoom == 'zoom_lightbox') && matchMediaQuery("hover")) {
      getterRunFn(_media_image_zoom, this, media_image_zoom_fn).call(this);
    }

    getterGet(_slide_media_main, this)?.addEventListener('reInit', () => {
      $4('.hdt-product-media__zoom', this)?.toggleAttribute('hidden', $4('.hdt-product__media-item.is-selected', this)?.dataset.mediaType != 'image');
    });

    queueMicrotask(() => {
      this.#applyMediaVisibilityContext();
      if (this.#hasVariantAltFilter) {
        this.#orderMediaForVariant(this.dataset.initialFeaturedMediaId || '', this.dataset.initialVariantSku || '');
      }
      this.slider?.reInit({ startIndex: 0 });
      this.#sliderThumb?.reInit();
    });
  }
  get imageZoom() {
    return this.getAttribute('image-zoom');
  }
  get sectionId() {
    return this.getAttribute('section-id');
  }
  get slider() {
    return $4('hdt-slider-media', this);
  }
  get #sliderThumb() {
    return $4('hdt-slider-thumb', this);
  }
  get images() {
    return $$4('.hdt-product-media__main [data-media-type="image"]:not([hidden]) img[hdt-el]', this)
  }
  get formId() {
    return this.getAttribute("form");
  }
  get form() {
    return document.forms[this.formId];
  }
  get variantPicker() {
    return $4(`hdt-variant-picker[form="${this.formId}"]`);
  }
  get #hasGroupFilter() {
    return this._hasGroupFilter ??= this.hasAttribute('can-has-media-group');
  }
  get #hasVariantAltFilter() {
    return this._hasVariantAltFilter ??= this.hasAttribute('filter-media-by-variant-alt');
  }
  get #medias() {
    return this.#_medias ??= $$4('.hdt-product__media-item', this);
  }
  get #thumbnailMedias() {
    return this.#_thumbnailMedias ??= $$4('.hdt-thumbnail__media', this);
  }
  #applyMediaVisibilityContext() {
    let context = null;
    if (this.dataset.mediaVisibilityCollection) {
      context = {
        collectionHandle: this.dataset.mediaVisibilityCollection,
        collectionHandles: String(this.dataset.mediaVisibilityCollectionHandles || this.dataset.mediaVisibilityCollection).split('|').filter(Boolean),
        hideSuffixes: String(this.dataset.mediaVisibilitySuffixes || '').split('||').map((suffix) => suffix.trim().toLowerCase()).filter(Boolean)
      };
    } else {
      context = MediaVisibilityContext.resolveForProduct(this);
    }
    if (!context?.collectionHandle || !context.hideSuffixes?.length) return;
    const productCollectionHandles = String(this.dataset.productCollectionHandles || '').split('|').filter(Boolean);
    const contextCollectionHandles = context.collectionHandles?.length ? context.collectionHandles : [context.collectionHandle];
    if (!contextCollectionHandles.some((handle) => productCollectionHandles.includes(handle))) return;

    const filenameFor = (media) => {
      const image = media.matches('img') ? media : $4('img', media);
      const source = image?.currentSrc || image?.getAttribute('src') || '';
      try {
        return decodeURIComponent(source.split('?')[0].split('/').pop() || '').replace(/\.[^.]+$/, '').toLowerCase();
      } catch (_) {
        return source.split('?')[0].split('/').pop()?.replace(/\.[^.]+$/, '').toLowerCase() || '';
      }
    };
    const imageMedia = $$4('.hdt-product__media-item[data-media-type="image"]', this);
    let hiddenMedia = imageMedia.filter((media) => context.hideSuffixes.some((suffix) => filenameFor(media).endsWith(suffix)));
    if (hiddenMedia.length == imageMedia.length) hiddenMedia = hiddenMedia.slice(1);
    const allMainMedia = $$4('.hdt-product__media-item', this);
    const hiddenIds = new Set(hiddenMedia.map((media) => media.dataset.mediaId));
    const hiddenIndexes = new Set(hiddenMedia.map((media) => allMainMedia.indexOf(media)));
    hiddenMedia.forEach((media) => {
      media.dataset.visibilityRuleHidden = 'true';
      media.hidden = true;
    });
    $$4('.hdt-thumbnail__media', this).forEach((media, index) => {
      if (!hiddenIds.has(media.dataset.mediaId) && !hiddenIndexes.has(index)) return;
      media.dataset.visibilityRuleHidden = 'true';
      media.hidden = true;
    });
  }
  #getVariantMedia(variant) {
    const mediaId = variant?.mid || variant?.featured_media?.id;
    if (!mediaId) return;
    const media = $4(`.hdt-product-media__main [data-media-id="${mediaId}"]`, this);
    return media?.dataset.variantId ? media : undefined;
  }
  #updateGroupMediaFilter(variant){
    if (!this.#hasGroupFilter && !this.#hasVariantAltFilter) return;
    const values = [];
    let selectedValues = '';
    if (this.#hasGroupFilter) {
      const options = this.getAttribute('can-has-media-group').split('|');
      options.forEach( (index) => {
        values.push(variant[`option${index}`]);
      });
      selectedValues = values.join('-');
    }
    // console.log('1: ',selectedValues, values, variant);

    const variantSku = String(variant.sku || '').trim();
    const featuredMediaId = String(variant.mid || variant.featured_media?.id || '');
    this.#medias.forEach( (mediaItem, index) => {
      let isMatch = mediaItem.dataset.visibilityRuleHidden != 'true';
      if (this.#hasGroupFilter) {
        let groupValues = mediaItem.dataset.groupValues;
        if (groupValues.includes('*')) {
          //groupValues = groupValues.replace('*0', values[0]).replace('*1', values[1]).replace('*2', values[2]);
          groupValues = groupValues.replace(/\*(\d)/g, (match, index) => {
            return values[index] !== undefined ? values[index] : match;
          });
        }
        isMatch = isMatch && groupValues == selectedValues;
      }
      if (this.#hasVariantAltFilter && mediaItem.dataset.mediaType == 'image') {
        const mediaAlt = (mediaItem.dataset.variantAlt || '').trim();
        const isFeaturedMedia = featuredMediaId != '' && mediaItem.dataset.mediaId == featuredMediaId;
        const matchesVariantAlt = isFeaturedMedia || mediaAlt == '' || mediaAlt.toLowerCase() == 'all' || mediaAlt == variantSku;
        isMatch = isMatch && matchesVariantAlt;
      }
      mediaItem.toggleAttribute('hidden', !isMatch);
      this.#thumbnailMedias[index]?.toggleAttribute('hidden', !isMatch);
    });
    this.#orderMediaForVariant(featuredMediaId, variantSku);
    if (this.imageZoom != 'no') this.updateImageClick();
    //console.log(this.slider);
    //console.log(this.#sliderThumb);
    const variantMedia = this.hasAttribute('scroll-to-variant-image') && !this.#hasVariantAltFilter
      ? this.#getVariantMedia(variant)
      : undefined;
    const reInitOptions = this.#hasVariantAltFilter
      ? { startIndex: 0 }
      : variantMedia
        ? { startIndex: this.slider?.getIndexSlide(variantMedia.dataset.mediaId) }
        : undefined;
    this.slider?.reInit(reInitOptions);
    this.#sliderThumb?.reInit();
  }
  #orderMediaForVariant(featuredMediaId, variantSku) {
    const orderItems = (items) => {
      const parents = new Map();
      items.forEach((item, index) => {
        const parent = item.parentElement;
        if (!parent) return;
        const mediaAlt = (item.dataset.variantAlt || '').trim();
        const priority = item.hidden
          ? 3
          : featuredMediaId != '' && item.dataset.mediaId == featuredMediaId
            ? 0
            : mediaAlt == variantSku && mediaAlt != ''
              ? 1
              : 2;
        const entries = parents.get(parent) || [];
        entries.push({ item, index, priority });
        parents.set(parent, entries);
      });
      parents.forEach((entries, parent) => {
        entries.sort((a, b) => a.priority - b.priority || a.index - b.index);
        entries.forEach(({ item }) => parent.append(item));
      });
    };
    orderItems(this.#medias);
    orderItems(this.#thumbnailMedias);
  }
};
slider_main_select_fn = async function(event){
  const { sliderApi } = event.detail,
  selectedSlide = sliderApi.slideNodes()[sliderApi.selectedScrollSnap()],
  prevSlide = sliderApi.slideNodes()[sliderApi.previousScrollSnap()],
  mediaId   = selectedSlide.dataset.mediaId,
  variantId = (selectedSlide.dataset.variantId || this.form.id.value) + '';

  if (this.sliderUseronChange && this.variantPicker && this.hasAttribute('update-image-on-slide-change') && variantId != this.form.id.value) {
    this.sliderUseronChange = false;
    if (!_variants_options.has(variantId)) {
      await fetch(`${this.dataset.url}?variant=${variantId}&view=options`).then((response) => response.text()).then((data) => {
        console.log(JSON.parse(data));
        _variants_options.set(variantId, JSON.parse(data));
      }).catch(() => { });
    }
    var inputChange = null;
    this.variantPicker?.fieldsets.forEach((fieldset, index) => {
      const input = $4(`input[is-value][data-value-id="${_variants_options.get(variantId)[index]}"]`, fieldset);
      if (!input.checked) {
        input.checked = true;
        inputChange = input;
      }
    });
    inputChange?.dispatchEvent(new Event("change", { bubbles: true }));
  }

  $4('hdt-video[playing], hdt-model[playing]', prevSlide)?.dispatchEvent( new CustomEvent('media:hidden', { bubbles: false, cancelable: true }) );
  $4('hdt-video, hdt-model', selectedSlide)?.dispatchEvent( new CustomEvent('media:visible', { bubbles: false, cancelable: true }) );
  // Update attr xr button
  getterGet(_xr_button, this)?.setAttribute('data-shopify-model3d-id', selectedSlide.dataset.mediaType == 'model' ? mediaId : getterGet(_xr_button, this).dataset.defaultId);
  // Update icon zoom
  $4('.hdt-product-media__zoom', this)?.toggleAttribute('hidden', selectedSlide.dataset.mediaType != 'image');
};
media_image_zoom_fn = function(){
  var classFadeMedia = 'zoom_fade_media',
      classFadeInfo  = 'zoom_fade_info',
      options        = JSON.parse( this.getAttribute('zoom-options') ),
      zoomWrapper    = $id4(`product-zoom-${this.sectionId}`),
      info           = $id4(`product-info-${this.sectionId}`),
      zoomType       = options.type,  // external, inner, inner2 zoom
      zoomFactor     = options.magnify,
      isExternal     = zoomType  == 'external';

  if(Shopify.designMode) $4('.drift-zoom-pane, .drift-bounding-box')?.remove();
  html.classList.add(`zoom-type--${zoomType}`);
  $$4('.hdt-product-media__main [data-media-type="image"] img', this).forEach((image) => {
    new Zoom(image, {
      //showWhitespaceAtEdges: false,
      sourceAttribute: 'src',
      zoomFactor,
      inlinePane: !isExternal && zoomType == 'inner2',
      containInline: isExternal,
      paneContainer: isExternal ? zoomWrapper : image.parentElement,
      hoverBoundingBox: isExternal, //false , true
      handleTouch: false,
      onShow: () => {
       this.classList.add(classFadeMedia);
       info.classList.add(classFadeInfo);
      },
      onHide: () => {
       this.classList.remove(classFadeMedia);
       info.classList.remove(classFadeInfo);
      }
    });
  });

};
customElements.define('hdt-product-media', ProductMedia);

var _master_input = new WeakMap(),
_fieldsets = new WeakMap(),
_options_size = new WeakMap();

const _tree = {},
_variants = {},
_product_info_cache = new Map(),
_variantLoadingStates = {};
class VariantLoader {
  constructor(config) {
    this.baseUrl = `${Shopify.routes.root}products/${config.handle}`; // URL cơ bản của product
    this.productId = config.productId; // Product ID để cache
    this.totalVariants = config.totalVariants; // Tổng số variants
    this.sectionId = config.sectionId || 'variants'; // Section ID
    this.triggerElement = config.triggerElement; // Element để theo dõi lazy load
    //this.onProgress = config.onProgress || (() => {}); // Callback khi có tiến trình
    //this.onComplete = config.onComplete || (() => {}); // Callback khi hoàn thành
    this.isLoading = false;
    this.isLoaded = false;
  }

  /**
   * Tải dữ liệu từ một trang
   */
  async fetchPage(pageNumber) {
    try {
      const response = await fetch(`${this.baseUrl}?page=${pageNumber}&section_id=${this.sectionId}`);

      if (!response.ok) {
        throw new Error('error: ', response);
      }
      const htmlText = await response.text();
      const html = new DOMParser().parseFromString(htmlText, "text/html");
      return $4('.hdt-section', html).textContent.trim();
      //return JSON.parse($4('.hdt-section', html).textContent.trim())
    } catch (error) { console.error(error); }
  }

  /**
   * Tải tất cả các trang
   */
  async loadAllPages() {
    // Kiểm tra cache global trước
    if (this.productId && _variants[this.productId]) {
      // console.log(`✓ Product ${this.productId} đã có trong cache`);
      const variants = _variants[this.productId];
      this.isLoaded = true;
      //this.onComplete(variants);
      this.dispatchLoadedEvent(variants);
      return variants;
    }

    // Kiểm tra nếu đã có instance khác đang tải cùng product
    if (this.productId && _variantLoadingStates[this.productId]) {
      // console.log(`Đang chờ instance khác tải product ${this.productId}...`);
      return this.waitForOtherInstanceToComplete();
    }

    if (this.isLoading || this.isLoaded) {
      // console.log('Đang tải hoặc đã tải xong');
      return _variants[this.productId]
    }

    // Đánh dấu đang tải
    this.isLoading = true;
    if (this.productId) {
      _variantLoadingStates[this.productId] = true;
    }

    const totalPages = Math.ceil(this.totalVariants / 250);
    // console.log(`Bắt đầu tải ${totalPages} trang, tổng ${this.totalVariants} variants`);

    try {
      // Tải tuần tự từng trang
      const variants = [];
      for (let page = 1; page <= totalPages; page++) {
        // console.log(`Đang tải trang ${page}/${totalPages}...`);

        const pageData = await this.fetchPage(page);
        variants.push(...JSON.parse(pageData));
        //const array = pageData.split('[nt94]');
        //variants.push(...JSON.parse(array[0]));
        //options.push(...JSON.parse(array[1]));
        // Gộp variants vào mảng chung
        // if (Array.isArray(pageData)) {
        //   variants.push(...pageData);
        // } else {
        //   console.warn(`Dữ liệu trang ${page} không phải array:`, pageData);
        // }

        // Callback tiến trình
        // this.onProgress({
        //   currentPage: page,
        //   totalPages: totalPages,
        //   loadedVariants: variants.length,
        //   totalVariants: this.totalVariants
        // });

        // Delay nhỏ để tránh quá tải server
        if (page < totalPages) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }
      }
      this.isLoaded = true;
      this.isLoading = false;

      // Lưu vào cache global
      if (this.productId) {
        _variants[this.productId] = variants;
        delete _variantLoadingStates[this.productId];
        // console.log(`✓ Đã lưu ${variants.length} variants vào theme.variants.${this.productId}`);
      } else {
        // console.log(`✓ Đã tải xong ${variants.length} variants`);
      }

      // Dispatch custom event
      this.dispatchLoadedEvent(variants);

      // Callback hoàn thành
      //this.onComplete(variants);

      return variants;

    } catch (error) {
      this.isLoading = false;
      if (this.productId) {
        delete _variantLoadingStates[this.productId];
      }
      // console.error('Lỗi khi tải variants:', error);
      throw error;
    }
  }

  /**
   * Chờ instance khác tải xong
   */
  async waitForOtherInstanceToComplete() {
    return new Promise((resolve) => {
      const checkInterval = setInterval(() => {
        if (this.productId && _variants[this.productId]) {
          clearInterval(checkInterval);
          const variants = _variants[this.productId];
          this.isLoaded = true;
          this.dispatchLoadedEvent(variants);
          //this.onComplete(variants);
          resolve(variants);
        }
      }, 100);
    });
  }

  /**
   * Dispatch custom event khi tải xong
   */
  dispatchLoadedEvent(variants) {

    // Dispatch từ trigger element nếu có, nếu không thì từ document
    this.triggerElement.dispatchEvent(new CustomEvent('variantsLoaded', {
      detail: {
        productId: this.productId,
        variants: variants,
        totalVariants: variants.length
      },
      bubbles: true
    }));
    // console.log(`✓ Đã dispatch event 'variantsLoaded' với ${variants.length} variants`);
  }
}
class VariantPicker extends HTMLElement {
 #controller;
 #controllerFetch;
 #fieldsetsTree = {};
 #is_soldout = false;
 #is_unavailable = false;
 #optionsIndexNeedUpdate = [];
  constructor() {
    super();
    getterAdd(_fieldsets, this, $$4('fieldset:not([pseudo-option])', this));
    getterAdd(_options_size, this, this.fieldsets.length);

  }
  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.abortController = new AbortController();
    getterAdd(_master_input, this, this.masterInput);
    this.#updateUrl();
    this.updateOptions();

    // Init Variants
    if (_variants[this.dataset.id]) {
      this.#variantSmart(_variants[this.dataset.id]);
      this.#selectVariantFromUrl(_variants[this.dataset.id]);
    } else {
      const loader = new VariantLoader({
        handle: this.handle,
        productId: this.dataset.id,
        totalVariants: parseInt(this.getAttribute('count')),
        triggerElement: this
      });
      inView(this.parentElement, () => loader.loadAllPages(), { margin: "500px" });
      this.addEventListener('variantsLoaded', (e) => {
        this.#variantSmart(e.detail.variants);
        this.#selectVariantFromUrl(e.detail.variants);
      });
    }
    // End Init Variants

    this.addEventListener('change', this.#valueChange, { signal });

    // To trigger when use type dropdown
    //$$4('fieldset[type^="dropdown"]', this).forEach((fieldset) => {
    $$4('fieldset[type^="dropdown"], fieldset[picker-style^="dropdown"]', this).forEach((fieldset) => {
      $4('hdt-popover', fieldset).addEventListener("richlist:change", (e) => {
        //console.log(e)
        const input = $4(`input[type="hidden"][name="option${parseInt(e.target?.dataset.index) + 1}"]`, fieldset);
        if (input.value == e.detail.value) return;
        input.value = e.detail.value;
        input.setAttribute("data-value-id", e.target?.dataset.valueId);
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }, { signal });
    });
  }
  disconnectedCallback() {
    this.#controller.abort();
  }
  get handle() {
    return this._handle ??= this.getAttribute("handle");
  }
  get masterInput() {
    const formId = this.getAttribute("form"),
    tmp = this.nextElementSibling;
    if (!document.forms[formId] && tmp) {
      tmp.replaceWith(tmp.content.firstElementChild.cloneNode(true));
    }
    return document.forms[formId].id;
  }
  get selectedVariant() {
    // const scriptData  = $4('script[data-selected-variant]', this),
    // variant = JSON.parse(scriptData?.textContent || "{}");
    // if (variant) variant.valuesID = JSON.parse(scriptData?.dataset?.selectedVariant || "[]");
    return JSON.parse($4('script[data-selected-variant]', this)?.textContent || "{}");
  }
  get fieldsets() {
    return getterGet(_fieldsets, this);
  }
  get #hideSoldOut() {
    return false;
  }
  get #isInterMarket() {
    return this.hasAttribute('inter-market');
  }
  #variantIsAvailable(variant) {
    return this.#isInterMarket() ? variant.interAvailable !== false : variant.available;
  }
  get #main() {
    return this._main ??= this.closest(".hdt-main-product");
  }
  get #sectionId() {
    return this._sectionId ??= this.getAttribute("section-id");
  }
  get #form() {
    return this._form ??= document.forms[this.getAttribute("form")];
  }
  // updateOptions() {
  //   this.options = this.fieldsets.map((fieldset) => {
  //     return $$4('input, a', fieldset).find((input) => input.checked || input.type == 'hidden' || input.hasAttribute('selected'))?.dataset.valueId;
  //   }).filter((value)=> {
  //     return value !== undefined && value !== '';
  //   })
  // }
  updateOptions() {
    this.options = this.fieldsets
      .map((fieldset) => {
        const el = $$4('input, a', fieldset).find((input) => !input.hasAttribute('data-custom-color-variant') && (input.checked || input.type === 'hidden' || input.hasAttribute('selected')));
        return el?.dataset.valueId
          ? Number(el.dataset.valueId)
          : undefined;
      })
      .filter((value) => Number.isFinite(value));
  }

  #variantSmart(variants) {
    // Remove soldout
    //console.log(variants)
    let total = 1;
    // build fieldsetsTree
    this.fieldsets.forEach((fieldset, index) => {
      this.#fieldsetsTree[index] = $$4('[is-value]', fieldset).map(el => parseInt(el.dataset.valueId));
      const length = this.#fieldsetsTree[index].length;
      total = total * length;
      //if (length > 1) this.#optionsIndexNeedUpdate.push(index);
      this.#optionsIndexNeedUpdate.push(index);
    });
    // console.log('fieldsetsTree: ',this.#fieldsetsTree)
    _tree[this.dataset.id] = this.#buildVariantTree(variants);
    this.#is_unavailable = variants.length < total; // has unavailable
    this.#is_soldout = variants.some(v => !this.#variantIsAvailable(v)); // has soldout
    if (this.#is_unavailable || this.#is_soldout ) this.#updateSwatchSelector();

    // Hover
    // $$4('input[is-value] + label, button[is-value]').forEach( (el)=> {
    //   hover(el, () => {
    //     console.log("hover start")
    //     const nextOptions = [...this.options]; // clone
    //     nextOptions[Number(el.dataset.index || el.previousElementSibling.dataset.index)] = Number(el.dataset.valueId || el.previousElementSibling.dataset.valueId);
    //     const selectedOptions = nextOptions.reduce((acc, value, index) => {
    //       acc[`option${index}`] = value;
    //       return acc;
    //     }, {}),
    //     node = this.#findNode(selectedOptions);
    //     console.log(nextOptions, selectedOptions, node);
    //     let currentVariant;
    //     if (node) {
    //       currentVariant = node._variant;
    //     } else {
    //       currentVariant = this.#findClosestVariantOptimized(selectedOptions);
    //     }
    //     if (currentVariant) this.#fetchSection(currentVariant.id, false)
    //   })
    // })
  }
  #selectVariantFromUrl(variants) {
    const requestedVariantId = new URLSearchParams(window.location.search).get('variant');
    if (!requestedVariantId) return;

    const requestedVariant = variants.find((variant) => String(variant.id) === requestedVariantId);
    if (!requestedVariant) return;

    let trigger;
    this.fieldsets.forEach((fieldset, index) => {
      const input = $4(`[is-value][data-value-id="${requestedVariant[`option${index}`]}"]`, fieldset);
      if (!input) return;

      if (input.type === 'radio') {
        input.checked = true;
      } else if (input.tagName === 'BUTTON') {
        $4('[is-value][aria-selected="true"]', fieldset)?.setAttribute('aria-selected', 'false');
        input.setAttribute('aria-selected', 'true');
      }
      trigger = input;
    });

    if (!trigger) return;
    this.#valueChange({ target: trigger });
  }
  #valueChange = async (event) => {
    //console.log('valueChange')
    if (event.target.hasAttribute('data-custom-color-variant')) {
      const targetUrl = event.target.dataset.url;
      if (targetUrl) {
        MediaVisibilityContext.prepareNavigation(event.target, targetUrl);
        window.location.href = targetUrl;
      }
      return;
    }
    if (!event.target.hasAttribute("is-value") && !event.target.hasAttribute('trigger-value')) return;
    this.updateOptions();
    if (this.options.length < getterGet(_options_size, this)) {
      return;
    }
    this.removeAttribute('no-pick');
    let currentVariant;
    //console.log('valueChange: ', this.options)
    const selectedOptions = this.#selectedOptions;
    //console.log('selectedOptions: ', selectedOptions)
    if (this.#is_unavailable || ( this.hideSoldOut && this.#is_soldout)) {
      // Check is unavailable: this.#is_unavailable || ( this.hideSoldOut && this.#is_soldout)
      // Check has variant match with options selected. if not variant find a variant closest match.
      const node = this.#findNode(selectedOptions);
      if (node) currentVariant = node._variant;
      //console.log('node:', node);
      if (!currentVariant) {
        // Case Unavailable
        currentVariant = this.#findClosestVariantOptimized(selectedOptions);
        if (!currentVariant) {
          //console.log('not find acurrentVariant')
          return;
        }
        // Update option
        const newOptions = Object.entries(currentVariant)
        .filter(([key]) => key.startsWith('option'))
        .map(([_, value]) => value);

        // Update radio checked
        newOptions.forEach( (value, index) => {
          const fieldset = this.fieldsets[index],
          valueEl = $4(`[is-value][data-value-id="${value}"]`, fieldset)
          if (valueEl) {
            if (valueEl.type == 'button') {
              // is Dropdown
              $4('[trigger-value]', fieldset).dataset.valueId = value;
              $4('button[aria-owns]', fieldset).textContent = valueEl.value;
              $4(`button[is-value][aria-selected="true"]`, fieldset).setAttribute('aria-selected', false);
              valueEl.setAttribute('aria-selected', true);
            } else {
              valueEl.checked = true;
            }
          }
        });
        // Update [update-value]
        this.updateOptions();
        //console.log('node2:', currentVariant, newOptions)
      }
      this.#updateSwatchSelector();
    } else {
      const _node = this.#findNode(selectedOptions);
      currentVariant = _node._variant;
      if (this.#is_soldout) this.#updateSwatchSelector();
    }
    //if (!currentVariant) return;
    const formVariantInput = this.#form?.querySelector('[name="id"]');
    if (formVariantInput && currentVariant) {
      formVariantInput.value = currentVariant.id;
      formVariantInput.disabled = !currentVariant.available;
    }
    // UPDATE
    // 1. Update [update-value]
    this.options.forEach( (value, index) => {
      const valueEl = $4(`[is-value][data-value-id="${value}"]`, this.fieldsets[index]);
      const updateValueEl = $4('[update-value]', this.fieldsets[index]);
      if (valueEl && updateValueEl) updateValueEl.textContent = valueEl.value;
    });

    // 2. Update form, buy buttons and media
    this.#form?.dispatchEvent(new CustomEvent("product:updateNow", { detail: { variant: currentVariant } }));

    // 3. Update url
    this.#updateUrl(currentVariant.id);

    // 4. Update product info
    const html = await this.#fetchSection(currentVariant.id);
    //console.log('html: ', html)
    if (!html) return;
    this.#form?.dispatchEvent(new CustomEvent("product:updateInfo", {
      detail: {
        html,
        sectionId: this.#sectionId,
        targetId: event.target.id,
      }
    }));
  }
  #updateSwatchSelector() {
    const CLASS_UNAVAILABLE = 'is-unavailable',
    CLASS_SOLDOUT = this.#hideSoldOut ? 'is-unavailable' : 'is-disabled',
    indexes = this.#optionsIndexNeedUpdate;
    //console.log(this.#fieldsetsTree, this.options)
    indexes.forEach((currentIndex, level) => {
      //console.log(currentIndex,level)
      this.#fieldsetsTree[currentIndex].forEach((value) => {

        const valueEl = $4(`[is-value][data-value-id="${value}"]`, this.fieldsets[currentIndex])

        // ===== Build selectedOptions =====
        const selectedOptions = {}

        // Fill previous selected options
        for (let i = 0; i < level; i++) {
          const idx = indexes[i];
          selectedOptions[`option${idx}`] = this.options[idx]
        }

        // Current option value
        selectedOptions[`option${currentIndex}`] = value

        const nodes = this.#findNode(selectedOptions)

        // ===== Reset state =====
        valueEl.classList.add(CLASS_UNAVAILABLE, CLASS_SOLDOUT);

        if (!nodes) return;

        valueEl.classList.remove(CLASS_UNAVAILABLE)
        if ( this.#collectLeafVariants(nodes)) valueEl.classList.remove(CLASS_SOLDOUT)

      })
    })
  }
  #buildVariantTree(variants) {
    const root = {};

    variants.forEach((variant) => {
      let currentNode = root;

      // Get all option values dynamically
      const optionValues = Object.keys(variant)
        .filter(key => key.startsWith("option") && variant[key])
        .sort() // ensure option1 -> option2 -> option3
        .map(key => variant[key]);

      optionValues.forEach((value, index) => {
        if (!currentNode[value]) {
          currentNode[value] = {};
        }

        // If last level → store variant
        if (index === optionValues.length - 1) {
          currentNode[value]._variant = variant;
          currentNode[value]._available = variant.available;
        }

        currentNode = currentNode[value];
      });
    });

    return root;
  }
  #findNode(selectedOptions) {
    let currentNode = _tree[this.dataset.id];

    const values = Object.keys(selectedOptions)
      .sort()
      .map(key => selectedOptions[key]);
    for (let value of values) {
      if (!currentNode[value]) return null;
      currentNode = currentNode[value];
    }

    return currentNode;
  }
  #collectAllVariants(node, result = []) {
    if (!node) return result;

    // Nếu là leaf node
    if (node._variant) {
      result.push(node._variant);
    }

    // Duyệt các nhánh con
    for (let key in node) {
      if (key.startsWith("_")) continue;

      this.#collectAllVariants(node[key], result);
    }

    return result;
  }
  #getMatchScore(variant, selectedOptions) {
    let score = 0;

    Object.keys(selectedOptions).forEach((key) => {
      if (variant[key] === selectedOptions[key]) {
        score++;
      }
    });

    return score;
  }
  #findClosestVariantOptimized(selectedOptions) {
    let currentNode = _tree[this.dataset.id];
    let lastValidNode = _tree[this.dataset.id];

    const values = Object.keys(selectedOptions)
      .sort()
      .map(key => selectedOptions[key]);

    for (let value of values) {
      if (!currentNode[value]) break;
      currentNode = currentNode[value];
      lastValidNode = currentNode;
    }

    const candidates = this.#collectAllVariants(lastValidNode);

    let bestVariant = null;
    let bestScore = -1;

    for (let variant of candidates) {
      if (!variant.available && this.#hideSoldOut) continue;

      const score = this.#getMatchScore(variant, selectedOptions);

      if (score > bestScore) {
        bestScore = score;
        bestVariant = variant;
      }
    }

    return bestVariant;
  }
  #collectLeafVariants(node, stopOnAvailable = true) {
    // GET 1 variant available
    const result = []
    let found = null
    const isInterMarket = this.#isInterMarket();

    function traverse(current) {
      for (const key in current) {
        const value = current[key]

        // nếu đã tìm được và muốn dừng
        if (stopOnAvailable && found) {
          return
        }

        // leaf node (variant)
        if (value && value.id !== undefined) {
          if (stopOnAvailable) {
            if (isInterMarket ? value.interAvailable !== false : value.available) {
              found = value
              return
            }
          } else {
            result.push(value)
          }
        } else {
          traverse(value)
        }
      }
    }

    traverse(node)

    if (stopOnAvailable) {
      return found
    }

    return result
  }
  async #fetchSection(variantID, loading = true) {
    const key = `${this.#sectionId}:${variantID}`;

    if (_product_info_cache.has(key)) {
      return _product_info_cache.get(key);
    }
    this.#controllerFetch?.abort();
    const controller = new AbortController();
    this.#controllerFetch = controller;

    if (loading) this.#main?.setAttribute('loading-options', '');

    try {
      //console.log('url: ', `${Shopify.routes.root}products/${this.handle}?variant=${variantID}&section_id=${this.#sectionId}`)
      const response = await fetch(`${Shopify.routes.root}products/${this.handle}?variant=${variantID}&section_id=${this.#sectionId}`, { signal: controller.signal });
      const html = await response.text();
      // Save cache
      if (!Shopify.designMode) _product_info_cache.set(key, html);
      return this.#controllerFetch === controller ? html: true;
    }
    catch (error) {
      if (error.name !== 'AbortError') {console.error(error);}
    }
    finally {
      // chỉ remove nếu là request mới nhất
      if (this.#controllerFetch === controller) {
        this.#main?.removeAttribute('loading-options');
      }
    }
    // this.#controllerFetch?.abort();
    // this.#controllerFetch = new AbortController();
    // this.#main?.setAttribute('loading-options', '');
    // const response = await fetch(`${Shopify.routes.root}products/${this.handle}?option_values=${optionValues}&section_id=${this.#sectionId}`, { signal: this.#controllerFetch.signal});
    // const html = await response.text();
    // this.#main?.removeAttribute('loading-options');
    // // Save cache
    // if (!Shopify.designMode) _product_info_cache.set(key, html);

    // return html;
  }
  #updateUrl (id) {
    if (!this.hasAttribute("update-url") || !history.replaceState) return;
    const newUrl = new URL(window.location.href);
    id = id || this.getAttribute("update-url");
    if (id) {
      newUrl.searchParams.set("variant", id);
    } else {
      newUrl.searchParams.delete("variant");
    }
    const currentState = history.state && typeof history.state == 'object' ? history.state : {};
    window.history.replaceState({ ...currentState, path: newUrl.toString() }, "", newUrl.toString());
  }
  get #selectedOptions() {
    return this.options.reduce((acc, value, index) => {
      acc[`option${index}`] = value;
      return acc;
    }, {});
  }
};

var _max_height = new WeakSet(), max_height_fn;
class MaxHeight extends HTMLElement {
  constructor() {
    super();
    getterAdd(_max_height, this);
  }
  connectedCallback() {
    getterRunFn(_max_height, this, max_height_fn).call(this);
    // Add event listener for window resize
    window.addEventListener('resize', getterRunFn(_max_height, this, max_height_fn).bind(this));
    $4('.hdt-read-more', this)?.addEventListener("click", (e) => {
      e.preventDefault();
      this.toggleAttribute("open")
    });
  }
};
max_height_fn = function() {
  // Remove the max-height property
  this.removeAttribute("active-mh");
  this.removeAttribute("open");

  if (this.clientHeight >= this.scrollHeight) return;
  this.style.setProperty("--scroll-height", `${this.scrollHeight + ($4('.hdt-read-more', this)?.clientHeight || 0) + 20}px`);
  this.setAttribute("active-mh", "");
};

var _block_required_froms,
_block_required_detect,
_block_required_on_change, block_required_on_change_fn,
_block_required_on_submit, block_required_on_submit_fn;
class BlockRequired extends HTMLElement {
  #controller;
  constructor() {
    super();
    getterAdd(_block_required_on_submit, this);
    getterAdd(_block_required_on_change, this);
    getterAdd(_block_required_detect, this, this.getAttribute('detect'));
  }
  connectedCallback() {
    this.#controller = new AbortController();
    const arrRequireds = $$4('[required]', this);
    //getterGet(_block_required_froms, this).checkBreak = false;
    if (arrRequireds.length == 0) return;
    const { signal } = this.#controller;
    getterAdd(_block_required_froms, this, document.forms[this.attrForm]);
    if (!getterGet(_block_required_froms, this)) return;
    arrRequireds.forEach((el) => { el.removeAttribute("required"); this.classList.add("is-required") } );
    //getterGet(_block_required_froms, this).checkBreak = ( $$4(`hdt-block-required [form="${this.attrForm}"]`).length != $$4(`hdt-block-required:not(.is-uncheck, .is-required) [form="${this.attrForm}"]`).length );
    this.updateBreak();
    if ( this.getAttribute('event') === 'change') {
      setTimeout(() => this.checked = $4('input:checked', this), 100); // fix when back tab will autocomplete
      this.addEventListener("change", getterRunFn(_block_required_on_change, this, block_required_on_change_fn).bind(this), { signal });
    } else {
      this.addEventListener("input", debounce( getterRunFn(_block_required_on_change, this, block_required_on_change_fn).bind(this), 150, { signal }));
    }
    getterGet(_block_required_froms, this).addEventListener("submit", getterRunFn(_block_required_on_submit, this, block_required_on_submit_fn).bind(this), { signal });
  }
  get attrForm() {
    return this._attrForm = this._attrForm || $4('[form]', this).getAttribute("form");
  }
  updateBreak() {
    getterGet(_block_required_froms, this).checkBreak = ( $$4(`hdt-block-required [form="${this.attrForm}"]`).length != $$4(`hdt-block-required:not(.is-uncheck, .is-required) [form="${this.attrForm}"]`).length );
  }
  disconnectedCallback() {
    this.#controller.abort();
  }
  createStyle() {
    const arr = [];
    let i,j = 0;
    for (i = 0; i < 10; i++) {
      arr.push(`translate3d(${arguments[j++]},0,0)`);
      if (j === arguments.length) j = 0;
    }
    return arr
  }
  /**
   * @param {any} value
   */
  set checked(value) {
    this.setChecked = value;
  }
  get checked() {
    return this.setChecked
  }
}
_block_required_froms = new WeakMap();
_block_required_detect = new WeakMap();
_block_required_on_change = new WeakSet();
block_required_on_change_fn = function() {
  this.checked = false;
  // checked, length
  if ( getterGet(_block_required_detect, this ) === 'checked') {
    if ($4('input:checked', this)) this.checked = true;
  } else {
    const element = $4('input[type="text"]', this) || $4('textarea', this) || $4('select', this);
    if (element && element.value.length > 0) this.checked = true;
  }
  // this.classList.remove('is-required');
  // this.classList.toggle('is-uncheck', !this.checked);
  this.classList.remove('is-uncheck');
  this.classList.toggle('is-required', !this.checked);
  this.updateBreak();
};
_block_required_on_submit = new WeakSet();
block_required_on_submit_fn = function(event) {
  if (this.checked) return;
  //if (this.checked || event.target?.getAttribute('id') !== this.attrForm) return;
  event.preventDefault();
  event.stopPropagation();
  this.classList.remove('is-required');
  this.classList.add('is-uncheck');
  //$4('label', this)?.focus();
  $4(`hdt-block-required.is-uncheck [form="${this.attrForm}"]`).focus();
  animate(
    this,
    {
      transform: this.createStyle(0, '-10px', '10px')
    },
    {
      offset: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
      duration: 1,
      ease: [0.25, 0.1, 0.25, 1.0]
    }
  );
};
customElements.define("hdt-block-required", BlockRequired);


class buyButtons extends HTMLElement {
  #controller;
  connectedCallback() {
    this.#controller = new AbortController();
    const productForm = this.closest('product-form');
    //quantity = $4('[quantity-selector', this);
    productForm.submitButton = $4('[type="submit"]', this);
    if (productForm.cart) productForm.submitButton.setAttribute('aria-haspopup', 'dialog');
    const {preOrder, addToCart, soldOut} = themeHDN.strings;
    document.forms[this.getAttribute("form")]?.addEventListener("product:updateNow", (event) => {
      const { variant } = event.detail;
      //console.log('Buy button: ', variant)
      // 1.Update id
      productForm.form.id.value = variant.id;
      if (!this.hasAttribute('need-update-atc')) return;
      // 2. Update atc text: Add to cart, Sold out, pre-oder
      productForm.submitButton.toggleAttribute('disabled', !variant.available);
      productForm.submitButton.firstElementChild.textContent = variant.isPreOrder ? preOrder : variant.available ? addToCart : soldOut;
      // Hidden quantity
      // quantity.hidden = !variant.available;
    }, { signal: this.#controller.signal });
    if (this.closest('.hdt-main-product')?.hasAttribute('is-qv')) {
      //console.log('qv')
      Shopify?.PaymentButton?.init();
    }
  }
  disconnectedCallback() {
    this.#controller.abort();
  }
};
var _on_submit_handler = new WeakSet(), on_submit_handler_fn,
_product_form = new WeakMap(), _cart_drawer = new WeakMap(),
_reset_product_form_state = new WeakSet(), reset_product_form_state_fn;
class ProductForm extends HTMLElement {
  #controller;
  constructor() {
    super();
    getterAdd(_on_submit_handler, this);
    getterAdd(_reset_product_form_state, this);
    getterAdd(_product_form, this, $4('form', this));
    getterAdd(_cart_drawer, this, $4('[ref="hdt-cart"]'));
    this.hideErrors = this.dataset.hideErrors === 'true';
    this.submitButton = $4('[type="submit"]', this);
    if (this.cart) this.submitButton.setAttribute('aria-haspopup', 'dialog');
  }
  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    if (typeof this.form.id == 'object') this.form.id.disabled = false;
    this.form?.addEventListener('submit', getterRunFn(_on_submit_handler, this, on_submit_handler_fn).bind(this), { signal });
    this.form?.addEventListener('variant-change', getterRunFn(_reset_product_form_state, this, reset_product_form_state_fn).bind(this), { signal });
  }
  disconnectedCallback() {
    this.#controller.abort();
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || $4('.hdt-form__message-wrapper', this);
    //console.log('this.errorMessageWrapper', this.errorMessageWrapper, errorMessage)
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || $4('.hdt-error-message', this.errorMessageWrapper);

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
    if (errorMessage) this.errorMessage.textContent = errorMessage;
  }
  get form() {
    return getterGet(_product_form, this);
  }
  get cart() {
    return getterGet(_cart_drawer, this);
  }
};
on_submit_handler_fn =  async function(event) {
  event.preventDefault();
  if (this.form.checkBreak) return;
  if (!this.form.checkValidity()) {
    this.form.reportValidity();
    return;
  }
  this.submitButton.setAttribute("aria-disabled", true);
  this.submitButton.setAttribute("aria-busy", true);

  document.dispatchEvent(new CustomEvent(loadingStart));

  const formData = new FormData(this.form);
  if (this.cart) {
    formData.append('sections', this.cart?.sectionsToRender?.map(section => section.id) ?? ['cart-json']);
    // formData.append(
    //   'sections',
    //   this.cart.sectionsToRender.map((section) => section.id)
    // );
    //formData.append('sections_url', window.location.pathname);
    //this.cart.focusElement = document.activeElement;
  }
  const fetchCfg = fetchConfig('javascript', { body: formData }),
  response = await fetch(`${Shopify.routes.root}cart/add.js`, {
    ...fetchCfg,
    headers: {
      ...fetchCfg.headers,
      Accept: 'text/html',
    },
  });
  this.submitButton.removeAttribute("aria-disabled");
  this.submitButton.removeAttribute("aria-busy");
  const responseJson = await response.json();
  document.dispatchEvent(new CustomEvent(loadingEnd));
  if (responseJson.status) {
    //if (this.hideErrors) return;
    const {errors, description, message} = responseJson;
    this.form.dispatchEvent(new CustomEvent(cartError, {
      bubbles: true,
      detail: {
        source: 'product-form',
        errors: errors || description,
        message
      }
    }));
    if (!this.hideErrors) this.handleErrorMessage(description);

    // When we add more than the maximum amount of items to the cart, we need to dispatch a cart reload event
    // because our back-end still adds the max allowed amount to the cart.
    document.dispatchEvent(new CustomEvent(cartReload, {
      bubbles: true,
      detail: {
        variantId: formData.get('id')
      }
    }));
  } else {
    if (!this.hideErrors) this.handleErrorMessage();
    const cartData = Object.assign({}, responseJson, JSON.parse(responseJson.sections['cart-json'].split('[split_94]')[1] || '{}'));
    this.form.dispatchEvent(new CustomEvent(cartUpdate, {
      bubbles: true,
      detail: {
        source: 'product-form',
        actionAfterATC: formData.get("action_added"),
        variantId: formData.get('id'),
        cartData,
        formData: Object.fromEntries(formData.entries())
      }
    }));
  }
};
reset_product_form_state_fn = function(even) {
  this.handleErrorMessage();
};

class ProductFormBundle extends ProductForm {
  #controller;
  constructor() {
    super();
  }
  connectedCallback() {
    super.connectedCallback();
    this.#controller = new AbortController();

    this.form?.addEventListener('variant-bundle-change', getterRunFn(_reset_product_form_state, this, reset_product_form_state_fn).bind(this), { signal: this.#controller.signal });
    const $totalPrice = $4('[update-total-price]', this);
    if (!$totalPrice) return;
    let totalPrice = Number($totalPrice.dataset.price);
    let totalComparePrice = Number($totalPrice.dataset.cpprice);
    this.addEventListener("bundle:update-price", (event) => {
      //$$4('.hdt-bundle-product [name="items[][id]"]', this).forEach(()=> { });
      const { gapPrice , gapCpprice } = event.detail;
      // Update price
      totalPrice += gapPrice;
      totalComparePrice += gapCpprice;
      $4('hdt-compare-at-price', $totalPrice).toggleAttribute('hidden', totalComparePrice <= totalPrice);
      $4('hdt-compare-at-price .hdt-money', $totalPrice).outerHTML = `<span class="hdt-money">${currency.formatMoney(totalComparePrice)}</span>`;
      $4('hdt-price .hdt-money', $totalPrice).outerHTML = `<span class="hdt-money">${currency.formatMoney(totalPrice)}</span>`;
      document.dispatchEvent(new CustomEvent("currencyUpdate"));
    });
  }
  disconnectedCallback() {
    this.#controller.abort();
  }
};

var _update_product_bundle = new WeakSet(), update_product_bundle_fn;
// _hover_product_bundle = new WeakSet(), hover_product_bundle_fn,
// _hover_btn_bundle = new WeakSet(), hover_btn_bundle_fn,
// _hover_bundle_timer = new WeakMap(),
// _hover_bundle_timer2 = new WeakMap();
class ProductBundle extends HTMLElement {
  #controller;
  #hoverHandle;
  #hoverHandle2;
  #resize;
  constructor() {
    super();
    getterAdd(_update_product_bundle, this);
    // getterAdd(_hover_product_bundle, this);
    // getterAdd(_hover_btn_bundle, this);
    // getterAdd(_hover_bundle_timer, this, void 0);
    // getterAdd(_hover_bundle_timer2, this, void 0);
  }
  connectedCallback() {
    this.#controller = new AbortController();
    const selectElement = $4('select[name="items[][id]"]', this),
    butonHover = $4(`#${this.getAttribute('prefix')}`);
    if (selectElement) {
      // Store the initial value as the previous value
      this.prevOpt = $4(`option[value="${selectElement.value}"]`, selectElement);

      // Add event listener for change event
      selectElement.addEventListener('change', getterRunFn(_update_product_bundle, this, update_product_bundle_fn).bind(this), { signal: this.#controller.signal });
    }
    if (!butonHover) return;
    this.#resize = resize(this, () => {
      //console.log('resize product bundle', matchMediaQuery("hover"), matchMediaQuery("mobile"));
      if ( !matchMediaQuery("hover") || matchMediaQuery("mobile") ) {
        if (this.#hoverHandle) this.#hoverHandle();
        if (this.#hoverHandle2) this.#hoverHandle2();
        return;
      }
      this.#hoverHandle = hover(this, () => {
        this.toggle()
        return () => this.toggle(false)
      })
      this.#hoverHandle2 = hover(butonHover, () => {
        this.#hover()
        return () => this.#hover(false)
      })
    });
  }
  disconnectedCallback() {
    this.#controller.abort();
    if (this.#hoverHandle) this.#hoverHandle();
    if (this.#hoverHandle2) this.#hoverHandle2();
    if (this.#resize) this.#resize();
    //this.hoverHandle?.destroy();
    //this.butonHoverHandle?.destroy();
  }
  toggle(show = true) {
    const popover = $4(`#${this.getAttribute('prefix').replace('point-','popover-')}`);
    if (show) {
      if (!popover.btnOpening) popover.btnOpening = $4(`#${this.getAttribute('prefix')}`);
      popover.parentElement?.open();
    } else {
      popover.parentElement?.close();
    }
  }
  #hover(show = true) {
    this.toggle(show);
    $$4('.hdt-bundle-product', this.closest('.hdt-bundle-products')).forEach((bundle)=> {
      bundle.classList.toggle('hdt-bundle-product--selected', show && bundle == this);
      bundle.classList.toggle('hdt-bundle-product--fade', show && bundle != this);
    });
  }
};
update_product_bundle_fn = function(event) {
  const currentOpt = $4(`option[value="${event.target.value}"]`, event.target);
 let { src, cpprice, price, qty } = currentOpt.dataset;
  cpprice = Number(cpprice || price);
  price = Number(price);
  const imgEl = $4('[update-img]', this);
  if (imgEl) imgEl.src = src || event.target.dataset.src; // Update image
  $4('[update-qty]', this).value = qty; // Update qty
  // Update price
  $4('hdt-compare-at-price', this).toggleAttribute('hidden', cpprice <= price);
  $4('hdt-compare-at-price .hdt-money', this).outerHTML = `<span class="hdt-money">${currency.formatMoney(cpprice)}</span>`;
  $4('hdt-price .hdt-money', this).outerHTML = `<span class="hdt-money">${currency.formatMoney(price)}</span>`;

  // Trigger event
  let prev_cpprice = this.prevOpt.dataset.cpprice,
  prev_price = this.prevOpt.dataset.price;
  prev_cpprice = Number(prev_cpprice || prev_price);
  prev_price = Number(prev_price);
  let gapCpprice = Math.max(prev_cpprice, cpprice) - Math.min(prev_cpprice, cpprice);
  let gapPrice = Math.max(prev_price, price) - Math.min(prev_price, price);
  if (price < prev_price) {
    gapPrice = gapPrice * -1;
  }
  if (cpprice < prev_cpprice) {
    gapCpprice = gapCpprice * -1;
  }
  if (gapCpprice != 0 || gapPrice != 0) {
    this.closest('product-form-bundle')?.dispatchEvent(new CustomEvent("bundle:update-price", {
      detail: {
        action: gapPrice > 0 ? 'plus' : 'minus',
        gapCpprice,
        gapPrice
      }
    }));
  }

  // Update the previous value to the current value
  this.prevOpt = currentOpt;


  this.closest('form')?.dispatchEvent(new CustomEvent("variant-bundle-change", {
    bubbles: false,
    detail: { variantId: event.target.value }
  }));
};
// hover_product_bundle_fn = function(event) {
//   if (event.type === "mouseleave") {
//     clearTimeout(getterGet(_hover_bundle_timer, this));
//     this.toggle(false);
//   } else if (event.type === "mouseenter") {
//     getterAdd(_hover_bundle_timer, this, setTimeout(() => this.toggle(), 125), true);
//   }
// };
// hover_btn_bundle_fn = function(event) {
//   if (event.type === "mouseleave") {
//     clearTimeout(getterGet(_hover_bundle_timer2, this));
//     this.hover(false);
//   } else if (event.type === "mouseenter") {
//     getterAdd(_hover_bundle_timer2, this, setTimeout(() => this.hover(), 125), true);
//   }
// };

var _onOptionClicked, onOptionClicked_fn, _onKeyDown, onKeyDown_fn;
class Richlist extends HTMLElement {
  constructor() {
    super();
    getterAdd(_onOptionClicked, this);
    getterAdd(_onKeyDown, this);
    this.addEventListener("keydown", getterRunFn(_onKeyDown, this, onKeyDown_fn));
  }
  connectedCallback() {
    $$4('[role="option"]',this).forEach((option) => {
      option.addEventListener("click", getterRunFn(_onOptionClicked, this, onOptionClicked_fn).bind(this));
    });
  }
  static get observedAttributes() {
    return ["selected"];
  }
  /**
   * @param {string} value
   */
  set selected(value) {
    this.setAttribute("selected", value);
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "selected" && oldValue !== null && newValue !== oldValue) {
      $$4('[role="option"]',this).forEach((option) => {
        if (option.value === newValue) {
          option.setAttribute("aria-selected", "true");
          if (!this.hasAttribute('off-change-text')) {
            $$4(`[aria-owns="${this.id}"]`).forEach((btnOwn) => {
              const btnText = $4('[change-text]', btnOwn),
              _btnText = btnText || btnOwn;
              _btnText.textContent = $4('[get-text]', option)?.innerText || option.getAttribute("title") || option.innerText || option.value;
            });
          }
          option.dispatchEvent(new CustomEvent("richlist:change", {
            bubbles: true,
            detail: {
              value: option.value
            }
          }));
        } else {
          option.setAttribute("aria-selected", "false");
        }
      });
    }
  }

}
_onOptionClicked = new WeakSet();
onOptionClicked_fn = function(event) {
  //console.log(event)
  const value = event.currentTarget.value;
  this.selected = value;
  event.currentTarget.dispatchEvent(new CustomEvent("richlist:select", {
    bubbles: true,
    detail: { value }
  }));
};
_onKeyDown = new WeakSet();
onKeyDown_fn = function(event) {
  if (event.key === "ArrowUp") {
    event.target.previousElementSibling?.focus();
    event.preventDefault();
  } else if (event.key === "ArrowDown") {
    event.target.nextElementSibling?.focus();
    event.preventDefault();
  }
};
customElements.define("hdt-richlist", Richlist);

// https://web.dev/articles/building/a-loading-bar-component?hl=vi#overview
var _loading_bar_start = new WeakSet(), loading_bar_start_fn,
 _loading_bar_end = new WeakSet(), loading_bar_end_fn;
class LoadingBar extends HTMLElement {
  constructor() {
    super();
    styleEffect(this, {scaleX: motionValue(0) });
    getterAdd(_loading_bar_start, this);
    getterAdd(_loading_bar_end, this);
    document.addEventListener(loadingStart, getterRunFn(_loading_bar_start, this, loading_bar_start_fn).bind(this));
    document.addEventListener(loadingEnd, getterRunFn(_loading_bar_end, this, loading_bar_end_fn).bind(this));
  }
};
loading_bar_start_fn = function() {
  this.showPopover();
  animate([
    [this, { opacity: [0, 1] }, { duration: 0.25, ease: "easeIn" }],
    [this, { scaleX: [0, 0.9] }, { duration: 0.6, at: 0.2, ease: "linear" }]
  ]);
};
loading_bar_end_fn = function() {
  animate([
    [this, { scaleX: 1 }, { duration: 0.25, ease: "linear" }],
    [this, { opacity: 0 }, { duration: 0.25, ease: "easeIn" }]
  ]).then(() => {
    this.hidePopover();
  });
};
class RevealItems extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    if (matchMediaQuery("motion") && this.enabledReveal && $$4(this.selector, this).length > 0) {
    inView(this, this.reveal.bind(this));
    }
  }
  //disconnectedCallback() { }
  get selector() {
    const _selector = this.getAttribute('selector') || '.hdt-card-product';
    return (this.prependEl || '') + _selector + (this.appendEl || '').replaceAll(/nathan/g, _selector);
  }
  get enabledReveal() {
    return this.getAttribute('reveal-on-scroll') === 'true';
  }
  reveal() {
    animate(
      $$4(this.selector, this),
      {
        opacity: [0, 1],
        transform: ["translateY(30px)", "translateY(0)"],
      },
      {
        duration: 0.25,
        ease: [0.25, 0.1, 0.25, 1.0],
        delay: stagger(0.05, { startDelay: 0.3, ease: [0.25, 0.1, 0.25, 1.0] })
      }
  );
    // .then(() => {
    //   this.appendEl = '';
    // });
   // this.setEl = null;
    // .then(() => {
    //   this.setEl = null;
    // });
  }
}

customElements.define("hdt-buy-buttons", buyButtons);
customElements.define('hdt-quantity-wrapp', QuantityWrapp);
customElements.define('hdt-variant-picker', VariantPicker);
customElements.define('hdt-recipient-form', RecipientForm);
customElements.define("hdt-progress-bar", ProgressBar);
customElements.define("hdt-max-height", MaxHeight);
customElements.define("product-form", ProductForm);
customElements.define("product-form-bundle", ProductFormBundle);
customElements.define("hdt-loading-bar", LoadingBar);
customElements.define('hdt-bundle-product', ProductBundle);

// Free Shipping Bar - updates on PDP when cart changes
class FreeShippingBar extends HTMLElement {
  #controller;
  constructor() {
    super();
    this.#controller = new AbortController();
  }
  connectedCallback() {
    // Only listen for cart updates on product pages (not in cart drawer/page)
    if (!this.closest('#CartDrawer, #MainCart')) {
      document.addEventListener(cartUpdate, this.#handleUpdate.bind(this), { signal: this.#controller.signal });
    }
  }
  disconnectedCallback() {
    this.#controller.abort();
  }
  #handleUpdate(event) {
    const cartData = event.detail?.cartData;
    if (!cartData?.items) return;
    
    const progressBar = $4('.hdt-progress-bar', this);
    const msgElement = $4('.hdt-progress-msg', this);
    if (!progressBar) return;
    
    const shippingAmount = parseInt(progressBar.getAttribute('aria-valuemax'));
    if (!shippingAmount) return;
    
    // Calculate total price for items requiring shipping
    const totalPrice = cartData.items
      .filter(item => item.requires_shipping)
      .reduce((sum, item) => sum + (item.final_line_price || 0), 0);
    
    // Update progress bar value
    progressBar.setAttribute('aria-valuenow', totalPrice);
    
    // Calculate progress
    const progress = Math.min(1, totalPrice / shippingAmount);
    
    // Update state classes
    this.classList.remove('is-intial', 'is-unreached', 'is-success');
    if (progress <= 0.6) {
      this.classList.add('is-intial');
    } else if (progress >= 1) {
      this.classList.add('is-success');
    } else {
      this.classList.add('is-unreached');
    }
    
    // Update message text
    if (!msgElement) return;
    
    if (!window.themeHDN || !window.Shopify) return;
    
    const strings = themeHDN?.strings?.cart?.free_shipping_bar;
    if (!strings) return;
    
    const moneyNeeded = shippingAmount - totalPrice;
    
    // Match the same logic as the Liquid template
    if (progress === 0 && strings.intial_html) {
      const formatted = currency.formatMoney(shippingAmount);
      const newText = strings.intial_html.replace('__MONEY_PLACEHOLDER__', '<span class="hdt-money">' + formatted + '</span>');
      msgElement.innerHTML = newText;
    } else if (progress >= 1 && strings.success) {
      msgElement.textContent = strings.success;
    } else if (strings.unreached_html) {
      const formatted = currency.formatMoney(moneyNeeded);
      const newText = strings.unreached_html.replace('__MONEY_PLACEHOLDER__', '<span class="hdt-money">' + formatted + '</span>');
      msgElement.innerHTML = newText;
    }
  }
}
customElements.define('hdt-free-shipping-bar', FreeShippingBar);
customElements.define("hdt-reval-items", RevealItems);

var _update_product_info = new WeakSet(), update_product_info_fn;
class ProductUpdateInfo extends HTMLElement {
  #controller;
    constructor() {
      super();
      getterAdd(_update_product_info, this);
    }
  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.form?.addEventListener('product:updateInfo', getterRunFn(_update_product_info, this, update_product_info_fn).bind(this), { signal });
    this.form?.addEventListener('product:updateNow', (event) => {
      const sku = String(event.detail.variant?.sku || '');
      $$4('[data-accordion-sku]', this).forEach((element) => {
        element.textContent = sku;
      });
    }, { signal });
  }
  disconnectedCallback() {
    this.#controller.abort();
  }
  get form() {
    return document.forms[this.getAttribute("form")];
  }
};
update_product_info_fn = function(event) {
  const { sectionId, html, targetId } = event.detail,
  domFragment = $4(`#shopify-section-${sectionId}`, document.createRange().createContextualFragment(html)),
        scriptData  = $4('[data-type="variant-picker"] script[data-selected-variant]', domFragment),
        variant     = JSON.parse(scriptData?.textContent || "{}"),
        types       = ["price", "badges", "sku", "inventory", "payment-terms", "pickup-availability", "liquid", "category-field", "metafield-text"];
  if (variant) variant.valuesID = JSON.parse(scriptData?.dataset?.selectedVariant || "[]");
  types.forEach((type) => {
    const strBlock = `.hdt-product-info__item[data-type="${type}"]`,
    domBlocksType = $$4(strBlock, domFragment);
    $$4(strBlock, this).forEach((block, index) => {
      const blockReplace = domBlocksType[index];
      if (!blockReplace) return;
      // if (type === "variant-picker" || type === "buy-buttons") {
      //   if (type === "buy-buttons") $4('[name="id"]', block).value = variant.id;
      //   $4(`hdt-${type}`, block).replaceWith($4(`hdt-${type}`, blockReplace));
      //   if (type === "buy-buttons") {
      //     Shopify?.PaymentButton?.init();
      //   }
      //   // else {
      //   //   $4('.hdt-modal__size-chart', block)?.parentElement?.replaceWith($4('.hdt-modal__size-chart', blockReplace).parentElement);
      //   // }
      // } else
      if (type === "quantity-selector") {
        block.replaceWith(blockReplace);
        $4("hdt-quantity-wrapp", blockReplace).qty = $4("hdt-quantity-wrapp", block).qty;
      } else {
        block.replaceWith(blockReplace)
      }
    });
  });
  const mediaBadgesSelector = "[data-product-media-badges]",
        mediaBadges = $4(mediaBadgesSelector, document.getElementById(`shopify-section-${sectionId}`)),
        updatedMediaBadges = $4(mediaBadgesSelector, domFragment);
  if (mediaBadges && updatedMediaBadges) mediaBadges.replaceWith(updatedMediaBadges);
  // Focus input radio
  //$4(`#${targetId}`)?.focus();
  this.form?.dispatchEvent(new CustomEvent("variant-change", {
    bubbles: true,
    detail: {
      sectionId,
      html,
      variant
    }
  }));
};
customElements.define('hdt-product-observe', ProductUpdateInfo);

/**
* 9. Product card
* -----------------------------------------------------------------------------
*/

const MediaVisibilityContext = (() => {
  const pendingKey = 'hdt:media-visibility-context:pending';
  const maxPendingAge = 30000;

  const splitList = (value) => String(value || '')
    .split('||')
    .map((item) => item.trim().toLowerCase())
    .filter(Boolean);

  const splitHandles = (value) => String(value || '')
    .split('|')
    .map((item) => item.trim())
    .filter(Boolean);

  const productHandleFromUrl = (rawUrl) => {
    try {
      const url = new URL(rawUrl, window.location.origin);
      const match = url.pathname.match(/\/products\/([^/]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (_) {
      return '';
    }
  };

  const belongsToContext = (element, context) => {
    const productHandles = splitHandles(element?.dataset.productCollectionHandles);
    const contextHandles = context?.collectionHandles?.length
      ? context.collectionHandles
      : [context?.collectionHandle].filter(Boolean);
    return contextHandles.some((handle) => productHandles.includes(handle));
  };

  const normalize = (context) => {
    if (!context?.collectionHandle) return null;
    return {
      collectionHandle: String(context.collectionHandle),
      collectionTitle: String(context.collectionTitle || ''),
      collectionUrl: String(context.collectionUrl || ''),
      collectionHandles: Array.isArray(context.collectionHandles)
        ? context.collectionHandles.map((handle) => String(handle).trim()).filter(Boolean)
        : splitHandles(context.collectionHandles || context.collectionHandle),
      hideSuffixes: Array.isArray(context.hideSuffixes)
        ? context.hideSuffixes.map((suffix) => String(suffix).trim().toLowerCase()).filter(Boolean)
        : splitList(context.hideSuffixes),
      targetProductHandle: String(context.targetProductHandle || ''),
      createdAt: Number(context.createdAt || Date.now())
    };
  };

  const current = () => normalize(history.state?.mediaVisibilityContext);

  const applyBreadcrumb = (context) => {
    if (!context?.collectionUrl) return;
    const breadcrumbCurrent = document.querySelector('[data-product-breadcrumb-current]');
    if (!breadcrumbCurrent) return;
    const normalizePath = (rawUrl) => {
      try {
        const url = new URL(rawUrl, window.location.origin);
        return url.pathname.replace(/\/$/, '');
      } catch (_) {
        return String(rawUrl || '').replace(/\/$/, '');
      }
    };
    const contextPath = normalizePath(context.collectionUrl);
    const template = [...document.querySelectorAll('template[data-product-breadcrumb-template]')]
      .find((item) => normalizePath(item.dataset.collectionUrl) == contextPath);
    let content = template?.content.cloneNode(true);
    if (!content) {
      const fallback = document.querySelector('template[data-product-breadcrumb-fallback]');
      content = fallback?.content.cloneNode(true);
      const link = content?.querySelector('a');
      if (link) {
        link.href = context.collectionUrl;
        link.textContent = context.collectionTitle || context.collectionHandle;
      }
    }
    if (!content) return;
    document.querySelectorAll('[data-product-breadcrumb-context-item]').forEach((item) => item.remove());
    breadcrumbCurrent.before(content);
  };

  const fromElement = (element) => {
    if (!element) return null;
    const directSource = element.closest('[data-media-visibility-link]');
    if (directSource?.dataset.mediaVisibilityCollection) {
      const context = normalize({
        collectionHandle: directSource.dataset.mediaVisibilityCollection,
        collectionTitle: directSource.dataset.mediaVisibilityCollectionTitle,
        collectionUrl: directSource.dataset.mediaVisibilityCollectionUrl,
        collectionHandles: directSource.dataset.mediaVisibilityCollectionHandles,
        hideSuffixes: directSource.dataset.mediaVisibilitySuffixes
      });
      if (!context || (directSource.dataset.productCollectionHandles && !belongsToContext(directSource, context))) return null;
      return context;
    }

    const card = element.closest('hdt-card-product');
    if (element.closest('[data-media-context-product], .hdt-linked-product-option, [data-custom-color-variant]')) {
      let context = null;
      if (card?.dataset.mediaVisibilityEligible == 'true' && card.dataset.mediaVisibilityCollection) {
        context = normalize({
          collectionHandle: card.dataset.mediaVisibilityCollection,
          collectionTitle: card.dataset.mediaVisibilityCollectionTitle,
          collectionUrl: card.dataset.mediaVisibilityCollectionUrl,
          collectionHandles: card.dataset.mediaVisibilityCollectionHandles,
          hideSuffixes: card.dataset.mediaVisibilitySuffixes
        });
      } else {
        context = current();
      }
      return context && belongsToContext(element, context) ? context : null;
    }

    if (card?.dataset.mediaVisibilityEligible == 'true' && card.dataset.mediaVisibilityCollection) {
      const context = normalize({
        collectionHandle: card.dataset.mediaVisibilityCollection,
        collectionTitle: card.dataset.mediaVisibilityCollectionTitle,
        collectionUrl: card.dataset.mediaVisibilityCollectionUrl,
        collectionHandles: card.dataset.mediaVisibilityCollectionHandles,
        hideSuffixes: card.dataset.mediaVisibilitySuffixes
      });
      return context && belongsToContext(card, context) ? context : null;
    }

    return null;
  };

  const prepareNavigation = (element, rawUrl) => {
    const context = fromElement(element);
    const targetProductHandle = productHandleFromUrl(rawUrl);
    if (!context || !targetProductHandle) return false;
    sessionStorage.setItem(pendingKey, JSON.stringify({
      ...context,
      targetProductHandle,
      createdAt: Date.now()
    }));
    return true;
  };

  const resolveForProduct = (element) => {
    const productHandle = element?.dataset.productHandle || productHandleFromUrl(window.location.href);
    const pageProductHandle = productHandleFromUrl(window.location.href);
    const stateContext = current();
    if (stateContext && stateContext.targetProductHandle == productHandle && belongsToContext(element, stateContext)) {
      queueMicrotask(() => applyBreadcrumb(stateContext));
      return stateContext;
    }

    let pendingContext = null;
    try {
      pendingContext = normalize(JSON.parse(sessionStorage.getItem(pendingKey) || 'null'));
    } catch (_) {
      pendingContext = null;
    }
    if (!pendingContext || Date.now() - pendingContext.createdAt > maxPendingAge || pendingContext.targetProductHandle != pageProductHandle) {
      sessionStorage.removeItem(pendingKey);
      return null;
    }
    if (pendingContext.targetProductHandle != productHandle) return null;
    sessionStorage.removeItem(pendingKey);
    if (!belongsToContext(element, pendingContext)) return null;

    const nextState = history.state && typeof history.state == 'object' ? history.state : {};
    history.replaceState({ ...nextState, mediaVisibilityContext: pendingContext }, '', window.location.href);
    queueMicrotask(() => applyBreadcrumb(pendingContext));
    return pendingContext;
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (link) prepareNavigation(link, link.href);
  }, true);
  document.addEventListener('pointerdown', (event) => {
    if (event.button != 0 && event.button != 1) return;
    const link = event.target.closest('a[href]');
    if (link) prepareNavigation(link, link.href);
  }, true);
  document.addEventListener('auxclick', (event) => {
    if (event.button != 1) return;
    const link = event.target.closest('a[href]');
    if (link) prepareNavigation(link, link.href);
  }, true);

  const applyCurrentBreadcrumb = () => applyBreadcrumb(current());
  if (document.readyState == 'loading') {
    document.addEventListener('DOMContentLoaded', applyCurrentBreadcrumb, { once: true });
  } else {
    queueMicrotask(applyCurrentBreadcrumb);
  }

  return { current, fromElement, prepareNavigation, resolveForProduct };
})();

var cacheUrlVariant = {};
const PRODUCT_CARD_DEBUG = true;
const updateProductCardPrice = (productCard, priceData) => {
  const priceWrapper = productCard && $4('.hdt-price-wrapp', productCard);
  const price = Number(priceData?.price);
  const compareAtPrice = Number(priceData?.compareAt || 0);
  if (!priceWrapper || !Number.isFinite(price) || price <= 0 || typeof currency === 'undefined' || !currency.formatMoney) return;

  const priceMoney = $4('hdt-price .hdt-money', priceWrapper);
  const compareMoney = $4('hdt-compare-at-price .hdt-money', priceWrapper);
  const compareElement = $4('hdt-compare-at-price', priceWrapper);
  if (priceMoney) priceMoney.outerHTML = `<span class="hdt-money">${currency.formatMoney(price)}</span>`;
  if (compareMoney && compareAtPrice > price) compareMoney.outerHTML = `<span class="hdt-money">${currency.formatMoney(compareAtPrice)}</span>`;
  compareElement?.toggleAttribute('hidden', !(compareAtPrice > price));
};
var UrlWithVariant = class {
  static get(url, id) {
    if (!url || !id)  return;
    if (cacheUrlVariant[id]) {
      return cacheUrlVariant[id];
    }
    url = new URL(url);
    url.searchParams.set("variant", id);
    return cacheUrlVariant[id] = url.toString();
  }
};
var _color_action_all = new WeakSet(), color_action_all_fn,
_color_auto_limit = new WeakSet(), color_auto_limit_fn,
_color_changed_data = new WeakSet(), color_changed_data_fn,
_color_on_hovered = new WeakSet(), color_on_hovered_fn,
_create_img = new WeakSet(), create_img_fn,
_color_slider = new WeakMap(),
_color_links = new WeakMap(),
_color_media_main = new WeakMap();
class Swatches extends HTMLElement {
  #controller
  constructor() {
    super();
    getterAdd(_color_action_all, this);
    getterAdd(_color_auto_limit, this);
    getterAdd(_create_img, this);
    getterAdd(_color_changed_data, this);
    getterAdd(_color_on_hovered, this);
    getterAdd(_color_slider, this, this.closest('.hdt-slider'));
    const product = this.closest('hdt-card-product');
    getterAdd(_color_links, this, $$4('[data-pr-url]', product));
    getterAdd(_color_media_main, this, $4('.hdt-card-product__media--main', product) || $4('hdt-card-product-media .hdt-slider__slide:not([hidden]) img', product));
  }
  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;

    if (this.hasAttribute('auto-limit')) {
      if (window.ResizeObserver) {
        let resizeObserver = new ResizeObserver(throttle(getterRunFn(_color_auto_limit, this, color_auto_limit_fn).bind(this)));
        resizeObserver.observe(this);
        this.addEventListener('unobserve', ()=> { resizeObserver.unobserve(this); resizeObserver = null });
      } else {
        getterRunFn(_color_auto_limit, this, color_auto_limit_fn).call(this);
      }
    }
    if (this.hasAttribute('action-all')) {
      $4('.is--color-link', this)?.addEventListener("click", getterRunFn(_color_action_all, this, color_action_all_fn).bind(this), { signal });
    }
    if (PRODUCT_CARD_DEBUG) {
      this.addEventListener('click', (event) => {
        const label = event.target.closest('label');
        const radio = label?.control || event.target.closest('[type="radio"]');
        if (!label && !radio) return;
        const productCard = this.closest('hdt-card-product');
        console.log('[ProductCard] Swatch clicked', {
          productHandle: productCard?.dataset.productHandle,
          swatchWrapper: this,
          swatchId: radio?.name,
          swatchValue: radio?.value || label?.dataset.color,
          radioFound: Boolean(radio),
          disabled: radio?.disabled,
          checkedBeforeClick: radio?.checked,
          id: radio?.id,
          url: radio?.dataset.url,
          linkedProductId: radio?.dataset.linkedProductId,
          variantId: radio?.dataset.vid,
          variantImage: radio?.dataset.vimg,
          labelClasses: label?.className,
          eventTarget: event.target
        });
        if (radio?.disabled) console.warn('[ProductCard] Click landed on a disabled swatch');
        if (radio?.checked && !radio.disabled) {
          radio.dispatchEvent(new Event('change', { bubbles: false }));
          if (PRODUCT_CARD_DEBUG) console.log('[ProductCard] Re-applied active swatch selection');
        }
      }, { capture: true, signal });
    }
    if (PRODUCT_CARD_DEBUG) {
      const disabledSwatches = $$4('[type="radio"][disabled]', this);
      if (disabledSwatches.length) console.warn('[ProductCard] Disabled swatches', {
        productHandle: this.closest('hdt-card-product')?.dataset.productHandle,
        disabledCount: disabledSwatches.length,
        values: disabledSwatches.map((radio) => ({ value: radio.value, id: radio.id }))
      });
    }

    if ($$4('[type="radio"]:not([disabled])', this).length == 0 ) return;

    // change/preload
    $$4('[type="radio"]', this).forEach( (radio) => {
      radio.addEventListener("change", getterRunFn(_color_changed_data, this, color_changed_data_fn).bind(this), { signal });
    });
    $$4('[type="radio"][data-vimg] + label', this).forEach( (label) => {
      label.addEventListener("pointerover", getterRunFn(_color_on_hovered, this, color_on_hovered_fn).bind(this), { signal });
    });

    // Hover trigger event change
    if (!matchMediaQuery("mobile") && this.getAttribute('event') == 'hover') {
      let timeOut;
      $$4('[type="radio"] + label', this).forEach( (label) => {
        hover(label, () => {
          clearTimeout(timeOut);
          timeOut = setTimeout(() => {
            const radio = label.previousElementSibling;
            radio.checked = true;
            radio.dispatchEvent(new CustomEvent("change", { bubbles: false }))
          }, 100);
        })
      });
    }
  }
  disconnectedCallback() {
    this.#controller.abort();
  }
  set mediaMain(value) {
    getterAdd(_color_media_main, this, value, true);
  }
  get mediaMain() {
    return getterGet(_color_media_main, this);
  }
};
color_auto_limit_fn = function() {
  if (this.isReflow) return;
  const Linka =  $4('.is--color-link a', this);
  $4('.is--color-limit', this)?.classList.remove('is--color-limit');
  const widthLink = $4('.is--color-link', this)?.clientWidth || 0,
  notNeedLimit = (this.scrollWidth - widthLink ) <= this.clientWidth;
  this.setAttribute('no-limit', notNeedLimit.toString());

  if (notNeedLimit) return;

  this.isReflow = true;
  const widthColor = $4('.hdt-color-list__item', this).clientWidth,
  colorsCanShow = Math.floor((this.clientWidth  - widthLink) / widthColor);

  $$4('.hdt-color-list__item', this)[colorsCanShow]?.classList.add('is--color-limit');
  if (Linka) Linka.textContent = `+${this.firstElementChild.childElementCount - 1 - colorsCanShow}`;

  setTimeout( ()=> {
    this.isReflow = false;
  }, 60)

};
color_action_all_fn = async function(e) {
  e.preventDefault();
  this.dispatchEvent(new CustomEvent("unobserve", { cancelable: true, composed: true }));
  this.firstElementChild.lastElementChild.setAttribute('hidden', '');
  const $colors = $$4('.is--color-limit, .is--color-limit ~ .hdt-color-list__item:not(.is--color-link)', this),
  focusEl = $4('.is--color-limit', this).nextElementSibling;
  this.style.overflow = 'hidden';
  this.style.height = this.clientHeight + 'px';
  this.isReflow = true;
  focusEl.previousElementSibling.classList.remove('is--color-limit');
  this.removeAttribute('auto-limit');

  animate($colors, { opacity: 0 }, { duration: 0 })
  await animate(this, { height: [`${this.clientHeight}px`, `${this.scrollHeight}px`] }, { duration: getterGet(_color_slider, this) && getterGet(_color_slider, this).isActive ? 0 : 0.25 });

  this.style.height = null;
  this.style.overflow = null;
  this.isReflow = false;
  // Reint slider
  getterGet(_color_slider, this)?.reInit();
  animate(
    $colors,
    { opacity: [0, 1], transform: ["scale(.5) translateY(10px)", "scale(1) translateY(0)"] },
    { duration: 0.35, at: "-0.1", delay: stagger($colors.length > 25 ? 0 : 0.01, { ease: "easeOut" }), ease: [0.25, 0.1, 0.25, 1.0] }
  ).then(() => {
    //getterGet(_color_slider, this)?.reInit();
  });

  // Focus
  $4('input', focusEl)?.focus();

};
_create_img = new WeakSet();
create_img_fn = function(vimg) {
  return createImg({
    src: vimg,
    width: this.mediaMain.getAttribute('width'),
    height: this.mediaMain.getAttribute('height'),
    alt: this.mediaMain.alt,
    onload: true,
    attrs: {
      class: this.mediaMain.className,
      sizes: this.mediaMain.sizes,
      'data-widths': this.mediaMain.getAttribute('data-widths') || '[]'
    }
  })
};
color_changed_data_fn = function(event) {
  const {vid,vimg,url} = event.target.dataset;
  const linkedProductId = event.target.dataset.linkedProductId;
  const productCard = this.closest('hdt-card-product');
  const media = productCard && $4('hdt-card-product-media', productCard);

  if (PRODUCT_CARD_DEBUG) {
    console.groupCollapsed('[ProductCard] Swatch changed');
    console.log({
      productId: productCard?.dataset.selectedVariantId,
      productHandle: productCard?.dataset.productHandle,
      swatchValue: event.target.value,
      linkedProductId,
      url,
      variantId: vid,
      variantImage: vimg,
      mediaMode: media?.activeMode,
      sliderFound: Boolean(media?.slider)
    });
  }

  let linkedMediaUpdated = false;
  if (linkedProductId && media) {
    const template = $4(`template[data-card-linked-media="${linkedProductId}"]`, productCard);
    const container = media.slider
      ? $4('.hdt-slider__container', media)
      : $4('.hdt-card-product__media-wrapp', media);
    if (PRODUCT_CARD_DEBUG) console.log('[ProductCard] Linked media template', {
      found: Boolean(template),
      containerFound: Boolean(container),
      templateMediaCount: template?.content?.querySelectorAll('[data-media-id]').length || 0,
      selectedSku: template?.dataset.linkedSku,
      featuredMediaId: template?.dataset.featuredMediaId
    });
    if (template && container) {
      container.replaceChildren(...template.content.cloneNode(true).childNodes);
      media.setAttribute('data-selected-sku', template.dataset.linkedSku || '');
      media.selectVariant(template.dataset.linkedSku || '', template.dataset.featuredMediaId || '');
      productCard.dataset.productHandle = template.dataset.productHandle || productCard.dataset.productHandle;
      productCard.dataset.productCollectionHandles = template.dataset.productCollectionHandles || '';
      productCard.dataset.mediaVisibilityEligible = template.dataset.mediaVisibilityEligible || 'false';
      const selectedImage = media.slider
        ? $4('.hdt-slider__slide:not([hidden]) img', media)
        : $4('img.hdt-card-product__media--main', media);
      if (selectedImage) getterAdd(_color_media_main, this, selectedImage, true);
      linkedMediaUpdated = true;
    }
  }

  // Update badges for the selected linked product as well as its media.
  if (linkedProductId && productCard) {
    const badgeWrapper = $4('.hdt-badge__wrapp', productCard);
    const badgeTemplate = $4(`template[data-card-linked-badges="${linkedProductId}"]`, productCard);
    if (badgeWrapper && badgeTemplate) {
      const linkedBadgeWrapper = $4('.hdt-badge__wrapp', badgeTemplate.content);
      // Template nodes are a source for every swatch change. Clone them before
      // inserting, otherwise selecting this color again leaves its template empty.
      badgeWrapper.replaceChildren(...(linkedBadgeWrapper ? [...linkedBadgeWrapper.cloneNode(true).childNodes] : []));
      badgeWrapper.toggleAttribute('hidden', badgeWrapper.children.length == 0);
    }

    const sizesWrapper = $4('[data-card-product-sizes]', productCard);
    const sizesTemplate = $4(`template[data-card-linked-sizes="${linkedProductId}"]`, productCard);
    if (sizesWrapper && sizesTemplate) {
      sizesWrapper.replaceChildren(...sizesTemplate.content.cloneNode(true).childNodes);
    }
  }

  // Update variant url
  const cardLinks = productCard ? $$4('[data-pr-url]', productCard) : getterGet(_color_links, this);
  if (cardLinks.length > 0) {
    const newUrl = url || UrlWithVariant.get((getterGet(_color_links, this)[0] || cardLinks[0]).href, vid);
    cardLinks.forEach((link) => { link.href = newUrl });
    if (PRODUCT_CARD_DEBUG) console.log('[ProductCard] Links updated', { newUrl, linkCount: cardLinks.length });
  }

  // Update image
  if (!linkedMediaUpdated && vimg && this.mediaMain && vimg !== this.mediaMain.getAttribute('src')) {
    const newImg = getterRunFn(_create_img, this, create_img_fn).call(this, vimg);
    this.mediaMain.parentElement.removeAttribute('loaded');
    this.mediaMain.parentElement.setAttribute('loading', '');
    this.mediaMain.replaceWith(newImg);
    this.mediaMain = newImg;
    if (PRODUCT_CARD_DEBUG) console.log('[ProductCard] Main image updated', { image: vimg });
  }

  // Update product card price without fetching the linked product again.
  updateProductCardPrice(productCard, event.target.dataset);

  // Keep the product-card add form in sync with color/linked-product changes.
  if (productCard && vid) {
    productCard.dataset.selectedVariantId = vid;
    const addVariantInput = $4('[data-card-add-variant-id]', productCard);
    if (addVariantInput) addVariantInput.value = vid;
  }
  if (productCard && event.target.dataset.productHandle) {
    const quickViewButton = $4('[aria-controls="hdt-quick-view-modal"]', productCard);
    quickViewButton?.setAttribute('handle', event.target.dataset.productHandle);
  }

  if (PRODUCT_CARD_DEBUG) console.groupEnd();

};
color_on_hovered_fn = function(event) {
  const radio = event.target.previousElementSibling;
  if (!radio ) return;
  const {vimg} = radio.dataset;
  // Preload image
  if ( vimg !== this.mediaMain.getAttribute('src')) getterRunFn(_create_img, this, create_img_fn).call(this, vimg);
};
customElements.define('wrapp-hdt-swatches', Swatches);

class CardProductMedia extends HTMLElement {
  connectedCallback() {
    frame.render(() => {
      this.selectVariant(this.dataset.selectedSku || '', this.dataset.featuredMediaId || '');
    });
  }
  get mode() {
    return this.getAttribute('mode');
  }
  get activeMode() {
    return matchMedia('(max-width: 767px)').matches
      ? this.getAttribute('mobile-mode')
      : this.mode;
  }
  get slider() {
    return $4('hdt-slider', this);
  }
  selectVariant(sku, featuredMediaId = '') {
    const selectedSku = String(sku || '').trim();
    const sliderMode = this.activeMode == 'slider';
    const mediaItems = this.slider
      ? $$4('.hdt-slider__slide[data-media-id]', this)
      : $$4('img[data-media-id]', this);
    const featuredItem = mediaItems.find((media) => media.dataset.mediaId == String(featuredMediaId) && media.dataset.visibilityRuleHidden != 'true');
    let visibleItems = mediaItems.filter((media) => {
      if (media.dataset.visibilityRuleHidden == 'true') return false;
      const mediaSku = (media.dataset.mediaSku || '').trim();
      return media == featuredItem || mediaSku == '' || mediaSku.toLowerCase() == 'all' || mediaSku == selectedSku;
    });
    if (visibleItems.length == 0) {
      const fallbackItem = mediaItems.find((media) => media.dataset.visibilityRuleHidden != 'true');
      if (fallbackItem) visibleItems = [fallbackItem];
    }
    const primaryItem = featuredItem || visibleItems[0];
    visibleItems.sort((a, b) => {
      const priority = (media) => {
        if (media == primaryItem) return 0;
        const mediaSku = (media.dataset.mediaSku || '').trim();
        return mediaSku == selectedSku && mediaSku != '' ? 1 : 2;
      };
      return priority(a) - priority(b);
    });

    if (sliderMode) {
      mediaItems.forEach((media) => media.toggleAttribute('hidden', !visibleItems.includes(media)));
      $4('.hdt-card-product__media-nav', this)?.toggleAttribute('hidden', visibleItems.length < 2);
      const hiddenItems = mediaItems.filter((media) => !visibleItems.includes(media));
      const parent = mediaItems[0]?.parentElement;
      if (parent) [...visibleItems, ...hiddenItems].forEach((media) => parent.append(media));
      frame.render(() => {
        const slider = this.slider;
        if (typeof slider?.reInit == 'function') {
          slider.reInit({ startIndex: 0 });
        } else if (typeof slider?.apiS?.reInit == 'function') {
          slider.apiS.reInit();
          slider.apiS.scrollTo?.(0, true);
        } else if (slider) {
          // Related collection blocks can connect before their nested slider.
          // Re-run once the slider API is available so all matching media become slides.
          slider.addEventListener('init', () => {
            this.selectVariant(selectedSku, featuredMediaId);
          }, { once: true });
        }
      });
      return;
    }

    const getMediaSource = (media) => {
      const image = media.matches('img') ? media : $4('img', media);
      return image?.getAttribute('src') || '';
    };
    const primarySource = getMediaSource(primaryItem);
    const secondaryItem = this.activeMode == 'hover'
      ? visibleItems.find((media) => media != primaryItem && getMediaSource(media) != primarySource)
      : undefined;
    mediaItems.forEach((media) => {
      const isVisible = media == primaryItem || media == secondaryItem;
      media.toggleAttribute('hidden', !isVisible);
      media.classList.toggle('hdt-card-product__media--main', media == primaryItem);
      media.classList.toggle('hdt-card-product__media--hover', media == secondaryItem);
    });
  }
}
customElements.define('hdt-card-product-media', CardProductMedia);

class CardProduct extends HTMLElement {
  connectedCallback() {
    const syncSelectedVariant = () => {
      const selectedVariantId = String(this.dataset.selectedVariantId || '');
      const selectedButton = $$4('[data-card-variant-select]', this)
        .find((button) => button.dataset.variantId == selectedVariantId);
      if (!selectedButton) return;
      this.#setSelectedSize(selectedButton);
      this.#updateVariantBadges(selectedVariantId);
      const media = $4('hdt-card-product-media', this);
      media?.selectVariant(
        selectedButton.dataset.variantSku,
        selectedButton.dataset.featuredMediaId
      );
    };

    frame.render(syncSelectedVariant);

    // Related collections use an outer slider only above its column limit.
    // Its init timing must not change the card's selected size or media state.
    const collectionSlider = this.closest('hdt-slider-reveal');
    if (collectionSlider) {
      ['init', 'reInit'].forEach((eventName) => {
        collectionSlider.addEventListener(eventName, () => frame.render(syncSelectedVariant), { once: eventName == 'init' });
      });
    }

    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-card-variant-select]');
      if (!button || !this.contains(button)) return;
      event.preventDefault();
      this.#setSelectedSize(button);
      this.dataset.selectedVariantId = button.dataset.variantId;
      const addVariantInput = $4('[data-card-add-variant-id]', this);
      if (addVariantInput) addVariantInput.value = button.dataset.variantId;
      $$4('[data-pr-url]', this).forEach((link) => {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('variant', button.dataset.variantId);
        link.href = url.toString();
      });
      this.#updateVariantBadges(button.dataset.variantId);
      updateProductCardPrice(this, button.dataset);
      $4('hdt-card-product-media', this)?.selectVariant(button.dataset.variantSku, button.dataset.featuredMediaId);
    });
  }
  #setSelectedSize(button) {
    $$4('[data-card-variant-select]', this).forEach((sizeButton) => {
      const isSelected = sizeButton == button;
      sizeButton.classList.toggle('is-selected', isSelected);
      sizeButton.setAttribute('aria-pressed', isSelected.toString());
    });
  }
  #updateVariantBadges(variantId) {
    const wrapper = $4('.hdt-badge__wrapp', this);
    const template = $4(`template[data-card-variant-badges="${variantId}"]`, this);
    if (!wrapper || !template) return;
    $$4('[data-card-variant-badge]', wrapper).forEach((badge) => badge.remove());
    wrapper.append(template.content.cloneNode(true));
    wrapper.toggleAttribute('hidden', wrapper.children.length == 0);
  }
}
customElements.define('hdt-card-product', CardProduct);

var _btns_tab_collection = new WeakMap(),
_products_tab_collection = new WeakMap(),
_is_ink_bar_tab_collection = new WeakMap(),
_link_tab_collection = new WeakMap(),
_resize_tab_collection = new WeakMap(),
_set_active_tab = new WeakSet(), set_active_tab_fn;
class tabCollection extends HTMLElement {
  #controller;
  constructor() {
    super();
    this.index = 0;
    getterAdd(_btns_tab_collection, this, $$4("button", this));
    getterAdd(_products_tab_collection, this, $$4(".hdt-collections__product", this.closest('.hdt-section')));
    getterAdd(_is_ink_bar_tab_collection, this, this.hasAttribute("ink-bar"));
    getterAdd(_link_tab_collection, this, $4(`#${this.getAttribute('link-id')}`, this.closest('.hdt-section')));
    getterAdd(_set_active_tab, this);

    // Set the initial position of the ink bar
    if (getterGet(_is_ink_bar_tab_collection, this)) {
      getterRunFn(_set_active_tab, this, set_active_tab_fn).call(this, null);
      if (window.ResizeObserver) {
        getterAdd(_resize_tab_collection, this, new ResizeObserver(throttle(getterRunFn(_set_active_tab, this, set_active_tab_fn).bind(this, null))) );
        getterGet(_resize_tab_collection, this).observe(this);
      }
    }
  }
  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.btns.forEach((btn, index) => {
      btn.addEventListener("click", getterRunFn(_set_active_tab, this, set_active_tab_fn).bind(this, btn, index), { signal });
    });
    if (Shopify.designMode) {
      //this.addEventListener(admEvts.seLoad, () => { getterRunFn(_set_active_tab, this, set_active_tab_fn).call(this, null) }, { signal });
      this.addEventListener(admEvts.select, (event) => { event?.target?.click(); }, { signal });
    }
  }
  disconnectedCallback() {
    this.#controller.abort();
  }
  openDetails() {}
  get selectedReturn() {
    return true
  }
  get tabs() {
    return getterGet(_products_tab_collection, this);
  }
  get btns() {
    return getterGet(_btns_tab_collection, this);
  }
};
set_active_tab_fn = function(btn, index) {
  if (btn && btn.getAttribute("aria-selected") == 'true' && this.selectedReturn) return;
  if (!btn) {
    btn = this.btns[this.index];
    index = this.index
  }
  this.openDetails(btn, index);
  this.btns.forEach((btn) => {
    btn.setAttribute("aria-selected", btn === this.btns[index]);
  });
  this.tabs.forEach((item) => {
    item.setAttribute("hidden", "");
    item.classList.remove("is-selected");
  });
  let itemActive = this.tabs[index];
  if (this.index == index) {
    itemActive.removeAttribute("hidden");
    itemActive.classList.add("is-selected");
    //try { $4('.hdt-slider', itemActive)?.reveal(); } catch (error) {}
  } else {
    let itemPrevActive = this.tabs[this.index];
    itemPrevActive.removeAttribute("hidden");
    animate(itemPrevActive, { opacity: [1, 0], y: [0, 30] }, { duration: 0.35, ease: "easeIn" }).then(() => {
      itemPrevActive.setAttribute("hidden", "");
      itemActive.removeAttribute("hidden");
      itemActive.classList.add("is-selected");
      //console.log(itemActive, itemActive.clientHeight, itemActive.scrollHeight)
      //try { $4('.hdt-slider', itemActive)?.reveal(); } catch (error) {}
      animate(itemActive, { opacity: [0, 1], y: [30, 0] }, { duration: 0.35, ease: "easeOut" });
    });
  }
  this.index = index;

  if (getterGet(_link_tab_collection, this)) getterGet(_link_tab_collection, this).href = btn.dataset.url;

  if (!getterGet(_is_ink_bar_tab_collection, this)) return;
  this.style.setProperty("--ink-bar-w", `${btn.offsetWidth}px`);
  this.style.setProperty("--ink-bar-x", `${btn.offsetLeft}px`);
  this.style.setProperty("--ink-bar-y", `${btn.offsetTop + btn.offsetHeight - 1}px`);
};
var _summary_tab_collection = new WeakMap();
class detailsCollection extends tabCollection {
  #controller;
  constructor() {
    super();
    getterAdd(_summary_tab_collection, this, $4('summary', this));
  }
  connectedCallback() {
    this.#controller = new AbortController();
    getterGet(_summary_tab_collection, this).addEventListener("click", (event) => {
      event.preventDefault();
      if (!this.firstElementChild.hasAttribute("open")) {
        this.aniOpen();
      } else {
        this.aniClose();
      }
    }, {signal: this.#controller.signal});
    super.connectedCallback();
  }
  disconnectedCallback() {
    this.#controller.abort();
  }
  get selectedReturn() {
    return false
  }
  get summaryFirstChild() {
    return getterGet(_summary_tab_collection, this).firstElementChild;
  }
  openDetails(btn) {
    animate(this.summaryFirstChild, { opacity: [1, 0], transform: ["translateY(0%)", `translateY(-80%)`] }, { duration: 0.4, ease: "easeIn" }).then(() => {
      this.summaryFirstChild.textContent = btn.textContent;
      animate(this.summaryFirstChild, { opacity: [0, 1], transform: [`translateY(15px)`, "translateY(0px)"] }, { duration: 0.4, ease: "easeOut" });
    });
    this.aniClose();
  }
  aniOpen() {
    this.firstElementChild.setAttribute("open", "");
    return  animate([
      [$4('.hdt-options-tab', this), { opacity: [0, 1], transform: ["translateY(10px)", `translateY(0)`] }, { duration: 0.4, ease: "easeOut" }],
      [$$4('.hdt-options-tab button', this), { opacity: [0, 1], transform: ["translateY(8px)", "translateY(0)"] }, { duration: 0.15, ease: "easeOut", at: "-0.15", delay: stagger(0.2) }]
    ]);
  }
  aniClose() {
    return animate([
      [$$4('.hdt-options-tab button'), { opacity: [1, 0], transform: ["translateY(0)", "translateY(8px)"] }, { duration: 0.15, ease: "easeIn" }],
      [$4('.hdt-options-tab', this), { opacity: [1, 0], transform: ["translateY(0)", `translateY(10px)`] }, { duration: 0.35, at: "-0.1", ease: "easeIn" }],
    ]).then(() => {
      this.firstElementChild.open = false;
      if (!Shopify.designMode) getterGet(_summary_tab_collection, this).focus();
    });
  }

};
var _section_related = new WeakMap();
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    getterAdd(_section_related, this, this.closest('.hdt-section'));
  }
  connectedCallback() {
    if (!this.url) return this.nullOrEmpty();
    // this.observer?.unobserve(this);
    // console.log(this)
    // this.observer = new IntersectionObserver((entries, observer) => {
    //   console.log('loadProducts: ')
    //   if (!entries[0].isIntersecting) return;
    //   observer.unobserve(this);
    //   console.log('loadProducts 11: ')
    //   this.loadProducts();
    // },{ rootMargin: '0px 0px 400px 0px' });
    // this.observer.observe(this);
    inView(this, ()=> {
      this.loadProducts();
    }, { margin: '0px 0px 400px 0px' })
  }
  get type() {
    return 'related'
  }
  get url() {
    return this.dataset.url;
  }
  get section() {
    return getterGet(_section_related, this);
  }
  get mediaVisibilityContext() {
    if (this.dataset.mediaVisibilityCollectionHandle) {
      return {
        collectionHandle: this.dataset.mediaVisibilityCollectionHandle.trim(),
        collectionHandles: (this.dataset.mediaVisibilityCollectionHandles || this.dataset.mediaVisibilityCollectionHandle).split('|').filter(Boolean),
        hideSuffixes: (this.dataset.mediaVisibilitySuffixes || '').split('||').map((suffix) => suffix.trim().toLowerCase()).filter(Boolean)
      };
    }
    return MediaVisibilityContext.current();
  }
  get mediaVisibilitySuffixes() {
    return this.mediaVisibilityContext?.hideSuffixes || [];
  }
  get mediaVisibilityCollectionHandle() {
    return this.mediaVisibilityContext?.collectionHandle || '';
  }
  get mediaVisibilityCollectionHandles() {
    const context = this.mediaVisibilityContext;
    return context?.collectionHandles?.length ? context.collectionHandles : [context?.collectionHandle].filter(Boolean);
  }
  applyMediaVisibilityContext(html) {
    const collectionHandle = this.mediaVisibilityCollectionHandle;
    if (!collectionHandle) return;
    const contextCollectionHandles = this.mediaVisibilityCollectionHandles;
    const cards = [
      ...$$4('hdt-card-product', html),
      ...Array.from(html.querySelectorAll('template')).flatMap((template) => [...template.content.querySelectorAll('hdt-card-product')])
    ];
    cards.forEach((card) => {
      const collectionHandles = (card.dataset.productCollectionHandles || '').split('|').filter(Boolean);
      const isEligible = contextCollectionHandles.some((handle) => collectionHandles.includes(handle));
      card.dataset.mediaVisibilityEligible = isEligible.toString();
      if (!isEligible) {
        delete card.dataset.mediaVisibilityCollection;
        delete card.dataset.mediaVisibilitySuffixes;
        return;
      }
      card.dataset.mediaVisibilityCollection = collectionHandle;
      card.dataset.mediaVisibilityCollectionTitle = this.mediaVisibilityContext.collectionTitle || '';
      card.dataset.mediaVisibilityCollectionUrl = this.mediaVisibilityContext.collectionUrl || '';
      card.dataset.mediaVisibilityCollectionHandles = contextCollectionHandles.join('|');
      card.dataset.mediaVisibilitySuffixes = this.mediaVisibilitySuffixes.join('||');
    });
  }
  applyMediaVisibilityRules(html) {
    const suffixes = this.mediaVisibilitySuffixes;
    if (!suffixes.length) return;
    const collectionHandle = this.mediaVisibilityCollectionHandle;
    const contextCollectionHandles = this.mediaVisibilityCollectionHandles;
    const cards = [
      ...$$4('hdt-card-product', html),
      ...Array.from(html.querySelectorAll('template')).flatMap((template) => [...template.content.querySelectorAll('hdt-card-product')])
    ];
    const filterMedia = (root) => {
      const mediaItems = $$4('[data-media-id]', root);
      let matchingMedia = mediaItems.filter((media) => {
        const image = media.matches('img') ? media : $4('img', media);
        let filename = (image?.getAttribute('src') || '').split('?')[0].split('/').pop() || '';
        try { filename = decodeURIComponent(filename); } catch (_) {}
        filename = filename.replace(/\.[^.]+$/, '').toLowerCase();
        return suffixes.some((suffix) => filename.endsWith(suffix));
      });
      if (matchingMedia.length == mediaItems.length) matchingMedia = matchingMedia.slice(1);
      matchingMedia.forEach((media) => {
        media.dataset.visibilityRuleHidden = 'true';
        media.hidden = true;
      });
    };
    cards.forEach((card) => {
      if (card.dataset.mediaVisibilityEligible != 'true') return;
      filterMedia(card);
      $$4('template[data-card-linked-media]', card).forEach((template) => {
        const handles = (template.dataset.productCollectionHandles || '').split('|').filter(Boolean);
        const isEligible = contextCollectionHandles.some((handle) => handles.includes(handle));
        template.dataset.mediaVisibilityEligible = isEligible.toString();
        if (isEligible) filterMedia(template.content);
      });
    });
  }
  nullOrEmpty() {
    if (this.hasAttribute('inner-group')) {
      this.parentElement?.previousElementSibling?.remove();
      this.parentElement?.remove();
      this.section.setAttribute(`${this.type}-empty-inted`, '');
    } else {
      this.section.hidden = true;
    }
  }
  loadProducts() {
    fetch(`${this.url}`)
    .then((response) => response.text())
    .then((text) => {
      const html = new DOMParser().parseFromString(text, "text/html");
      this.applyMediaVisibilityContext(html);
      this.applyMediaVisibilityRules(html);
      const
      inner = $4('.hdt-section', html).innerHTML.trim().replace(/<!--[\s\S]*?-->/g, ''); // clear comment when on admin <!--shopify:rendered_by_section_api-->

      if (inner.includes('no_000') || inner.length == 0) {
        this.nullOrEmpty();
      } else {
        this.section.setAttribute(`${this.type}-inted`, '');
        if (this.hasAttribute('inner-group')) $4(`button[aria-controls="group-product-${this.type}--list"]`, this.section)?.removeAttribute("tabindex");
        this.replaceWith($4('.hdt-section', html).firstElementChild)
        document.dispatchEvent(new CustomEvent("currencyUpdate"));
      }
    }).catch((e) => {console.error(e); });
  }
};
class ProductRecently extends ProductRecommendations {
  constructor() {
    super();
  }
  get type() {
    return 'recently'
  }
  get #storageKey() {
    return 'theme4:recently:id"';
  }
  get url() {
    if (this._url) return this._url;
    this._url = null;
    let productsId = localStorage.getItem(this.#storageKey);
    let productId = this.dataset.id;
    //console.log(productsId)
    if (productsId !== null) {
      if (productsId.split(',').some(v => v === '')) {
        productsId = productsId.replace(/,+/g, ',').replace(/^,|,$/g, '');
        localStorage.setItem(this.#storageKey, productsId);
      }
      productsId = productsId.split(',');
      this._url = this.dataset.url.replace('q=', `q=id:${productsId.join("%20OR%20id:")}`);
    }
    let arrProducts = productsId || new Array;
    // console.log(arrProducts, productsId)
    if (!arrProducts.includes(productId + '')) {
      if (arrProducts.length >= 10) {
        arrProducts.pop();
      }
      arrProducts.unshift(productId);
      localStorage.setItem(this.#storageKey, arrProducts.toString());
    }
    return this._url;
  }
};

customElements.define('hdt-tab-collection', tabCollection);
customElements.define('wrapp-hdt-details', detailsCollection);
customElements.define('product-recommendations', ProductRecommendations);
customElements.define('hdt-product-recently', ProductRecently);


/**
* 10. Before after
* -----------------------------------------------------------------------------
*/
var _range_bf = new WeakMap();
class BeforeAfter extends HTMLElement {
  #controller;
  #percent;
  //#percent = springValue(0, { bounce: 0.5 });
  constructor() {
    super();
    getterAdd(_range_bf, this, $4('.hdt-bf-range',this));
    if (matchMediaQuery("motion") && this.hasAttribute('reveal-on-scroll') ) {
      this.#percent = springValue('0%');
      inView(this, ()=> {
        delay(() => {
        this.#percent.set(getterGet(_range_bf, this).value+'%')
        }, 0.35)
      }, { margin: "-200px 0px" });
    } else {
      this.#percent = springValue(getterGet(_range_bf, this).value+'%');
    }
  }

  connectedCallback() {
    this.#controller = new AbortController();
    styleEffect(this, { "--percent-val": this.#percent })
    getterGet(_range_bf, this).addEventListener("input", (e) => {
      this.#percent.set(e.target.value+'%');
    }, { signal: this.#controller.signal });
  }
};
customElements.define('hdt-before-after', BeforeAfter);

/**
* 11. Dialog
* -----------------------------------------------------------------------------
*/
/*
 * Declarative shadow DOM is only initialized on the initial render of the page.
 * If the component is mounted after the browser finishes the initial render,
 * the shadow root needs to be manually hydrated.
 */
class DeclarativeShadowElement extends HTMLElement {
  connectedCallback() {
    if (!this.shadowRoot) {
      const template = $4(':scope > :where(template[shadowrootmode="open"], template[lazy])', this);

      if (!(template instanceof HTMLTemplateElement)) return;

      const shadow = this.attachShadow({ mode: 'open' });
      shadow.append(template.content.cloneNode(true));
      template.remove();
    }
  }
}

const dialogsOpen = [];
var dialogCurrent;
class DialogComponent extends DeclarativeShadowElement {
  #controller;
  #scrollLock;
  constructor() {
    super();
  }
  connectedCallback() {
    this.dialog = $4('dialog', this);
    this.#scrollLock = this.dialog.hasAttribute('scroll-lock');
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    super.connectedCallback();

    // Events
    this.dialog.addEventListener('click', (e) => {
      // const rect = this.dialog.getBoundingClientRect();
      // const isClickOutside = (
      //   e.clientX < rect.left || e.clientX > rect.right ||
      //   e.clientY < rect.top || e.clientY > rect.bottom
      // );

      //console.log(isClickOutside, e, this.dialog, dialogsOpen, dialogCurrent, this.dialogId );
      if ((!this.hasAttribute('lock-outside') && this.#isClickOutside(e)) && (this.hasAttribute('nested') ? dialogCurrent === this.dialogId : true)) this.close();
    }, { signal });

    // ESC key to close dialog
    this.dialog.addEventListener('cancel', (e) => {
      e.preventDefault(); // Prevents the default cancel behavior
      //console.log(this)
      this.close();
    }, { signal });

    // Handle focus
    // this.dialog.addEventListener(dialogOpening, () => {
    //   //this.dialog.classList.add('focus-none');
    //   ($4('input[type="search"]', this.dialog) || this.dialog).focus();
    // }, { signal });

    // initial open
    if (this.hasAttribute('initial-open') || (!this.lockOpen && this.hasAttribute('initial-form-open') && location.href.indexOf(this.dataset.formId) > -1)) {
      this.open();
    }

    if (Shopify.designMode && !this.hasAttribute('un-detect')) {
      this.addEventListener(admEvts.select, (event) => this.open(!event.detail.load), { signal });
      this.addEventListener(admEvts.deselect, () => this.close(true), { signal });
      this._shopifySection = this._shopifySection || this.closest(".shopify-section");
      if (this._shopifySection) {
        if (this.hasAttribute("detect-adm-se-evt")) {
          this._shopifySection.addEventListener(admEvts.seSelect, (event) => this.open(event.detail.load), { signal });
          this._shopifySection.addEventListener(admEvts.seDeselect, this.close.bind(this), { signal });
        }
        //this._shopifySection.addEventListener(admEvts.seUnload, () => this.remove(), { signal });
      }
    }
  }
  disconnectedCallback() {
    if (this.dialog?.open) {
      this.#removeDialogId()
      if (this.#scrollLock && this._openedAsModal && dialogsOpen.length == 0) html.removeAttribute('scroll-lock');
    }
    this.dialog = null;
    this.#controller.abort();
  }

  /**
   * Gets the root node of the component, which is either its shadow root or the component itself.
   *
   * @returns {(ShadowRoot | Component<T>)[]} The root nodes.
   */
  // get roots() {
  //   return this.shadowRoot ? [this, this.shadowRoot] : [this];
  // }
  get dialogId() {
    return this.dialog.id;
  }
  get show() {
    this._openedAsModal = true;
    return this.dialog.showModal();
  }
  async open(jump = false) {
    if (this.dialog.open) return;
    // const focusable = $$4('input, button, [tabindex]', this.dialog);
    // focusable.forEach(el => el.setAttribute('tabindex', '-1'));
    // let scrollY = window.scrollY;
    // document.body.style.position = 'fixed';
    // document.body.style.top = `-${scrollY}px`;
    // document.body.style.left = '0';
    // document.body.style.right = '0';
    // document.body.style.width = '100%';
    this.show;
    elFocus(this.dialog, false, true);
    if (this.#scrollLock && this._openedAsModal) html.setAttribute('scroll-lock', '');
    this.dialog.dispatchEvent(new CustomEvent(dialogOpening));
    this.dialog.classList.add('dialog-opening');
    dialogsOpen.push(this.dialogId);
    dialogCurrent = this.dialogId;
    const animation = this.animateDialogOpen();
    if (jump) animation.complete();
    await animation;
    this.dialog.classList.remove('dialog-opening');
    this.dialog.dispatchEvent(new CustomEvent(dialogOpen));
    this.trapFocus();
  }
  trapFocus() {
    if (this.hasAttribute('un-trapFocus')) return;
    const initiaFocus = this.getAttribute('initia-focus');
    trapFocus(this.dialog, initiaFocus ? initiaFocus === 'false' ? false : $4(initiaFocus, this.dialog) : this.dialog);
  }
  async close(jump = false) {
    if (!this.dialog.open) return;
    // console.log('close', jump)
    // if (this.hasAttribute('dialog-closing')) return;
    this.dialog.dispatchEvent(new CustomEvent(dialogClosing));
    this.dialog.classList.add('dialog-closing');
    this.#removeDialogId();
    const animation = this.animateDialogClose();
    if (jump) animation.complete();
    await animation;
    this.dialog.close();
    this.dialog.classList.remove('dialog-closing');
    if (!this.hasAttribute('un-trapFocus')) removeTrapFocus();
    this.dialog.dispatchEvent(new CustomEvent(dialogClose));
    if (this.#scrollLock && this._openedAsModal && dialogsOpen.length == 0) html.removeAttribute('scroll-lock');
    this.dialog.btnOpening?.setAttribute('aria-expanded', false)
    this.dialog.btnOpening = null;
  }
  // #forceDialogToggle() {
  //   return animate(this, {}, { duration: 0 });
  // }
  animateDialogOpen() {
    return animate(this.dialog, { opacity: [0, 1]}, {
      duration: 0.3,
      ease: 'easeOut'
    });
  }
  animateDialogClose() {
    return animate(this.dialog, { opacity: [1, 0]}, {
      duration: 0.2,
      ease: 'easeIn'
    });
  }
  updateTrap(focusEl) {
    if (!this.hasAttribute('un-trapFocus')) trapFocus(this.dialog, focusEl);
  }
  #isClickOutside(event) {
    const rect = this.dialog.getBoundingClientRect();
    if (event.target instanceof HTMLDialogElement || !(event.target instanceof Element)) {
      return (
        event.clientX < rect.left || event.clientX > rect.right ||
        event.clientY < rect.top || event.clientY > rect.bottom
      );
    }
    return !this.contains(event.target);
  }
  #removeDialogId() {
    const index = dialogsOpen.indexOf(this.dialogId);
    if (index !== -1) dialogsOpen.splice(index, 1);
  }

}
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[aria-controls]');
  if (!trigger) return;

  const dialogId = trigger.getAttribute('aria-controls'),
  dialog = $id4(dialogId);

  // if (!dialogComponent || typeof dialogComponent.open !== 'function') {
  //   console.warn(`No dialog-component with id "${dialogId}" found or not a valid component.`);
  //   return;
  // }
  if (!dialog || !(dialog instanceof HTMLDialogElement) || !dialog.className.split(/\s+/).some(cls => cls.startsWith('hdt-')) || (dialog.hasAttribute('nested') && dialogCurrent !== dialog.id)) return;

  event.preventDefault();
  //event.stopPropagation();
  event.stopImmediatePropagation();
  const dialogCloseId = trigger.getAttribute('close-dialog');
  $$4('[data-auto-close] > dialog[open]').forEach( (_dialog)=> {
    if (!_dialog?.parentElement?._openedAsModal && _dialog.id != dialog.id) _dialog.parentElement.close(true);
  });
  if (dialog.open && dialogId == dialogCloseId) {
    dialog.parentElement?.close(true);
    dialog.addEventListener(dialogClose, ()=> {
      dialog.btnOpening = trigger;
      dialog.parentElement?.open();
    }, { once: true });
  } else {
    $id4(dialogCloseId)?.parentElement?.close();
    dialog.btnOpening = trigger;
    let expanded = 'false';
    // Toggle logic
    if (dialog.open) {
      dialog.parentElement.close();
    } else {
      expanded = 'true';
      dialog.parentElement.open();
    }
    $$4(`[aria-controls="${dialogId}"]`).forEach((_btn) => _btn.setAttribute('aria-expanded', 'false'));
    trigger.setAttribute('aria-expanded', expanded);
  }
});

class Drawer extends DialogComponent {
  constructor() {
    super();
  }
  /**
   * @param {string} pos
   */
  set transform(pos) {
    this._transform = ['translate3d(0, 0, 0)'];
    if (pos === 'right') {
      this._transform.push(`translate3d(${isRTL ? '-' : ''}100%, 0, 0)`);
    } else if (pos === 'bottom') {
      this._transform.push( 'translate3d(0, 100%, 0)');
    } else if (pos === 'top') {
      this._transform.push('translate3d(0, -100%, 0)');
    } else {
      this._transform.push(`translate3d(${isRTL ? '' : '-'}100%, 0, 0)`);
    }
  }
  get pos() {
    const arr = (this.dialog.getAttribute('pos-min-width') || '').split(':');
    return arr[1] && window.innerWidth >= Number(arr[0]) ? arr[1] : this.dialog.getAttribute('pos') || 'left';
  }
  get show() {
    this.transform = this.pos;
    this._openedAsModal = true;
    return this.dialog.showModal();
  }
  animateDialogOpen() {
    return animate(this.dialog, {
      transform: this._transform.reverse()
    }, {
      duration: 0.5,
      ease: [0.19, 1, 0.22, 1]
    });
  }
  animateDialogClose() {
    return animate(this.dialog, {
      transform: this._transform.reverse()
    }, {
      duration: 0.4,
      ease: [0.19, 1, 0.22, 1]
    });
  }
}
class Modal extends DialogComponent {
  animateDialogOpen() {
    return animate(this.dialog, {
      opacity: [0, 1],
      transform: ['translateX(-100px)', 'translateX(0)'],
    }, {
      duration: 0.45,
      ease: [0.19, 1, 0.22, 1]
    });
  }
  animateDialogClose() {
    return animate(this.dialog, {
      opacity: [1, 0],
      transform: ['translateX(0)', 'translateX(80px)']
    }, {
      duration: 0.45,
      ease: [0.19, 1, 0.22, 1]
    });
  }
}

import { computePosition, shift, flip, offset, arrow } from "@theme/floating";
var _translate_by_dpr = new WeakSet(), translate_by_dpr_fn,
_round_by_dpr = new WeakSet(), round_by_dpr_fn,
_dpr = window.devicePixelRatio || 1;
class BaseFloating extends DialogComponent {
  #config;
  constructor() {
    super();
    getterAdd(_translate_by_dpr, this);
    getterAdd(_round_by_dpr, this);
  }
  async updatePos(floatingEl, arrowEl, _placement, useTranslate = true) {
    return computePosition(this.#button, floatingEl, {
      //placement: getPlacement(_placement),
      placement: _placement,
      middleware: [
        offset(this.#offset),
        this.#enableFlip && flip({
          fallbackPlacements: ['left', 'right', 'top', 'bottom'],
          //fallbackPlacements: ['top', 'bottom'],
        }),
        shift({padding: 5}),
        arrow({
          element: arrowEl,
        }),
      ]
    }).then(({x, y, placement, middlewareData}) => {
      this.setAttribute('data-placement', placement);
      if (useTranslate) {
        this.objStyle = {
          top: '0',
          left: '0',
          transform: getterRunFn(_translate_by_dpr, this, translate_by_dpr_fn).call(this, x, y),
        }
      } else {
        this.objStyle = {
          left: `${x}px`,
          top: `${y}px`,
        };
      }
      Object.assign(floatingEl.style, this.objStyle);
      //console.log(middlewareData.arrow)
      if (middlewareData.arrow && arrowEl) {
        const {x: arrowX, y: arrowY} = middlewareData.arrow;
        const staticSide = {
          top: 'bottom',
          right: 'left',
          bottom: 'top',
          left: 'right',
        }[placement.split('-')[0]];

        Object.assign(arrowEl.style, {
          left: arrowX != null ? `${arrowX}px` : '',
          top: arrowY != null ? `${arrowY}px` : '',
          right: '',
          bottom: '',
          [staticSide]: this.#staticSide,
        });
      }
      //console.log(this.objStyle)
      return this.objStyle;
    });
  }
  get config() {
    return this.#config ??= JSON.parse(this.getAttribute("config") || '{}');
  }
  get placement() {
    return this.getAttribute("placement") || this.#button?.getAttribute("data-placement") || 'bottom';
  }
  get #button() {
    return this.dialog?.btnOpening;
  }
  get #enableFlip() {
    return !this.#button.hasAttribute('no-flip');
  }
  get arrowEl() {
    return this._arrowEl ??= $4('.hdt-popover__arrow', this);
  }
  get #offset() {
    return parseInt(this.config.offset || 14);
  }
  get #staticSide() {
    return this.config.staticSide || '-5px';
  }
};
round_by_dpr_fn = function(value) {
  return Math.round(value * _dpr) / _dpr;
};
translate_by_dpr_fn = function(x, y) {
  return _dpr > 1 ? `translate3d(${getterRunFn(_round_by_dpr, this, round_by_dpr_fn).call(this, x)}px,${getterRunFn(_round_by_dpr, this, round_by_dpr_fn).call(this, y)}px,0)` : `translate(${getterRunFn(_round_by_dpr, this, round_by_dpr_fn).call(this, x)}px,${getterRunFn(_round_by_dpr, this, round_by_dpr_fn).call(this, y)}px)`;
};
class Popover extends BaseFloating {
  #controller;
  constructor() {
    super();
  }
  get minWidth() {
    return Number(this.getAttribute('popover-active-min-width')) || 768;
  }
  get show() {
    this._openedAsModal = window.innerWidth < this.minWidth;
    const scrollY = window.scrollY;
    this.dialog.toggleAttribute('open-as-modal', this._openedAsModal);
    this._openedAsModal ? this.dialog.showModal() : this.dialog.show();
    requestAnimationFrame(() => {
      window.scrollTo(0, scrollY);
    });
    return true;
  }

  connectedCallback() {
    super.connectedCallback();

    this.dialog.addEventListener(dialogOpen, () => {
      this.#controller = new AbortController();
      const { signal } = this.#controller;
      document.addEventListener('click', (event)=> {
        if (!this._openedAsModal && !this.contains(event.target)) this.close();
      }, { signal });
      this.addEventListener("richlist:select", this.close.bind(this, false), { signal });
      // Add event esc when use method dialog.show
      if (!this._openedAsModal) {
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.dialog.open) {
            const event = new Event('cancel', { cancelable: true });
            this.dialog.dispatchEvent(event);
            if (!event.defaultPrevented) this.dialog.close();
          }
        }, { signal });
      }
    });
    this.dialog.addEventListener(dialogClosing, ()=> {
      this.#controller?.abort();
    });
    // if (this.hasAttribute('update-pos-when-hover-focus')) {
    //   const btnsOpen = $$4(`[aria-controls="${this.dialog.id}"]`);
    //   btnsOpen.forEach( (btn) => {
    //     hover(btn, () => {
    //       this.updatePos(this.dialog, this.arrowEl, this.placement);
    //     }, { once: true })
    //     btn.addEventListener('focus', () => {
    //       this.updatePos(this.dialog, this.arrowEl, this.placement);
    //     }, { once: true });
    //   });
    // }

    if (Shopify.designMode && !this.hasAttribute('un-detect')) {
      const shopifySection = this.closest(".shopify-section");
        shopifySection?.addEventListener(admEvts.select, (event) => {
          //console.log(event);
          if (event.target.getAttribute('aria-controls') === this.dialog.id) {
            this.dialog.btnOpening = event.target;
            this.open(!event.detail.load);
          }
        });
        shopifySection?.addEventListener(admEvts.deselect, (event) => {
          //console.log(event);
          if (event.target.getAttribute('aria-controls') === this.dialog.id) {
            this.close(true);
          }
        });
      // $4(`button[aria-controls="popover-${event.target.id}"]`).addEventListener(admEvts.select, (event) => this.open(!event.detail.load), { signal });
      // this.addEventListener(admEvts.deselect, () => this.close(true), { signal });
    }
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
  }

  async animateDialogOpen() {
    if (this._openedAsModal) {
      // Object.assign(this.dialog.style, {
      //   top: null,
      //   left: '0px',
      //   right: null,
      //   bottom: '0px',
      //   transform: null,
      // });
      return animate([
        [this.dialog, { transform: ["translateY(100%)", "translateY(0%)"], opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.4, ease: [0.645, 0.045, 0.355, 1] }],
        //[$4('.hdt-popover__body', this).children, {  opacity: [0, 1], transform: ["translateY(15px)", "translateY(0px)"] }, { at: "-0.08", duration: 0.24, ease: [0.645, 0.045, 0.355, 1] }]
      ]);
    } else {
      if (this.hasAttribute('un-popover-trapFocus')) document.activeElement?.blur();
      const pos = await this.updatePos(this.dialog, this.arrowEl, this.placement),
      { transform } = pos;
      //console.log(transform)
      return animate([
        [this.dialog, { top: ["10px","0"], opacity: [0, 1], visibility: ["hidden", "visible"], transform: [transform, transform] }, { duration: 0.15 }],
        [$4('.hdt-popover__body', this).children, { opacity: 1 }, { at: "<", duration: 0.15 }]
      ]);
    }
  }
  animateDialogClose() {
    if (this._openedAsModal) {
      return animate([
        //[$4('.hdt-popover__body', this).children, {  opacity: [1, 0], transform: ["translateY(0px)", "translateY(15px)"] }, { duration: 0.24, ease: [0.645, 0.045, 0.355, 1] }],
        [this.dialog, { transform: ["translateY(0%)", "translateY(100%)"], opacity: [1, 0], visibility: ["visible", "hidden"] }, { at: "-0.1", duration: 0.25, ease: [0.645, 0.045, 0.355, 1] }],
      ]);
    } else {
      return animate([
        [$4('.hdt-popover__body', this).children, { opacity: 0 }, { duration: 0.15 }],
        [this.dialog,{ top: ["0","10px"], opacity: [1, 0], visibility: ["visible", "hidden"] }, { at: "<", duration: 0.15 }]
      ]);
    }
  }
  trapFocus() {
    if (this.hasAttribute('un-popover-trapFocus') && !this._openedAsModal) return;
    //console.log(super.trapFocus);
    super.trapFocus();
  }
}

class searchDrawer extends DialogComponent {

  connectedCallback() {
    super.connectedCallback();
  }
  animateDialogOpen() {
    if (matchMediaQuery("mobile")) {
      return animate(this, {}, { duration: 0 });
    } else {
      return animate(this.dialog, { opacity: [0, 1], transform: ["translateY(-20px)", "translateY(0px)"] }, { duration: 0.4, ease: "easeOut" });
    }
  }
  animateDialogClose() {
    const animation = animate(this.dialog, { opacity: [1, 0], y: [0, -20] }, { duration: 0.4, ease: "easeOut" });
    animation.then(() => {
      this.dialog.style.opacity = 1;
      this.dialog.style.transform = "translateY(0)";
    });
    return animation;
  }
}
class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = $4('input[type="search"]', this);
    this.resetButton = $4('button[type="reset"]', this);

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));

      // Prevent ESC from clearing text from <input type="search"> on Chrome
      // this.input.addEventListener('keydown', (event) => {
      //   if (this.input.value.length > 0 && event.key === 'Escape') event.preventDefault()
      // });
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !$4('[aria-selected="true"] a', this);
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      if (this.hasAttribute('un-trapFocus')) {
        this.input.focus();
      } else {
        trapFocus(this.parentElement.tagName === 'DIALOG' ? this.parentElement : this, this.input);
      }
      this.toggleResetButton();
    }
  }
}

class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = $$4('input[type="search"][name="q"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.#onInputFocus.bind(this));
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    document.body.addEventListener('click', this.onBodyClickEvent);

    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.#onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.#keepInSync('', this.input);
    }
  }

  #onInput(event) {
    const target = event.target;
    this.#keepInSync(target.value, target);
  }

  #onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  #keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) input.value = value;
    });
    $$4('.hdt-reset-search__btn[type="reset"]').forEach((btn) => btn.classList.toggle('hidden', !value));
  }

  onBodyClick(event) {
    if (!this.contains(event.target)) this.closest('hdt-predictive-search')?.close(false);
  }
}
var suggestAPI;
class PredictiveSearch extends SearchForm {
  #controller;
  #initHeight = -1;
  constructor() {
    super();
    suggestAPI = Shopify.locale == 'en';
    this.supportPredictiveAPI();
    this.cachedResults = {};
    this.predictiveSearchResults = $4('[data-predictive-search]', this);
    this.allPredictiveSearchInstances = $$4('hdt-predictive-search');
    this.isOpen = false;
    this.#controller = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
    this.predictiveSearchResults.attachShadow({ mode: "open" });
    this.predictiveSearchResults.shadowRoot.appendChild(document.createRange().createContextualFragment(`<slot name="search-results"></slot>`));
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    if (this.hasAttribute('un-trapFocus')) {
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.addEventListener('keydown', (evt)=> {
        if ( evt.key === 'Escape') this.close(false, true);
      });
    }
  }
  supportPredictiveAPI () {
    if (suggestAPI) return;
    fetch(window.Shopify.routes.root + "search/suggest.json?q=nathan417&resources[type]=article&resources[options][fields]=title&resources[limit]=1")
      .then((res) => res.json())
      .then((res) => {
        suggestAPI = res.status != '417';
      }
    );
  }

  get query() {
    return this.input.value.trim();
  }

  get slotResults() {
    return $4('[slot="search-results"]', this);
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.query;
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      //$4('#predictive-search-results-groups-wrapper', this)?.remove();
      this.slotResults.innerHTML = "";
    }
    // Update the term asap, don't wait for the predictive search query to finish loading
    // this.updateSearchForTerm(this.searchTerm, newSearchTerm);
    this.searchTerm = newSearchTerm;
    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.query.length || $4('[aria-selected="true"] a', this)) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.#controller.abort();
      this.#controller = new AbortController();
      animate(this.slotResults, { opacity: [1, 0], height: [`${this.slotResults.clientHeight}px`, `${this.#initHeight}px`] }, { duration: 0.45, ease: "ease", height: { duration: 0.4 } }).then(() => {
        this.slotResults.style.height = null;
        this.closeResults(true);
      });
    }
  }

  onFocus() {
    const currentSearchTerm = this.query;

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut(event) {
    //console.log('onFocusOut', document.activeElement, event)
    setTimeout(() => {
      if (!this.contains(document.activeElement) ) this.close(false, true);
    });
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.#initHeight == -1) {
      this.#initHeight = $4('.hdt-main-search__empty-collection', this)?.clientHeight || 0;
    }

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(`${window.Shopify.routes.root}search${suggestAPI ? '/suggest' : ''}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search${suggestAPI ? '&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku,tag&resources[limit]=10&resources[limit_scope]=each' : '&options[prefix]=last'}`, {
      signal: this.#controller.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html');
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) return; // Code 20 means the call was aborted
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || $4('.hdt-predictive-search-status', this);
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');
    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    let oldHeight = this.slotResults.clientHeight;
    this.slotResults.replaceChildren(...document.importNode( $4('#shopify-section-predictive-search', resultsMarkup), true).children);
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
    let newHeight = this.slotResults.scrollHeight;
    //console.log(oldHeight, newHeight)
    animate(this.slotResults, { opacity: [0, 1], height: [`${oldHeight}px`, `${newHeight}px`] }, { duration: 0.45, ease: "easeOut" }).then(() => {
      this.slotResults.style.height = null;
    });
    if (!this.hasAttribute('un-trapFocus')) trapFocus(this.parentElement.tagName === 'DIALOG' ? this.parentElement : this, this.input);
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText($4('[search-live-region-count]', this).textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight = `${window.innerHeight - 40}px`;
    return this.resultsMaxHeight;
  }

  open() {
    //this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.parentElement?.style.setProperty("--hdt-search-mh", this.resultsMaxHeight || this.getResultsMaxHeight());
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false, closeDialog = false) {
    this.closeResults(clearSearchTerm, closeDialog);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false, closeDialog = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
      if (!this.hasAttribute('un-trapFocus')) {
        requestAnimationFrame(() => {
          trapFocus(this.parentElement.tagName === 'DIALOG' ? this.parentElement : this, this.input);
        });
      }
    }

    $4('[aria-selected="true"]', this)?.setAttribute('aria-selected', false);
    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    //this.predictiveSearchResults.removeAttribute('style');
    this.parentElement?.style.removeProperty("--hdt-search-mh");
    if (closeDialog && this.parentElement.tagName === 'DIALOG') this.parentElement?.close();
    if (!this.hasAttribute('un-trapFocus')) removeTrapFocus();
  }
}
class appendToBody extends HTMLElement {
  constructor() {
    super();
    if ( window.innerWidth < 768 && this.hasAttribute('desktop')) return;
    if (this.hasAttribute('not-idle')) {
      this.#run();
    } else {
      const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1));
      idle(this.#run);
    }
  }
  get #target() {
    return this.hasAttribute('host') ? this.parentElement : document.body;
  }
  get #key() {
    return this.getAttribute('key');
  }
  #run = () => {
    //if (!this.hasAttribute('lazy') && document.body === this.firstElementChild.parentNode) return;
    const tpl = $4(':scope > template', this);
    const fragment = document.createDocumentFragment();

    if (tpl) {
      fragment.append(tpl.content.cloneNode(true));
    } else {
      fragment.append(...this.childNodes);
    }
    if (Shopify.designMode && this.#key) {
      $$4(`[data-hdt-key="${this.#key}"]`).forEach(el => el.remove());
      fragment.firstElementChild?.setAttribute('data-hdt-key', this.#key);
    }
    this.#target.appendChild(fragment);
    this.remove();
  }
}

customElements.define('hdt-popover', Popover);
customElements.define("hdt-search-drawer", searchDrawer);
customElements.define('hdt-search-form', SearchForm);
customElements.define('hdt-predictive-search', PredictiveSearch);
customElements.define('hdt-main-search', MainSearch);
customElements.define("hdt-append-body", appendToBody);
const _resizeObserver_tabs = new WeakMap();
class Tabs extends HTMLElement {
  #selected;
  panels = [];
  tabs = [];
  #controller;
  constructor() {
    super();
    if (!this.shadowRoot) {
      this.attachShadow({ mode: "open" }).appendChild($4("template", this).content.cloneNode(true));
    }
    this.index = 0;
  }
  connectedCallback() {
    this.#controller = new AbortController();
    this.tabs = this.$PartName('hdt-tabs-slot').assignedNodes({ flatten: true }).filter((el) => el.tagName === 'BUTTON');
    this.panels = this.$PartName('hdt-tabs-content-slot').assignedNodes({ flatten: true }).filter((el) => el.nodeType === Node.ELEMENT_NODE && el.tagName !== 'TEMPLATE');
    if (this.tabs.length == 0) return;
    const { signal } = this.#controller;
    this.$PartName('hdt-tabs-slot').addEventListener('click', this.#onTitleClick.bind(this), { signal })
    if (!this.hasAttribute('disable-keydown')) this.$PartName('hdt-tabs-slot').addEventListener('keydown', this.#onKeyDown.bind(this), { signal });
    if (!this.hasAttribute('not-init')) this.selectTab(0);  // Set the initial position of the ink bar
    var lastWidth = this.offsetWidth;
    getterAdd(_resizeObserver_tabs, this, new ResizeObserver(entries => {
      for (let entry of entries) {
        if (entry.target !== this) continue;
        if (entry.contentRect.width !== lastWidth) {
          lastWidth = entry.contentRect.width;
          this.selectTab(this.index);
        }
      }
    }));
    getterGet(_resizeObserver_tabs, this).observe(this);
  }
  disconnectedCallback() {
    this.#controller.abort();
    getterGet(_resizeObserver_tabs, this)?.disconnect();
  }
  $PartName(name) {
    return this.shadowRoot?.querySelector(`[part="${name}"]`);
  }
  get selected() {
    return this.#selected;
  }
  set selected(idx) {
    this.#selected = idx;
    this.selectTab(idx);

    // Updated the element's selected attribute value when
    // backing property changes.
    this.setAttribute('selected', idx);
  }
  selectTab(idx = null) {
    let index = this.index;
    animate(this.panels[index], { opacity: [1, 0], transform: ["translateY(0px)", `translateY(30px)`] }, { duration: 0.35, ease: "easeIn" }).then(() => {
      for (let [i, tab] of this.tabs.entries()) {
        const select = i === idx;
        //tab.setAttribute('tabindex', select ? 0 : -1);
        tab.setAttribute('aria-selected', select);
        tab.setAttribute('aria-current', select);
        this.panels[i].setAttribute('aria-hidden', !select);
        if (index != i) this.panels[i].hidden = !select;

        if (select) {
          if (idx != index) this.panels[index].hidden = true;
          requestAnimationFrame(() => {
          this.style.setProperty("--ink-bar-w", `${tab.offsetWidth}px`);
          this.style.setProperty("--ink-bar-x", `${tab.offsetLeft}px`);
          this.style.setProperty("--ink-bar-y", `${tab.offsetTop + tab.offsetHeight - 1}px`);
          });
          animate(this.panels[idx], { opacity: [0, 1], transform: [`translateY(20px)`, "translateY(0px)"] }, { duration: 0.45, ease: "easeOut" });
        }
      }
    });
    this.index = idx || 0;
  }
  #onTitleClick(e) {
    if (e.target.slot === 'title') {
      this.selected = this.tabs.indexOf(e.target);
      e.target.focus();
    }
  }
  #onKeyDown(e) {
    switch (e.code) {
      case 'ArrowLeft':
        e.preventDefault();
        var idx = this.selected - 1;
        idx = idx < 0 ? this.tabs.length - 1 : idx;
        this.tabs[idx].click();
        break;
      case 'ArrowRight':
        e.preventDefault();
        var idx = this.selected + 1;
        this.tabs[idx % this.tabs.length].click();
        break;
      default:
        break;
    }
  }
}
customElements.define('hdt-tabs', Tabs);

// const defaultStickyConfig = {
//   type: 'auto',
//   stretch: false,
//   resize: true,
//   indents: {
//       top: 0,
//       bottom: 0
//   },
//   window: {
//       min: 768,
//       max: null
//   }
// };
// class HdtSticky extends HTMLElement {
//   constructor() {
//       super();
//       this.options = Object.assign({}, defaultStickyConfig, JSON.parse(this.getAttribute('config') || '{}'));
//       this.location = undefined;
//       this.freeplace = 0;
//       this.scroll = 0;
//   }

//   connectedCallback() {
//       this.init();
//   }

//   calcPosition() {
//       this.freeplace = window.innerHeight - this.options.indents.top - this.options.indents.bottom;

//       if (this.options.type === 'auto') {
//           if (this.clientHeight < this.freeplace) {
//               this.location = 'top';
//           } else {
//               this.location = 'bottom';
//           }
//       } else {
//           this.location = this.options.type;
//       }
//       switch (this.location) {
//           case 'top':
//               this.scroll = this.options.indents.top;
//               break;

//           case 'bottom':
//               this.scroll = window.innerHeight - this.clientHeight - this.options.indents.bottom;
//               break;

//           default:
//               console.error(`Invalid position: "${this.options.type}". Available positions: "auto", "top", "bottom".`);
//       }
//   }

//   stickBlock() {
//     this.style.position = 'sticky';
//     this.style.top = `${this.scroll}px`;
//     if (this.options.stretch && this.location === 'top') this.style.minHeight = `${this.freeplace}px`;
//   }

//   windowResize() {
//       if (!this.options.resize) return;
//       let currentWindowHeight = window.innerHeight;
//       window.addEventListener('resize', (e) => {
//           if (this.options.window.min && window.innerWidth < this.options.window.min) return;
//           if (this.options.window.max && window.innerWidth > this.options.window.max) return;

//           if (e.target.innerHeight > currentWindowHeight || e.target.innerHeight < currentWindowHeight) {
//               currentWindowHeight = e.target.innerHeight;
//               this.calcPosition();
//               this.stickBlock();
//           }
//       });
//   }

//   update() {
//       this.calcPosition();
//       this.stickBlock();
//   }

//   init() {
//       this.windowResize();
//       if (this.options.window.min && window.innerWidth < this.options.window.min) return;
//       if (this.options.window.max && window.innerWidth > this.options.window.max) return;
//       this.calcPosition();
//       this.stickBlock();
//   }
// };
// customElements.define('hdt-sticky', HdtSticky);
/**
 * A smart sticky component that handles content longer than the viewport.
 * It automatically calculates a negative 'top' value so that the bottom
 * of the element sticks to the bottom of the screen.
 */
class SafeSticky extends HTMLElement {
  #resize;
  constructor() {
    super();
  }

  connectedCallback() {
    //this.#resize = resize(this, () => this.#recalculatePosition())
    //console.log(this.offsetHeight, window.innerHeight)
    this.#resize = resize(this, () => this.toggleAttribute('is-hdt-safe-bottom', this.offsetHeight > window.innerHeight))
  }

  disconnectedCallback() {
    if (this.#resize) this.#resize();
  }

  /**
   * Recalculates the sticky top position based on element and viewport height.
   */
  // #recalculatePosition() {
  //   frame.render(() => {
  //     const viewportHeight = window.innerHeight;
  //     const elementHeight = this.offsetHeight;
  //     let top = 0;
  //     if (elementHeight > viewportHeight) {
  //       // If content is longer than screen, stick to the bottom
  //       // Formula: top = viewport - element_height
  //      top = viewportHeight - elementHeight;
  //     }
  //     this.style.setProperty('--hdt-safe-top', `${top}px`);
  //     this.style.setProperty('--hdt-safe-logic', top == 0 ? 1 : -1);
  //   })
  // }
}
customElements.define("hdt-safe-sticky", SafeSticky);

/**
* 11.1 Modal
* -----------------------------------------------------------------------------
*/


const menuDrawerTopItemMotion = {
  outDuration: 160,
  inDuration: 220,
  stagger: 45,
  outOffset: "-8px",
  inOffset: "-10px"
};

class MenuDrawer extends Drawer {
  #topMenuController;

  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.#initTopMenu();
  }

  disconnectedCallback() {
    this.#topMenuController?.abort();
    super.disconnectedCallback();
  }

  animateDialogOpen() {
    const menu = $4(".hdt-menu-drawer__nav:not([hidden]), .hdt-menu-drawer__panel:not([hidden])", this),
    links = $$4("li", menu);
    const revealSimultaneously = !!menu?.closest('.hdt-header-nav-eff--reveal-simultaneously');
    if (revealSimultaneously) {
      return animate([
        [this.dialog, { transform: this._transform.reverse() }, { duration: 0.3, ease: "easeOut" }],
        [links, { opacity: [0, 1],transform: ["translateX(-10px)", "translateX(0)"] }, { duration: 0.15, ease: "easeOut" }],
        [$4(".hdt-menu-drawer-footer", this), { opacity: [0, 1],transform: ["translateX(-12px)", "translateX(0)"] }, { duration: 0.15, ease: "easeOut" }]
      ]);
    }
    return animate([
      [this.dialog, { transform: this._transform.reverse() }, { duration: 0.3, at: "<", ease: "easeOut" }],
      [links, { opacity: [0, 1],transform: ["translateX(-10px)", "translateX(0)"] }, { duration: 0.15, delay: stagger(links.length < 15 ? 0.08 : 0.035), ease: "easeOut" }],
      [$4(".hdt-menu-drawer-footer", this), { opacity: [0, 1],transform: ["translateX(-12px)", "translateX(0)"] }, { duration: 0.3, ease: "easeOut" }]
    ]);
  }
  animateDialogClose() {
    const menu = $4(".hdt-menu-drawer__nav:not([hidden]), .hdt-menu-drawer__panel:not([hidden])", this),
    links = $$4("li", menu);
    const revealSimultaneously = !!menu?.closest('.hdt-header-nav-eff--reveal-simultaneously');
    if (revealSimultaneously) {
        return animate([
        [links, { opacity: [1, 0],transform: ["translateX(0)", "translateX(-10px)"] }, { duration: 0.15, ease: "easeIn" }],
        // [$4(".hdt-menu-drawer-footer", this), { opacity: [1, 0],transform: ["translateX(0)", "translateX(-12px)"] }, {  duration: 0.3, ease: "easeIn" }],
        [this.dialog, { transform: this._transform.reverse() }, { duration: 0.3, ease: "easeIn"  }],
      ]);
    }
    const delayTotal =  0.15 + (links.length < 10 ? 0.07 : 0.035) * links.length;
    return animate([
      [links, { opacity: [1, 0],transform: ["translateX(0)", "translateX(-10px)"] }, { duration: 0.15, delay: stagger(links.length < 10 ? 0.07 : 0.035), ease: "easeIn" }],
      [$4(".hdt-menu-drawer-footer", this), { opacity: [1, 0],transform: ["translateX(0)", "translateX(-12px)"] }, {  at: "-0.035", duration: 0.3, ease: "easeIn" }],
      [this.dialog, { transform: this._transform.reverse() }, { at: `-${delayTotal*0.5}`, duration: 0.3, ease: "easeIn"  }],
    ]);
  }

  #initTopMenu() {
    const top = $4(".hdt-menu-drawer__top", this.dialog);
    if (!top) return;

    const navItems = Array.from($$4(".hdt-menu-drawer__top-nav-item", top));
    const panels = Array.from($$4(".hdt-menu-drawer__top-collections-panel", top));
    if (!navItems.length || !panels.length) return;

    this.#topMenuController?.abort();
    this.#topMenuController = new AbortController();
    const { signal } = this.#topMenuController;
    const getActivePanel = () => panels.find((panel) => panel.classList.contains("is-panel-active")) || null;
    const setActiveNav = (activeItem) => {
      navItems.forEach((item) => item.classList.toggle("is-active", item === activeItem));
    };

    navItems.forEach((item) => {
      item.addEventListener("click", async (e) => {
        e.preventDefault();

        const handle = item.getAttribute("data-parent-handle");
        if (!handle) return;

        const nextPanel = panels.find((panel) => panel.getAttribute("data-panel-handle") === handle);
        const prevPanel = getActivePanel();
        if (!nextPanel || nextPanel === prevPanel) return;

        setActiveNav(item);

        await this.#animateTopPanelItemsOut(prevPanel);
        if (prevPanel) prevPanel.classList.remove("is-panel-active");
        nextPanel.classList.add("is-panel-active");
        this.#animateTopPanelItemsIn(nextPanel);
      }, { signal });
    });
  }

  #getTopPanelItems(panel) {
    if (!panel) return [];
    return Array.from($$4(".hdt-menu-drawer__collection-card", panel));
  }

  async #animateTopPanelItemsOut(panel) {
    const items = this.#getTopPanelItems(panel);
    if (!items.length) return;
    if (!matchMediaQuery("motion")) {
      items.forEach((item) => {
        item.style.opacity = "0";
        item.style.transform = "";
      });
      return;
    }

    const animations = items.map((item) => {
      const currentOpacity = window.getComputedStyle(item).opacity;
      const animation = item.animate(
        [
          { opacity: currentOpacity, transform: "translateX(0)" },
          { opacity: 0, transform: `translateX(${menuDrawerTopItemMotion.outOffset})` }
        ],
        { duration: menuDrawerTopItemMotion.outDuration, easing: "ease-in", fill: "forwards" }
      );
      return animation.finished.then(() => {
        item.style.opacity = "0";
        item.style.transform = "";
      }).catch(() => {});
    });

    await Promise.all(animations);
  }

  async #animateTopPanelItemsIn(panel) {
    const items = this.#getTopPanelItems(panel);
    if (!items.length) return;
    if (!matchMediaQuery("motion")) {
      items.forEach((item) => {
        item.style.opacity = "1";
        item.style.transform = "";
      });
      return;
    }

    items.forEach((item) => {
      item.style.opacity = "0";
      item.style.transform = `translateX(${menuDrawerTopItemMotion.inOffset})`;
    });

    const animations = items.map((item, index) => {
      const animation = item.animate(
        [
          { opacity: 0, transform: `translateX(${menuDrawerTopItemMotion.inOffset})` },
          { opacity: 1, transform: "translateX(0)" }
        ],
        { duration: menuDrawerTopItemMotion.inDuration, delay: index * menuDrawerTopItemMotion.stagger, easing: "ease-out", fill: "forwards" }
      );
      return animation.finished.then(() => {
        item.style.opacity = "1";
        item.style.transform = "";
      }).catch(() => {});
    });

    await Promise.all(animations);
  }
};

function setMenuDrawerSubmenuOpen(menuDrawer, isOpen) {
  if (!menuDrawer) return;
  const top = $4(".hdt-menu-drawer__top", menuDrawer);
  if (top) {
    if (isOpen) top.style.setProperty("--hdt-menu-drawer-top-height", `${top.scrollHeight}px`);
    top.toggleAttribute("aria-hidden", isOpen);
    if ("inert" in top) top.inert = isOpen;
  }
  menuDrawer.classList.toggle("hdt-menu-drawer--submenu-open", isOpen);
}

var _menu_drawer = new WeakMap(), _menu_drawer_prev = new WeakMap(), _menu_drawer_title = new WeakMap(), _menu_drawer_first_level = new WeakMap(),
_menu_open_panel = new WeakSet(), menu_open_panel_fn,
_menu_panel_prev = new WeakSet(), menu_close_panel_fn;
class MenuPanel extends HTMLElement {
  #controller;
  constructor() {
    super();
    getterAdd(_menu_drawer, this, $4('#menu-drawer'));
    getterAdd(_menu_panel_prev, this);
    getterAdd(_menu_open_panel, this);
  }
  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    const trigger = $4(`[panel-id="${this.id}"]`, this.menuDrawer);
    trigger?.addEventListener('click', getterRunFn(_menu_open_panel, this, menu_open_panel_fn).bind(this), { signal });
    if (!this.hidden) this.btnPrev?.addEventListener('click', getterRunFn(_menu_panel_prev, this, menu_close_panel_fn).bind(this), { once: true, signal });
  }
  disconnectedCallback() {
    this.#controller.abort();
    this.abortController?.abort();
  }
  get menuDrawer() {
    return getterGet(_menu_drawer, this, $4('#menu-drawer'))
  }
  get btnPrev() {
    return getterGet(_menu_drawer_prev, this, $4('.hdt-menu-drawer__prev', this.menuDrawer));
  }
  get title() {
    return getterGet(_menu_drawer_title, this, $4('.hdt-menu-drawer__title', this.menuDrawer));
  }
  get firstLevel() {
    return getterGet(_menu_drawer_first_level, this, $4('.hdt-menu-drawer__find-store', this.menuDrawer));
  }
};
menu_open_panel_fn = async function(e) {
  e.preventDefault();
  const target = e.target.tagName === 'A' ? e.target : e.target.closest('a'),
  linksPrev = $$4("li", target.closest('.hdt-menu-drawer__nav')),
  links = $$4("li,[reveal]", this);
  const panelId = target?.getAttribute('panel-id');
  const panel = panelId ? $4(`#${panelId}`, this.menuDrawer) : null;
  if (!target || !panel) {
    console.error('[MenuDrawer] Cannot open panel: trigger or panel is missing', { panelId, panel });
    return;
  }
  const revealSimultaneously = !!this.menuDrawer?.closest('.hdt-header-nav-eff--reveal-simultaneously');
  const linksAnimate = revealSimultaneously ? { duration: 0.15,  ease: "easeOut" }: { duration: 0.15, delay: stagger(linksPrev.length < 10 ? 0.07 : 0.035), ease: "easeOut" };
  const linksPrevAnimate = revealSimultaneously ? { duration: 0.15, ease: "easeIn" }: { duration: 0.15, at: "-0.15", delay: stagger(links.length > 15 ? 0.08 : 0.035), ease: "easeIn" };
  this.title.textContent = target.textContent;
  animate(this.title, { opacity: [0, 1],transform: ["translateY(-10px)", "translateY(0)"] }, { duration: 0.15, ease: "easeOut" });
  animate(this.btnPrev, { opacity: [0, 1],transform: ["translateY(-10px)", "translateY(0)"] }, { duration: 0.15, ease: "easeOut", at: "-0.15" });
  if (this.firstLevel) animate(this.firstLevel, { opacity: [1, 0],transform: ["translateY(0)", "translateY(-10px)"] }, { duration: 0.15, ease: "easeIn", at: "-0.15" });
  setMenuDrawerSubmenuOpen(this.menuDrawer, true);
  await animate(linksPrev, { opacity: [1, 0],transform: ["translateX(0)", "translateX(-10px)"] }, linksPrevAnimate);
  target.closest('.hdt-menu-drawer__nav').setAttribute('hidden', '');
  panel.removeAttribute('hidden');
  animate(links, { opacity: [0, 1],transform: ["translateX(-10px)", "translateX(0)"] }, linksAnimate);
  this.abortController = new AbortController();
  this.btnPrev?.addEventListener('click', getterRunFn(_menu_panel_prev, this, menu_close_panel_fn).bind(this), { signal: this.abortController.signal });
};
menu_close_panel_fn = async function() {
  if (this.hidden) return;
  const links = $$4(".hdt-menu-drawer__nav li", this.menuDrawer),
  linksPrev = $$4("li", this);
  const revealSimultaneously = !!this.menuDrawer?.closest('.hdt-header-nav-eff--reveal-simultaneously');
  const linksAnimate = revealSimultaneously ? { duration: 0.15, ease: "easeOut" }: { duration: 0.15, delay: stagger(links.length > 15 ? 0.08 : 0.035), ease: "easeOut" };
  const linksPrevAnimate = revealSimultaneously ? { duration: 0.15, ease: "easeIn" }: { duration: 0.15, delay: stagger(linksPrev.length < 10 ? 0.07 : 0.035), ease: "easeIn" };
  animate(this.title, { opacity: [1, 0],transform: ["translateY(0)", "translateY(-10px)"] }, { duration: 0.15, ease: "easeOut" });
  animate(this.btnPrev, { opacity: [1, 0],transform: ["translateY(0)", "translateY(-10px)"] }, { duration: 0.15, ease: "easeOut", at: "-0.15" });
  if (this.firstLevel) animate(this.firstLevel, { opacity: [0, 1],transform: ["translateY(-10px)", "translateY(0)"] }, { duration: 0.15, ease: "easeOut", at: "-0.15" });
  await animate(linksPrev, { opacity: [1, 0],transform: ["translateX(0)", "translateX(-10px)"] }, linksPrevAnimate);
  this.setAttribute('hidden', '');
  $4('.hdt-menu-drawer__nav', this.menuDrawer).removeAttribute('hidden');
  setMenuDrawerSubmenuOpen(this.menuDrawer, false);
  animate(links, { opacity: [0, 1],transform: ["translateX(-10px)", "translateX(0)"] }, linksAnimate);
  this.abortController?.abort();
};

var _cart_update = new WeakSet(), cart_update_fn,
_cart_reload = new WeakSet(), cart_reload_fn,
_cart_pageshow = new WeakSet(), cart_pageshow_fn,
_cart_section_id = new WeakMap();
class CartDrawer extends Drawer {
  #controller;
  constructor() {
    super();
    getterAdd(_cart_update, this);
    getterAdd(_cart_reload, this);
    getterAdd(_cart_pageshow, this);
    getterAdd(_cart_section_id, this, this.getAttribute('section-id'));
  }
  connectedCallback() {
    super.connectedCallback();
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    document.addEventListener(cartUpdate, getterRunFn(_cart_update, this, cart_update_fn).bind(this), { signal });
    document.addEventListener("cart:tab", getterRunFn(_cart_reload, this, cart_reload_fn).bind(this), { signal });
    document.addEventListener(cartReload, getterRunFn(_cart_reload, this, cart_reload_fn).bind(this), { signal });
    window.addEventListener("pageshow", getterRunFn(_cart_pageshow, this, cart_pageshow_fn).bind(this), { signal });

    this.dialog.addEventListener(dialogOpening, () => {
      $4('.hdt-marquee', this)?._animation?.play();
    }, { signal });
    this.dialog.addEventListener(dialogClosing, () => {
      $4('.hdt-marquee', this)?._animation?.pause();
    }, { signal });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller.abort();
  }
  get sectionId() {
    return getterGet(_cart_section_id, this) || 'cart-drawer';
  }
  get sectionsToRender() {
    return [
      {
        id: this.sectionId
      },
      {
        id: 'cart-json'
      }
    ];
  }

  /**
   * @param {any} element
   */
  // set focusElement(element) {
  //   this._focusElement = element;
  // }
  // get focusElement() {
  //   return this._focusElement ? this._focusElement : document.activeElement;
  // }
};
cart_update_fn = async function(event) {
  //console.log(cartUpdate, event.detail)
  const {cartData, source, actionAfterATC, name, index} = event.detail,
  {item_count} = cartData,
  cartdrawerDom = new DOMParser().parseFromString(cartData.sections[this.sectionId], "text/html");
  let animation;
  if (item_count == 0) {
    const sequence    = [],
          shippingBar = $4('.hdt-free-shipping-bar', this);
    if (shippingBar) sequence.push([$4('.hdt-free-shipping-bar', this), { opacity: [1, 0] }, { duration: 0.15, ease: "easeIn" }]);
     sequence.push(
      [$4('.hdt-cart-drawer-items', this), { opacity: [1, 0], y: [0, 30] }, { duration: 0.25, ease: "easeIn", ...(shippingBar && { at: "<" }) }],
      [$4('.hdt-cart-drawer__footer', this), { opacity: [1, 0], y: [0, 30] }, { duration: 0.25, ease: "easeIn", at: 0.15 }]);
    animation = animate(sequence);
  } else {
    animation = animate(this, {}, { duration: 0 })
  }
  await animation;
  this.dialog.classList.toggle('is-empty', item_count == 0);

  // update gift wrap
  $4('[aria-controls="CartDrawer-Gift"]', this)?.toggleAttribute('hidden', $4('.is-gift-wrap', cartdrawerDom));

  const selectors = ['.hdt-free-shipping-bar', '.hdt-cart-drawer-empty', '#CartDrawer-CartItems', '#CartDrawer-complementary', '.hdt-cart__discount', '.js-contents'];
  for (const selector of selectors) {
    const targetElement = $4(selector, this);
    const sourceElement = $4(selector, cartdrawerDom);
    if (!targetElement || !sourceElement) continue;
    if (selector == selectors[0]) {
      //$4('.hdt-progress-bar', sourceElement).setAttribute('aria-valuenow', $4('.hdt-progress-bar', targetElement).getAttribute('aria-valuenow'));
      $4('.hdt-progress-bar', sourceElement).style.setProperty('--progress-rate', $4('.hdt-progress-bar', targetElement).style.getPropertyValue('--progress-rate'));
      targetElement.replaceWith(sourceElement);
      $4('.hdt-progress-bar', this).now = $4('.hdt-progress-bar', sourceElement).getAttribute('aria-valuenow');
    } else if (selector != selectors[3]) {
      targetElement.replaceWith(sourceElement);
    } else if ( targetElement.dataset.id !== sourceElement.dataset.id ) {
      targetElement.replaceWith(sourceElement);
    }
  }
  if (item_count == 0) {
    this.isEmpty = true;
    animate([
      [$4('.hdt-dialog-drawer__inner', this), { opacity: [0, 1], transform: ["translateY(30px)", "translateY(0)"] }, { duration: 0.25, ease: [0.25, 0.46, 0.45, 0.94] }],
    ]);
  } else if (this.isEmpty) {
    this.isEmpty = false;
    const sequence    = [],
          shippingBar = $4('.hdt-free-shipping-bar', this);
    if (shippingBar) sequence.push([$4('.hdt-free-shipping-bar', this), { opacity: [0, 1] }, { duration: 0.15, ease: "easeOut" }]);
    sequence.push(
      [$4('.hdt-cart-drawer-items', this), { opacity: [0, 1], y: [30, 0] }, { duration: 0.25, ease: "easeOut", ...(shippingBar && { at: "<" }) }],
      [$4('.hdt-cart-drawer__footer', this), { opacity: [0, 1], y: [30, 0] }, { duration: 0.25, ease: "easeOut", at: 0.15 }]);
    animate(sequence);
  }
  if ( source === 'product-form') {
    const action = actionAfterATC || themeHDN.settings.actionAfterATC;
    if ( action === 'open_cart_drawer' ) {
      this.open();
    } else if ( action.indexOf('close:') > -1 ) {
      $4(action.split(':')[1]).parentElement?.close();
    }
  }

  // Focus back to the add to cart button
  // console.log(item_count, name, index)
  if (item_count === 0) {
    trapFocus(this.dialog, $4('.hdt-cart-drawer-empty a', this.dialog) || this.dialog);
  } else if (name && index) {
    const lineItem = $id4(`CartDrawer-Item-${index}`);
    const nameLineItem = $4(`[name="${name}"]`, lineItem);
    if (lineItem && nameLineItem) {
      trapFocus(this.dialog, nameLineItem);
    } else if ($4('.hdt-cart-item'), this.dialog) {
      trapFocus(this.dialog, $4('.hdt-cart-item-header a', this.dialog));
    }
  }
};
cart_reload_fn = async function(event) {
  //console.log('cart_reload_fn', event)
  try {
    let cartData;
    if (event && event.type == 'cart:tab' && event.detail.sections && event.detail.sections[getterGet(_cart_section_id, this)]) {
      cartData = event.detail
    } else {
      const response = await fetch(`${Shopify.routes.root}?sections=${getterGet(_cart_section_id, this)},cart-json`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const responseJson = await response.json();
      const cartJson = responseJson['cart-json'].split('[split_94]')[1] || '{}';
      cartData = JSON.parse(cartJson);

      //document.dispatchEvent(new CustomEvent(cartCount, { detail: { item_count: cartData.item_count } }));

      cartData.sections = {};
      cartData.sections[getterGet(_cart_section_id, this)] = responseJson[getterGet(_cart_section_id, this)];
    }

    $4('#CartDrawer-complementary')?.setAttribute('data-id', '1509'); //reset id
    //getterRunFn(_cart_update, this, cart_update_fn).call(this, evtCustom);
    this.dispatchEvent(new CustomEvent(cartUpdate, {
      bubbles: true,
      detail: {
        cartData,
        source: 'reload',
        actionAfterATC: 'no_action'
      }
    }));
  } catch (error) {
    console.error('Failed to reload cart:', error);
  }
}
cart_pageshow_fn = async function(event) {
  if (!event.persisted) return;
  getterRunFn(_cart_reload, this, cart_reload_fn).call(this);
};

var _cart_main_update = new WeakSet(), cart_main_update_fn,
_cart_main_reload = new WeakSet(), cart_main_reload_fn,
_cart_main_section_id = new WeakMap();
class CartMain extends HTMLElement {
  #controller;
  constructor() {
    super();
    getterAdd(_cart_main_update, this);
    getterAdd(_cart_main_reload, this);
    getterAdd(_cart_main_section_id, this, this.getAttribute('section-id'));
    this.prevCount = parseInt(this.getAttribute('cart-count'));
  }
  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    document.addEventListener(cartUpdate, getterRunFn(_cart_main_update, this, cart_main_update_fn).bind(this), { signal });
    document.addEventListener("cart:tab", getterRunFn(_cart_main_reload, this, cart_main_reload_fn).bind(this), { signal });
    document.addEventListener(cartReload, getterRunFn(_cart_main_reload, this, cart_main_reload_fn).bind(this), { signal });
  }
  disconnectedCallback() {
    this.#controller.abort();
  }
  get sectionsToRender() {
    return [
      {
        id: this.sectionId
      },
      {
        id: 'cart-json'
      }
    ];
  }
  get sectionId() {
    return getterGet(_cart_main_section_id, this) || 'main-cart';
  }
};
cart_main_update_fn = async function(event) {
  //console.log('cart-main-update', event.detail);
  const {cartData, name, index} = event.detail,
  {item_count} = cartData,
  newCartMain = document.createRange().createContextualFragment(cartData.sections[this.sectionId]);
  let animation;

  if (item_count == 0) {
    animation = animate([
      [$4('.hdt-cart-header', this), { opacity: [1, 0], transform: ["translateY(0)", "translateY(30px)"] }, { duration: 0.15 }],
      [$4('cart-items', this), { opacity: [1, 0], transform: ["translateY(0)", "translateY(30px)"] }, { duration: 0.15 }],
      [$$4('.hdt-cart__shipping-estimator, .hdt-cart__blocks', this), { opacity: [1, 0], transform: ["translateY(0)", "translateY(30px)"] }, { duration: 0.15 }]
    ]);
  } else if (this.prevCount == 0 && item_count > 0) {
    animation = animate($4('.hdt-cart-empty', this), { opacity: [1, 0], transform: ["translateY(0)", "translateY(30px)"] }, { duration: 0.25 })
  } else {
    animation = animate(this, {}, { duration: 0 })
  }
  await animation;

  this.classList.toggle('is-empty', item_count == 0);
  // Update gift wrap
  $4('.hdt-page-cart__add-gift', this)?.toggleAttribute('hidden', $4('.is-gift-wrap', newCartMain));
  if ($4('.hdt-page-cart__add-gift', this)?.hidden) $4('[type="checkbox"]', $4('.hdt-page-cart__add-gift', this)).checked = false;

  const selectors = ['.hdt-free-shipping-bar', '#main-cart-items', '.js-contents', '#Cart-complementary', '.hdt-cart__discount', '.hdt-cart-empty'];
  for (const selector of selectors) {
    const targetElement = $4(selector, this);
    const sourceElement = $4(selector, newCartMain);
    if (!targetElement || !sourceElement) continue;
    if (selector == selectors[0]) {
      //$4('.hdt-progress-bar', sourceElement).setAttribute('aria-valuenow', $4('.hdt-progress-bar', targetElement).getAttribute('aria-valuenow'));
      $4('.hdt-progress-bar', sourceElement).style.setProperty('--progress-rate', $4('.hdt-progress-bar', targetElement).style.getPropertyValue('--progress-rate'));
      targetElement.replaceWith(sourceElement);
      $4('.hdt-progress-bar', this).now = $4('.hdt-progress-bar', sourceElement).getAttribute('aria-valuenow');
    } else if (selector != selectors[3]) {
      targetElement.replaceWith(sourceElement);
    } else if ( targetElement.dataset.id !== sourceElement.dataset.id ) {
      targetElement.replaceWith(sourceElement);
    }
  }

  if (item_count == 0) {
    animate($4('.hdt-cart-empty', this), { opacity: [0, 1], transform: ["translateY(30px)", "translateY(0)"] }, { duration: 0.25 })
  } else if (this.prevCount == 0 && item_count > 0) {
    animate([
      [$4('.hdt-cart-header', this), { opacity: [0, 1], transform: ["translateY(30px)", "translateY(0px)"] }, { duration: 0.15 }],
      [$4('cart-items', this), { opacity: [0, 1], transform: ["translateY(30px)", "translateY(0px)"] }, { duration: 0.15 }],
      [$$4('.hdt-cart__shipping-estimator,.hdt-cart__blocks', this), { opacity: [0, 1], transform: ["translateY(30px)", "translateY(0px)"] }, { duration: 0.15 }],
    ]);
  }
  this.prevCount = item_count;

  // Focus back to the add to cart button
  // console.log(item_count, name, index)
  if (item_count === 0) {
    $4('.hdt-cart-empty a', this)?.focus();
  } else if (name && index) {
    const lineItem = $id4(`CartItem-${index}`);
    const nameLineItem = $4(`[name="${name}"]`, lineItem);
    if (lineItem && nameLineItem) {
      nameLineItem.focus();
    } else if ($4('.hdt-main-cart-item'), this) {
      $4('.hdt-main-cart-item__name a', this).focus();
    }
  }
};
cart_main_reload_fn = async function(event) {
  try {
    let cartData;
    if (event && event.type == 'cart:tab' && event.detail.sections && event.detail.sections[getterGet(_cart_main_section_id, this)]) {
      cartData = event.detail
    } else {
      const response = await fetch(`${Shopify.routes.root}?sections=${getterGet(_cart_main_section_id, this)},cart-json`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const responseJson = await response.json();
      const cartJson = responseJson['cart-json'].split('[split_94]')[1] || '{}';
      cartData = JSON.parse(cartJson);

      //document.dispatchEvent(new CustomEvent(cartCount, { detail: { item_count: cartData.item_count } }));

      cartData.sections = {};
      cartData.sections[getterGet(_cart_main_section_id, this)] = responseJson[getterGet(_cart_main_section_id, this)];
    }

    const evtCustom = {
      detail: {
        cartData,
        source: 'reload',
        actionAfterATC: 'no_action'
      }
    };

    $4('#Cart-complementary')?.setAttribute('data-id', '1509'); //reset id
    getterRunFn(_cart_main_update, this, cart_main_update_fn).call(this, evtCustom);
  } catch (error) {
    console.error('Failed to reload cart:', error);
  }
};

var _cart_items_update_qty = new WeakSet(), cart_items_update_qty_fn;
class CartItems extends HTMLElement {
  #controller;
  constructor() {
    super();
    getterAdd(_cart_items_update_qty, this);
  }

  connectedCallback() {
    this.#controller = new AbortController();
    this.lineItemStatusElement = document.getElementById('CartDrawer-LineItemStatus') || document.getElementById('shopping-cart-line-item-status');
    //this.addEventListener('change', debounce(), { signal: this.#controller.signal });
    this.addEventListener('change', debounce((event) => {
      this.onChange(event);
    }, 100).bind(this), { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  resetQuantityInput(id) {
    const input = $4(`#Drawer-quantity-${id}`, this) || $4(`#Quantity-${id}`, this);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value),
    { key, index } = event.target.dataset,
    { min_error, max_error, step_error } = themeHDN.strings.cart;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      getterRunFn(_cart_items_update_qty, this, cart_items_update_qty_fn).call(this, event, key, inputValue, document.activeElement.getAttribute('name'), event.target.dataset.variantId, index);
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }
  updateQuantity(event, key, quantity, name, variantId, index) {
    getterRunFn(_cart_items_update_qty, this, cart_items_update_qty_fn).call(this, event, key, quantity, name, variantId, index);
  }

  get sectionsToRender() {
    return [
      {
        id: this.dataset.id
      }
    ];
  }
};
cart_items_update_qty_fn = async function(event, id, quantity, name, variantId, index) {
  // console.log('cart-update-qty: ', this, event, id, quantity, name, variantId);
  // console.log(this.sectionsToRender.map((section) => section.id))
  document.dispatchEvent(new CustomEvent(loadingStart));
  this.closest('#CartDrawer, #MainCart')?.setAttribute('effect-blur', '');
  const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      id,
      quantity,
      sections: this.sectionsToRender.map((section) => section.id),
    })
  });
  const cartData = await response.json();
  document.dispatchEvent(new CustomEvent(loadingEnd));
  this.closest('#CartDrawer, #MainCart')?.removeAttribute('effect-blur');
  if (response.ok) {
    document.dispatchEvent(new CustomEvent(cartUpdate, {
      bubbles: true,
      detail: {
        source: 'cart-items',
        variantId,
        cartData,
        name,
        index
      }
    }));
  } else {
    const {description, message} = cartData;
    document.dispatchEvent(new CustomEvent(cartError, {
      bubbles: true,
      detail: {
        source: 'cart-items',
        errors: message || description,
        message
      }
    }));

  }
};
class CartDrawerItems extends CartItems {

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('scroll', this.#update);
    this.#resizeObserver.observe(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('scroll', this.#update);
    this.#resizeObserver.disconnect();
  }

  #update = () => {
    const { scrollTop, scrollHeight, clientHeight, scrollLeft, scrollWidth, clientWidth } = this;
    const scrollDirection = scrollWidth > clientWidth ? 'horizontal' : 'vertical';
    const scrollPercentage = scrollDirection === 'vertical' ? scrollTop / (scrollHeight - clientHeight) : scrollLeft / (scrollWidth - clientWidth);
    //console.log(scrollPercentage);
    this.style.maskImage = Number.isNaN(scrollPercentage) ? '' : `linear-gradient(to ${scrollDirection === 'vertical' ? 'bottom' : 'right'}, transparent ${scrollPercentage > 0 ? 1 : 0}%, black ${scrollPercentage < 0.1 ? scrollPercentage * 100 : 10}%, black ${scrollPercentage > 0.9 ? scrollPercentage * 100 : 90}%, transparent 100%)`;
  };
  #resizeObserver = new ResizeObserver(this.#update);
};
class CartRemoveButton extends HTMLElement {
  #controller;
  constructor() {
    super();
  }
  connectedCallback() {
    this.#controller = new AbortController();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems?.updateQuantity(event, this.dataset.key, 0, '', this.dataset.variantId, this.dataset.index);
    }, { signal: this.#controller.signal });
  }
  disconnectedCallback() { this.#controller.abort(); }
}
class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('input', debounce((event) => {
        fetch(`${Shopify.routes.root}cart/update.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ note: event.target.value }),
          keepalive: true
        })
        .then(() => {
          if (this.dataset.type != 'cart-drawer') return;
         const currentText = this.dataset[event.target.value.length ? 'edit' : 'add'],
               control     = $4('[aria-controls="CartDrawer-Note"]');
          $4('label', this).textContent = currentText;
          control?.setAttribute('aria-label', currentText)
          control?.classList.toggle('has-noted', event.target.value.length);
        });
      }, 300)
    );
  }
};
class CartAction extends DialogComponent {
  #controller;
  constructor() {
    super();
  }
  connectedCallback () {
    super.connectedCallback();
    const cartDrawer = $4('cart-drawer');
    if (!cartDrawer) return;
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    let btnOpening;
    document.addEventListener(discountUpdate, () => {
      setTimeout(() => {
        if (this.dialog.open) trapFocus(this.dialog);
      }, 60);
    }, { signal });
    this.dialog.addEventListener(dialogOpening, () => {
      btnOpening = this.dialog.btnOpening;
      cartDrawer.classList.add('is-cart-openabled');
    }, { signal });
    this.dialog.addEventListener(dialogClose, () => {
      cartDrawer.classList.remove('is-cart-openabled');
      trapFocus(cartDrawer.dialog);
      elFocus(btnOpening, false, true);
    }, { signal });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
  }
  animateDialogOpen() {
    return animate(this.dialog, {
      transform: ['translate3d(0, 100%, 0)', 'translate3d(0, 0, 0)']
    }, {
      duration: 0.5,
      ease: [0.19, 1, 0.22, 1]
    });
  }
  animateDialogClose() {
    return animate(this.dialog, {
      transform: ['translate3d(0, 0, 0)', 'translate3d(0, 100%, 0)']
    }, {
      duration: 0.4,
      ease: [0.19, 1, 0.22, 1]
    });
  }
};

/**
 * https://shopify.dev/docs/themes/ajax-api/reference/cart#generate-shipping-rates
 * https://community.shopify.com/c/shopify-design/cart-add-a-shipping-rates-calculator-to-your-cart/td-p/616554
 */
var _calc_shipping = new WeakSet(), calc_shipping_fn,
_async_shipping_rates = new WeakSet(), async_shipping_rates_fn,
_shipping_rates_ok = new WeakSet(), shipping_rates_ok_fn,
_shipping_rates_error = new WeakSet(), shipping_rates_error_fn;
class ShippingCalculator extends HTMLElement {
  #controller;
  constructor() {
    super();
    getterAdd(_calc_shipping, this);
    getterAdd(_async_shipping_rates, this);
    getterAdd(_shipping_rates_ok, this);
    getterAdd(_shipping_rates_error, this);
    this.langRates = JSON.parse( $4('template[data-lang-rates]', this).innerHTML );
  }
  connectedCallback() {
    this.#controller = new AbortController();
    this.submitButton = $4('[type="button"]', this);
    this.resultsElement = $4('[aria-live="polite"]', this);
    this.submitButton.addEventListener("click", getterRunFn(_calc_shipping, this, calc_shipping_fn).bind(this), { signal: this.#controller.signal });
  }
  disconnectedCallback() {
    this.#controller.abort();
  }
};
calc_shipping_fn = async function(event) {
  event.preventDefault();
  const zip = $4('[name="address[zip]"]', this).value,
  country = $4('[name="address[country]"]', this).value,
  $province = $4('[name="address[province]"]', this),
  province = $province.disabled ? '' : $province.value;
  this.submitButton.setAttribute("aria-busy", "true");
  document.dispatchEvent(new CustomEvent(loadingStart));
  const response = await fetch(`${Shopify.routes.root}cart/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`, { method: "POST" });
  document.dispatchEvent(new CustomEvent(loadingEnd));
  if (response.ok) {
    const shippingRates = await getterRunFn(_async_shipping_rates, this, async_shipping_rates_fn).call(this, zip, country, province);
    getterRunFn(_shipping_rates_ok, this, shipping_rates_ok_fn).call(this, shippingRates);
  } else {
    const jsonError = await response.json();
    getterRunFn(_shipping_rates_error, this, shipping_rates_error_fn).call(this, jsonError);
  }
  this.resultsElement.hidden = false;
  this.submitButton.removeAttribute("aria-busy");
};
async_shipping_rates_fn = async function(zip, country, province) {
  const response = await fetch(`${Shopify.routes.root}cart/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`);
  const responseAsText = await response.text();
  if (responseAsText === "null") {
    return getterRunFn(_async_shipping_rates, this, async_shipping_rates_fn).call(this, zip, country, province);
  } else {
    return JSON.parse(responseAsText).shipping_rates;
  }
};
shipping_rates_ok_fn = function(shippingRates) {
  let ratesList = shippingRates.map((shippingRate) => {
    return `<li>${shippingRate.presentment_name}: ${ shippingRate.price == "0.00" ? this.langRates.free : `<span class="hdt-money">${currency.convert(shippingRate.price)}</span>` }</li>`;
  });
  this.resultsElement.innerHTML = `<div class="hdt-mess__rates is--rates-success"><p>${shippingRates.length === 0 ? this.langRates.no_rates : shippingRates.length === 1 ? this.langRates.one_rate : this.langRates.multiple_rates}</p>${ratesList === "" ? "" : `<ul role="list">${ratesList.join('')}</ul>`}</div>`;
  document.dispatchEvent(new CustomEvent("currencyUpdate"));
};
shipping_rates_error_fn = function(errors) {
  let errorHtml = Object.keys(errors).map((errorKey) => {
    return `<li><span class="hdt-key__rate">${errorKey}:</span> ${errors[errorKey]}</li>`;
  });
  this.resultsElement.innerHTML = `<div class="hdt-mess__rates is--rates-error"><p>${this.langRates.errors}</p><ul role="list">${errorHtml.join('')}</ul></div> `;
};

class GiftTick extends HTMLElement {
  constructor() {
    super();
    $4('[type="checkbox"]', this)?.addEventListener('change', (e)=> {
      if (e.target.checked) $4('[name="add"]', $id4(this.getAttribute('form'))).click();
    });
  }
};
// cart count
var _get_cart_count = new WeakSet(), get_cart_count_fn,
_car_count_section = new WeakMap();
class HdtCartCount extends HTMLElement {
  #controller;
  constructor() {
    super();
    getterAdd(_get_cart_count, this);
    getterAdd(_car_count_section, this, $4('[ref="hdt-cart"]'));
  }
  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    document.addEventListener('cart:live', (event) => this.itemCount = event.detail.item_count, { signal });
    document.addEventListener('cart:tab', (event) => this.itemCount = event.detail.item_count, { signal });
    window.addEventListener("pageshow", getterRunFn(_get_cart_count, this, get_cart_count_fn).bind(this), { signal });
  }
  disconnectedCallback() {
    this.#controller.abort();
  }
  get cart() {
    return getterGet(_car_count_section, this);
  }
  /**
   * @param {number} count
   */
  set itemCount(count) {
    this.innerText = count;
    this.classList.toggle('is-visible', count > 0);
  }
}
get_cart_count_fn = async function(event) {
  if (!event.persisted) return;
  this.itemCount = await getCart().then((data) => data.item_count);
};
// cart dot
class CartDot extends HdtCartCount {
  /**
   * @param {number} count
   */
  set itemCount(count) {
    this.classList.toggle('is-visible', count > 0);
  }
}

class CartDiscount extends HTMLElement {
  #controller;
  #errors;
  #cart
  constructor() {
    super();
  }

  /** @type {AbortController | null} */
  #activeFetch = null;

  #createAbortController() {
    if (this.#activeFetch) {
      this.#activeFetch.abort();
    }

    const abortController = new AbortController();
    this.#activeFetch = abortController;
    return abortController;
  }

  connectedCallback() {
    this.#errors = {
      wrap: $4('[ref="cartDiscountError"]', this),
      discount: $4('[ref="cartDiscountErrorDiscountCode"]', this),
      shipping: $4('[ref="cartDiscountErrorShipping"]', this),
    };
    this.#cart = $4('[ref="hdt-cart"]');

    this.#controller = new AbortController();
    const { signal } = this.#controller;
    $4('form', this).addEventListener('submit', this.#applyDiscount.bind(this), { signal });
    //this.addEventListener('click', this.#removeDiscount, { signal });
  }

  disconnectedCallback() {
    this.#errors = null;
    this.#controller.abort();
    if (this.#activeFetch) {
      this.#activeFetch.abort();
      this.#activeFetch = null;
    }
  }

  /**
   * Handles updates to the cart note.
   * @param {SubmitEvent} event - The submit event on our form.
   */
  #applyDiscount = async (event) => {

    event.preventDefault();
    event.stopPropagation();

    const form = event.target;

    if (!(form instanceof HTMLFormElement)) return;

    const discountCode = $4('input[name="discount"]', form),
    discountCodeValue = discountCode.value;

    if (!(discountCode instanceof HTMLInputElement) || typeof this.dataset.sectionId !== 'string' || discountCodeValue.length === 0) return;

    const abortController = this.#createAbortController();
    try {
      const existingDiscounts = this.#existingDiscounts();
      if (existingDiscounts.includes(discountCodeValue)) return;

      document.dispatchEvent(new CustomEvent(loadingStart));
      const { wrap, discount, shipping } = this.#errors;
      wrap?.setAttribute('hidden', '');
      discount?.setAttribute('hidden', '');
      shipping?.setAttribute('hidden', '');

      const config = fetchConfig('json', {
        body: JSON.stringify({
          discount: [...existingDiscounts, discountCodeValue].join(','),
          sections: this.#cart.sectionsToRender.map((section) => section.id)
        }),
      });

      const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
        ...config,
        signal: abortController.signal,
      }),
      data = await response.json();
      document.dispatchEvent(new CustomEvent(loadingEnd));
      if (
        data.discount_codes.find((/** @type {{ code: string; applicable: boolean; }} */ discount) => {
          return discount.code === discountCodeValue && discount.applicable === false;
        })
      ) {
        discountCode.value = '';
        this.#handleDiscountError('discount_code');
        return;
      }

      const parsedHtml = new DOMParser().parseFromString(data.sections[this.dataset.sectionId], 'text/html'),
      section = parsedHtml.getElementById(`shopify-section-${this.dataset.sectionId}`);

      if (section) {
        const discountCodes = $$4('.hdt-cart-discount__pill', section),
        codes = discountCodes
          .map((element) => (element instanceof HTMLLIElement ? element.dataset.discountCode : null))
          .filter(Boolean);
        // Before morphing, we need to check if the shipping discount is applicable in the UI
        // we check the liquid logic compared to the cart payload to assess whether we leveraged
        // a valid shipping discount code.
        if (
          codes.length === existingDiscounts.length &&
          codes.every((/** @type {string} */ code) => existingDiscounts.includes(code)) &&
          data.discount_codes.find((/** @type {{ code: string; applicable: boolean; }} */ discount) => {
            return discount.code === discountCodeValue && discount.applicable === true;
          })
        ) {
          this.#handleDiscountError('shipping');
          discountCode.value = '';
          return;
        }
      }

      document.dispatchEvent(new DiscountUpdateEvent(data, this.id));
      document.dispatchEvent(new CustomEvent(cartUpdate, {
        bubbles: true,
        detail: {
          source: 'cart-discount',
          cartData: data
        }
      }));
    } catch (error) {
      document.dispatchEvent(new CustomEvent(loadingEnd));
    } finally {
      this.#activeFetch = null;
    }
  };

  /**
   * Handles removing a discount from the cart.
   * @param {MouseEvent | KeyboardEvent} event - The mouse or keyboard event in our pill.
   */
  removeDiscount = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if ((event instanceof KeyboardEvent && event.key !== 'Enter') || !(event instanceof MouseEvent) || !(event.target instanceof HTMLElement) || typeof this.dataset.sectionId !== 'string') return;

    const pill = event.target.closest('.hdt-cart-discount__pill');
    if (!(pill instanceof HTMLLIElement)) return;

    const discountCode = pill.dataset.discountCode;
    if (!discountCode) return;

    const existingDiscounts = this.#existingDiscounts();
    const index = existingDiscounts.indexOf(discountCode);
    if (index === -1) return;

    existingDiscounts.splice(index, 1);

    const abortController = this.#createAbortController();

    try {
      document.dispatchEvent(new CustomEvent(loadingStart));
      const config = fetchConfig('json', {
        body: JSON.stringify({ discount: existingDiscounts.join(','), sections: this.#cart.sectionsToRender.map((section) => section.id) }),
      }),
      response = await fetch(`${Shopify.routes.root}cart/update.js`, {
        ...config,
        signal: abortController.signal,
      }),
      data = await response.json();

      document.dispatchEvent(new CustomEvent(loadingEnd));
      document.dispatchEvent(new DiscountUpdateEvent(data, this.id));
      document.dispatchEvent(new CustomEvent(cartUpdate, {
        bubbles: true,
        detail: {
          source: 'cart-discount',
          cartData: data
        }
      }));
    } catch (error) {
    } finally {
      this.#activeFetch = null;
    }
  };

  /**
   * Handles the discount error.
   *
   * @param {'discount_code' | 'shipping'} type - The type of discount error.
   */
  #handleDiscountError(type) {
    const { wrap, discount, shipping } = this.#errors,
    target = type === 'discount_code' ? discount : shipping;
    wrap.removeAttribute('hidden');
    target.removeAttribute('hidden');
  }

  /**
   * Returns an array of existing discount codes.
   * @returns {string[]}
   */
  #existingDiscounts() {
    /** @type {string[]} */
    const discountCodes = [];
    const discountPills = $$4('.hdt-cart-discount__pill', this);
    for (const pill of discountPills) {
      if (pill instanceof HTMLLIElement && typeof pill.dataset.discountCode === 'string') {
        discountCodes.push(pill.dataset.discountCode);
      }
    }
    return discountCodes;
  }
}
class CartDiscountRemove extends HTMLElement {
  #controller;
  constructor() {
    super();
  }
  connectedCallback() {
    this.#controller = new AbortController();
    const discountComponent = this.closest('cart-discount-component');
    this.addEventListener('click', (event) => {
      //event.preventDefault();
      discountComponent?.removeDiscount(event);
    }, { signal: this.#controller.signal });
  }
  disconnectedCallback() { this.#controller.abort();}
}

class AgeModal extends Modal {
  #minAge;
  #expireDays;
  #daySelect;
  #monthSelect;
  #yearSelect;
  #requireDob;
  #controller;
  connectedCallback() {
    //console.log('Age Modal: ', $id4('hdt-age-modal'));
    super.connectedCallback();
    this.#controller = new AbortController();
    const { signal } = this.#controller.signal;
    this.#minAge = Number(this.getAttribute('min-age') || 18);
    this.#expireDays = Number(this.getAttribute('expire-days') || 15);

    if (expiresManager.check(this.#storageKey)) return this.dialog.setAttribute('is-verified', '');
    this.lockOpen = true;
    this.#requireDob = this.hasAttribute('require-dob');
    if (this.#requireDob) {
      this.#daySelect = $id4('hdt-age-day');
      this.#monthSelect = $id4('hdt-age-month');
      this.#yearSelect = $id4('hdt-age-year');
      this.#populateSelects();
    }
    if (!Shopify.designMode) this.open();
    const form = $id4('hdt-age-modal_form');
    form?.addEventListener('submit', this.#handleConfirm, { signal });
    form?.addEventListener('reset', this.#handleCancel, { signal });
    // bind change
    this.#monthSelect.addEventListener('change', this.#updateDays, { signal });
    this.#yearSelect.addEventListener('change', this.#updateDays, { signal });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller.abort();
  }
  get #storageKey() {
    return `age:${this.#minAge}`;
  }
  #populate(select, start, end, step = 1) {
    const fragment = document.createDocumentFragment();
    const isDescending = start > end;

    for (let i = start; isDescending ? i >= end : i <= end; i += step) {
      fragment.append(new Option(i, i));
    }
    select.append(fragment);
  }
  #populateSelects() {
    const now = new Date().getFullYear();

    this.#populate(this.#daySelect, 1, 31);
    this.#populate(this.#monthSelect, 1, 12);
    this.#populate(this.#yearSelect, now, now - 100, -1);
  }
  #daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
  }
  #updateDays = () => {
    const m = Number(this.#monthSelect.value),
    y = Number(this.#yearSelect.value),
    maxDays = (m && y) ? this.#daysInMonth(m, y) : 31,
    current = Number(this.#daySelect.value);

    this.#daySelect.innerHTML = `<option value="">${this.#daySelect.options[0].text}</option>`;
    this.#populate(this.#daySelect, 1, maxDays);
    // Keep the old date if it is still valid.
    if (current && current <= maxDays) this.#daySelect.value = current;
  }
  #calcAgeFromSelects() {
    const d = Number(this.#daySelect.value);
    const m = Number(this.#monthSelect.value);
    const y = Number(this.#yearSelect.value);


    if (!d || !m || !y) return null;


    const today = new Date();
    const dob = new Date(y, m - 1, d);


    // invalid date (VD: 31/02)
    if ( dob.getFullYear() !== y || dob.getMonth() !== m - 1 || dob.getDate() !== d ) return null;


    let age = today.getFullYear() - y;
    const diffMonth = today.getMonth() - (m - 1);


    if (diffMonth < 0 || (diffMonth === 0 && today.getDate() < d)) age--;
    return age;
  }
  #handleConfirm = (event) => {
    event.preventDefault();
    if (this.#requireDob) {
      const age = this.#calcAgeFromSelects();
      //console.log(age);
      if (age === null || age < this.#minAge) return this.#shake;
    }
    if (!Shopify.designMode) expiresManager.set(this.#storageKey, this.#expireDays);
    this.close();
    this.#controller.abort();
    document.dispatchEvent(new CustomEvent('theme4:age:verified'));
  };
  #handleCancel = () => {
    this.#shake;
    if (this.hasAttribute('custom-link') && !Shopify.designMode) window.location.href = this.getAttribute('custom-link');
  };
  get #shake() {
    return animate(
      this.dialog,
      // { x: [0, -8, 8, -6, 6, -4, 4, 0] },
      { transform: ['translateX(0px)', 'translateX(-8px)', 'translateX(8px)', 'translateX(-6px)', 'translateX(6px)', 'translateX(-4px)', 'translateX(4px)', 'translateX(0px)'] },
      {
        duration: 0.4,
        ease: 'easeInOut'
      }
    );
  }
}
class NewsletterPopup extends Modal {
  #scrollHandler = null;
  #timeoutId = null;
  #options;
  constructor() {
    super();
    if (expiresManager.check(this.#storageKey)) return;
    const ageModal = $id4('hdt-age-modal'),
    awaitAgeVerification = ageModal ? !ageModal.hasAttribute('is-verified') : false;
    //console.log('awaitAgeVerification: ', awaitAgeVerification);
    this.#options = JSON.parse(this.getAttribute('config') || '{}');

    if (awaitAgeVerification) {
      document.addEventListener('theme4:age:verified', this.#int, { once: true });
    } else {
      this.#int();
    }
    this.lockOpen = true;
    if ($4('.hdt-form__alert--success', this)) expiresManager.set(this.#storageKey, this.#options.expiryDays);
  }
  connectedCallback () {
    super.connectedCallback();
    this.dialog.addEventListener(dialogClose, () => expiresManager.set(this.#storageKey, this.#options.expiryDays), { once: true });
  }

  get #storageKey() {
    return 'newsletter_popup';
  }

  #int = () => {
    if (this.#options.type == 'time') {
      this.#initTimeTrigger();
    } else {
      this.#initScrollTrigger();
    }
  }
  #initTimeTrigger() {
    this.#timeoutId = setTimeout(() => {
      this.open();
      this.#cleanup();
    }, this.#options.timeDelay*1000);
  }
  #initScrollTrigger() {
    this.#scrollHandler = () => {
      const scrollPercent = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
      if (scrollPercent >= this.#options.scrollDelay) {
        this.open();
        this.#cleanup();
      }
    };

    window.addEventListener('scroll', this.#scrollHandler);
  }

  #cleanup() {
    // Cleanup scroll event
    if (this.#scrollHandler) {
      window.removeEventListener('scroll', this.#scrollHandler);
      this.#scrollHandler = null;
    }

    // Cleanup timeout
    if (this.#timeoutId) {
      clearTimeout(this.#timeoutId);
      this.#timeoutId = null;
    }
  }
}

customElements.define("hdt-modal", Modal);
customElements.define("hdt-drawer", Drawer);
customElements.define("hdt-menu-drawer", MenuDrawer);
customElements.define("hdt-menu-panel", MenuPanel);
customElements.define("cart-drawer", CartDrawer);
customElements.define("main-cart", CartMain);
customElements.define('cart-items', CartItems);
customElements.define('cart-drawer-items', CartDrawerItems);
customElements.define('cart-remove-button', CartRemoveButton);
customElements.define('cart-note', CartNote);
customElements.define("hdt-cart-action", CartAction);
customElements.define("hdt-shipping-calculator", ShippingCalculator);
customElements.define("hdt-cart-gift-tick", GiftTick);
customElements.define("hdt-cart-count", HdtCartCount);
customElements.define("hdt-cart-dot", CartDot);
customElements.define('cart-discount-component', CartDiscount);
customElements.define('wrapp-discount-remove', CartDiscountRemove);
customElements.define('hdt-age-modal', AgeModal);
customElements.define("hdt-newsletter-popup", NewsletterPopup);

var _localization_header = new WeakMap(),
_localization_disclosure = new WeakMap();
class LocalizationForm extends HTMLElement {
  #controller;
  constructor() {
    super();
    getterAdd(_localization_header, this, $4('.hdt-sticky-header'));
    getterAdd(_localization_disclosure, this, this.closest('.hdt-disclosure'));
  }
  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    if (this.hasAttribute('get-options') && !this.hasAttribute('added-options')) {
      let optionsDom = document.createRange().createContextualFragment($id4('GlobalCountry-country-results').innerHTML);
      // console.log(optionsDom)
      // Append the cloned content to the form
      $4('form', this)?.lastElementChild?.appendChild(optionsDom);
      this.setAttribute('added-options', '');
      optionsDom = null;
    }
    if (this.hasAttribute('on-header')) {
      this.disclosure?.addEventListener(dialogOpening, () => { this.header.preventHide = true }, { signal });
      this.disclosure?.addEventListener(dialogOpen, () => { this.header.preventHide = true }, { signal });
      this.disclosure?.addEventListener(dialogClosing, () => { this.header.preventHide = false }, { signal });
    }

    this.addEventListener('submit', (e) => {
      this.disclosure?.close();
      if (e.submitter.getAttribute('aria-selected') == 'true') return e.preventDefault();
      document.dispatchEvent(new CustomEvent(loadingStart));
    }, { once: true, signal });
  }
  disconnectedCallback() {
    this.#controller?.abort();
  }
  get header() {
    return getterGet(_localization_header, this);
  }
  get disclosure() {
    return getterGet(_localization_disclosure, this);
  }
};

var _reset_btn_country = new WeakMap(),
_search_country = new WeakMap(),
_disclosure_country = new WeakMap(),
_reset_filter_country = new WeakSet(), reset_filter_country_fn,
_filter_countries = new WeakSet(), filter_countries_fn;
class CountryFilter extends HTMLElement {
  #controller;
  constructor() {
    super();
    getterAdd(_reset_filter_country, this);
    getterAdd(_filter_countries, this);
    getterAdd(_reset_btn_country, this, $4('[type="reset"]', this));
    getterAdd(_search_country, this, $4('[type="search"]', this));
    getterAdd(_disclosure_country, this, this.closest('.hdt-disclosure'));
  }
  get resetButton() {
    return getterGet(_reset_btn_country, this);
  }
  get search() {
    return getterGet(_search_country, this);
  }
  get disclosure() {
    return getterGet(_disclosure_country, this);
  }
  normalizeString(str) {
    return str.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();
  }
  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.search?.addEventListener('keyup', getterRunFn(_filter_countries, this, filter_countries_fn).bind(this), { signal });
    this.search?.addEventListener('keydown', (event) => { if (event.key === 'Escape') event.preventDefault() }, { signal });
    this.resetButton?.addEventListener('click', getterRunFn(_reset_filter_country, this, reset_filter_country_fn).bind(this), { signal });
    this.resetButton?.addEventListener('mousedown', (event) => event.preventDefault(), { signal });
  }
  disconnectedCallback() {
    this.#controller.abort();
  }
};
reset_filter_country_fn = function(event) {
  event.stopPropagation();
  this.search.value = '';
  getterRunFn(_filter_countries, this, filter_countries_fn).call(this);
  this.disclosure.style.minWidth = null;
  //$4('.hdt-popover__body', this.disclosure).style.minHeight = null;
  //this.search.focus();
  this.closest('hdt-popover').updateTrap(this.search);
};
filter_countries_fn = function(e) {
   if (e && e.key === 'Tab') return;
  this.disclosure.style.minWidth = this.disclosure.offsetWidth + 'px';
  //$4('.hdt-popover__body', this.disclosure).style.minHeight = $4('.hdt-popover__inner', this.disclosure).offsetHeight + 'px';
  const searchValue = this.normalizeString(this.search.value);
  const allCountries = $$4('.hdt-disclosure__item', this.disclosure);
  let visibleCountries = allCountries.length;
  this.resetButton.classList.toggle('hidden', !searchValue);
  this.resetButton.tabIndex = searchValue ? 0 : -1;

  allCountries.forEach((item) => {
    const countryName = this.normalizeString($4('[country]',item).textContent);
    if (countryName.indexOf(searchValue) > -1) {
      item.removeAttribute('hidden');
      visibleCountries++;
    } else {
      item.setAttribute('hidden', '');
      visibleCountries--;
    }
  });

  $4('.hdt-country-no-results', this.disclosure)?.toggleAttribute('hidden', visibleCountries);
  if (this.nextElementSibling) this.nextElementSibling.innerHTML = themeHDN.strings.countryCount.replace('[count]', visibleCountries);
  $4('.hdt-disclosure__list', this.disclosure).scrollTop = 0;
  this.closest('hdt-popover').updateTrap(this.search);
  //this.closest('hdt-popover')?.updateFloating;
};
customElements.define("localization-form", LocalizationForm);
customElements.define("hdt-country-filter", CountryFilter);

var _section_ids_modal = new WeakMap();
class LazyModal extends Modal {
  constructor() {
    super();
    getterAdd(_section_ids_modal, this, this.getAttribute('section-id'));
    this._inner = $4('.hdt-dialog-modal__inner', this);
  }
  async open(jump = false) {
    const handle = this.btnOpening?.getAttribute("handle");
    if (!handle) return;

    document.dispatchEvent(new CustomEvent(loadingStart, { bubbles: true }));
    this.btnOpening?.setAttribute("aria-busy", "true");
    const responseSection = await (await fetchCache(`${window.Shopify.routes.root}products/${handle}?section_id=${getterGet(_section_ids_modal, this)}`)).text();
    document.dispatchEvent(new CustomEvent(loadingEnd, { bubbles: true }));
    this.btnOpening?.setAttribute("aria-busy", "false");
    const domElement = new DOMParser().parseFromString(responseSection, "text/html"),
    newSectionModal = document.createRange().createContextualFragment(domElement.getElementById(`shopify-section-${getterGet(_section_ids_modal, this)}`).innerHTML);
    const mediaContext = MediaVisibilityContext.fromElement(this.btnOpening);
    const productMedia = $4('hdt-product-media', newSectionModal);
    const productCollections = (productMedia?.dataset.productCollectionHandles || '').split('|').filter(Boolean);
    const contextCollections = mediaContext?.collectionHandles?.length ? mediaContext.collectionHandles : [mediaContext?.collectionHandle].filter(Boolean);
    if (mediaContext && contextCollections.some((handle) => productCollections.includes(handle))) {
      productMedia.dataset.mediaVisibilityCollection = mediaContext.collectionHandle;
      productMedia.dataset.mediaVisibilityCollectionHandles = contextCollections.join('|');
      productMedia.dataset.mediaVisibilitySuffixes = mediaContext.hideSuffixes.join('||');
    }
    // Update Product title
    const newPrTitle = $4('[product-title]', newSectionModal),
    prTitle = $4('[product-title]', this);
    if (newPrTitle && prTitle) prTitle.textContent = newPrTitle.getAttribute('product-title');
     // end Update Product title
    this._inner.replaceChildren(...newSectionModal.children);
    rteWrapTable(this);
    accessibleLinks(this);
    localeUrl(this);
    Shopify?.PaymentButton?.init();
    document.dispatchEvent(new CustomEvent(currencyUpdate));


    requestAnimationFrame(() => {
      super.open(jump);
    })
  }
  async close(jump = false) {
    await super.close(jump);
    this._inner.innerHTML = "";
  }
  get btnOpening() {
    return this.dialog?.btnOpening;
  }
};
class liveButton extends HTMLElement {
  constructor() {
    super();
    //$id4(this.firstElementChild.getAttribute('aria-controls'))?.updateBtnOpen(this);
  }
  connectedCallback() {
    $4('hdt-tmp-quick')?.dispatchEvent(new CustomEvent("theme:update:id", { bubbles: false }));
  }
};
class TmpQuick extends HTMLElement {
  constructor() {
    super();
    this.getIDTemp();
    this.addEventListener('theme:update:id', () => this.getIDTemp());
  }
  //connectedCallback() {}
  async getIDTemp() {
    const $btn = $4('[aria-controls="hdt-quick-view-modal"], [aria-controls="hdt-quick-add-modal"]');
    if (!$btn || this.hasID) return;
    this.hasID = true;
    this.removeEventListener('theme:update:id', () => this.getIDTemp());
    let response = '',
    idCache = "themeQuick" + window.Shopify.theme.id;
    if (sessionStorage.getItem(idCache) && !Shopify.designMode ) {
      response = sessionStorage.getItem(idCache);
    } else {
      const responseAsText = await (await fetch(`${window.Shopify.routes.root}products/${$btn.getAttribute('handle')}?view=only_config`, {priority: 'low'})).text();
      const tmpDom = new DOMParser().parseFromString(responseAsText, "text/html");
      $$4('#MainContent .hdt-section-lazy .js-tmp', tmpDom).forEach( (tmp)=> {
        response += tmp.innerHTML;
      });
      sessionStorage.setItem(idCache, response)
    }
    this.insertAdjacentHTML("afterend", response);
    this.remove();
  }
}

customElements.define('hdt-lazy-modal', LazyModal);
customElements.define("wrapp-hdt-open-btn", liveButton);
customElements.define('hdt-tmp-quick', TmpQuick);

var _hotspot_reveal = new WeakSet(),
hotspot_reveal_fn, hotspot_img = new WeakMap();
class hotspotReveal extends HTMLElement {
  constructor() {
    super();
    if (!matchMediaQuery("motion") || !this.hasAttribute('reveal-on-scroll') ) return;
    getterAdd(_hotspot_reveal, this);
    getterAdd(hotspot_img, this, $4('.hdt-media-wrapper > img', this));
    inView(this, getterRunFn(_hotspot_reveal, this, hotspot_reveal_fn).bind(this), { margin: "-50px 0px" });
  }
};
hotspot_reveal_fn = async function() {
  await checkImagesLoaded(getterGet(hotspot_img, this));
  animate(
    $$4('.hdt-hotspot__btn', this),
    { opacity: 1, transform: ["rotate(180deg) scale(0)", "rotate(0deg) scale(1)"] },
    { duration: 0.35, delay: stagger(0.5), ease: [0.25, 0.1, 0.25, 1.0] }
  )
};
customElements.define('hdt-hotspot', hotspotReveal);

/**
* 12. Accordion
* -----------------------------------------------------------------------------
*/
var _details = new WeakMap(),
_summary = new WeakMap(),
_content = new WeakMap(),
_on_keydown = new WeakSet(), on_keydown_fn;
class Accordion extends HTMLElement {
  #controller;
  constructor() {
    super();
    getterAdd(_details, this, $4('details', this));
    getterAdd(_summary, this, $4('summary', this));
    getterAdd(_content, this, getterGet(_summary, this).nextElementSibling);
    getterAdd(_on_keydown, this);
  }
  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    getterGet(_summary, this).addEventListener("click", this._onSummaryClicked.bind(this), { signal });
    getterGet(_summary, this).addEventListener("pick", this._onSummaryClicked.bind(this), { signal });
    getterGet(_details, this).addEventListener("keydown", getterRunFn(_on_keydown, this, on_keydown_fn).bind(this), { signal });
    if (Shopify.designMode) {
      this.addEventListener(admEvts.select, () => this.toggle(), { signal });
      this.addEventListener(admEvts.deselect, () => this.toggle2(), { signal });
    }
  }
  disconnectedCallback() {
    this.#controller.abort();
  }
  get open() {
    return getterGet(_details, this).hasAttribute('open');
  }
  get _summary() {
    return getterGet(_summary, this);
  }
  get _details() {
    return getterGet(_details, this);
  }
  toggle(setOpen = true) {
    if ( (setOpen && !this.open) || (!setOpen && this.open)) {
      this._summary?.dispatchEvent(new CustomEvent("pick", { detail: { offClick: true }}));
    }
  }
  toggle2(){
    this.toggle(false);
  }
  _onSummaryClicked(event) {
    event.preventDefault();
    if (!getterGet(_content, this)) return;
    if (this.hasAttribute('only-click-icon') && !event.target.hasAttribute('accordion-icon') && event?.type == 'click' && this._summary.hasAttribute('data-url') ) {
      return window.location.href = this._summary.getAttribute("data-url");
    }
    if ( !this.hasAttribute('only-click-icon') && event?.type == 'click' && this._summary.hasAttribute("data-url") && this.open ) {
      return window.location.href = this._summary.getAttribute("data-url");
    }
    this._details.style.overflow = "hidden";
    this._summary.setAttribute('aria-expanded', `${!this.open}`);
    if (this.open) {
      animate([
        [getterGet(_content, this), { opacity: 0 }, { duration: 0.15 }],
        [this._details, { height: [`${this._details.clientHeight}px`, `${this._summary.clientHeight}px`] }, { duration: 0.25, at: "<", ease: [0.25, 0.1, 0.25, 1.0] }]
      ]).then(() => {
        this._details.style.height = null;
        this._details.style.overflow = null;
        this._details.removeAttribute('open');
      });
    } else {
      this._details.setAttribute('open', '');
      animate([
        [this._details, { height: [`${this._summary.clientHeight}px`, `${this._details.scrollHeight}px`] }, { duration: 0.25, ease: [0.25, 0.1, 0.25, 1.0] }],
        [getterGet(_content, this), { opacity: [0, 1], transform: ["translateY(4px)", `translateY(0)`] }, { duration: 0.15, at: "-0.1" }]
      ]).then(() => {
        this._details.style.height = null;
        this._details.style.overflow = null;
      });
    }
  }
};
on_keydown_fn = function(e) {
  if (e.key != 'Enter' || !e.target?.hasAttribute('accordion-icon')) return;
  e.preventDefault();
  e.stopPropagation();
  e.target.click();
};
customElements.define("hdt-accordion", Accordion);

class FooterMenu extends Accordion {
  #resize;
  constructor() {
    super();
    if (!matchMediaQuery("motion")) return;
    inView(this, () => {
      animate(this, { opacity: [0, 1], transform: ["translateY(20px)", "translateY(0)"] }, { duration: 0.25, ease: [0.25, 0.1, 0.25, 1.0] });
    }, { margin: "-50px 0px" });
  }
  connectedCallback() {
    super.connectedCallback();
    let oldWidth = 0;
    this.#resize = resize(this, (_,{ width }) => {
      if (oldWidth == width) return;
      oldWidth = width;
      this.setAttribute('resized', '');
      this._details.open = (!matchMediaQuery("mobile") || this._summary.clientWidth == 0) || this.hasAttribute('open-default-mobile');
      this._summary.setAttribute('aria-expanded', this._details.open);
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.#resize) this.#resize();
  }
  toggle2(){
    if (matchMediaQuery("mobile")) this._details.removeAttribute('open')
  }
};
customElements.define("hdt-footer-menu", FooterMenu);

var _header_menus = new WeakMap(),
_header_sticky = new WeakMap(),
_escape = new WeakSet(), escape_fn,
//_click_outside = new WeakSet(), click_outside_fn,
// _click_outside_handler = new WeakMap(),
// _escape_handler = new WeakMap(),
_event = new WeakMap();
class HeaderMenu extends Accordion {
  #controller;
  constructor() {
    super();
    getterAdd(_header_menus, this, $$4('header-menu', this.closest('nav')));
    getterAdd(_header_sticky, this, $4('.hdt-sticky-header'));
    getterAdd(_escape, this);
    //getterAdd(_click_outside, this);
    // getterAdd(_escape_handler, this, getterRunFn(_escape, this, escape_fn).bind(this));
    // getterAdd(_click_outside_handler, this, getterRunFn(_click_outside, this, click_outside_fn).bind(this));
  }
  connectedCallback() {
    super.connectedCallback();
    // Only add hover functionality if device supports hover
    if (matchMediaQuery("hover") && this.getAttribute('event') === 'hover') {
      this.setupHoverBehavior();
    }
    //const content = $4('.hdt-mega-menu__content, .hdt-dropdown__content', this._details);
    // if (content) {
    //   const clipPath = motionValue("polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)");
    //   styleEffect(content, { clipPath });
    // }
  }
  get event() {
    return getterGet(_event, this, !matchMediaQuery("hover") ? "click" : this.getAttribute("event"));
  }
  get hoverDelay() {
    return 74;
  }
  get closeDelay() {
    return 250;
  }
  get header() {
    return getterGet(_header_sticky, this);
  }
  toggle(setOpen = true) {
    if ( (setOpen && !this.open) || (!setOpen && this.open)) {
      this._summary?.dispatchEvent(new CustomEvent("pick", { detail: { offClick: true }}));
    }
  }
  _onSummaryClicked(event) {
    event.preventDefault();
    //event.stopPropagation();
    //event.stopImmediatePropagation
    //console.log(this._details, document.activeElement);
    if (event?.type == 'click' && this.open && this._summary.hasAttribute('data-url') ) {
      return window.location.href = this._summary.getAttribute("data-url");
    }
    const content = $4('.hdt-mega-menu__content, .hdt-dropdown__content', this._details);
    if (this.header) this.header.preventHide = !this.open;
    this._summary.setAttribute('aria-expanded', `${!this.open}`);
    if (!this.open) {
      this.#controller?.abort();
      this.#controller = new AbortController();
      const { signal } = this.#controller;
      //document.addEventListener("click", getterRunFn(_click_outside, this, click_outside_fn).bind(this), { signal });
      this._details.addEventListener("keydown", getterRunFn(_escape, this, escape_fn).bind(this), { signal });
      this._details.addEventListener('focusout', this.#onFocusOut.bind(this), { signal });
      // document.addEventListener("click", getterGet(_click_outside_handler, this));
      // this._details.addEventListener("keydown", getterGet(_escape_handler, this));
      getterGet(_header_menus, this).forEach( (el) => {
        if (el !== this) {
          el._details.open = false;
          el._summary.setAttribute('aria-expanded', false);
        }
      });
      this._details.open = true;
      /*animate([
        [content, { clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)", visibility: ["hidden", "visible"] }, { duration: 0.25, ease: [0.25, 0.1, 0.25, 1.0] }],
        [$$4('[reveal], [can-reveal]', content),
          { opacity: [0, 1], transform: ["translate3d(-10px,10px,0)", "translate3d(0,0,0)"]},
          {
            at: 0.19,
            duration: 0.4,
            ease: [0.25, 0.1, 0.25, 1.0],
            delay: stagger(0.08, { startDelay: 0.1, ease: [0.25, 0.1, 0.25, 1.0], duration: 0.4 })
          }
        ]
      ]);*/
      animate([
        [
          content,
          {
            clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
            visibility: ["visible", "visible"]
          },
          {
            duration: 0
          }
        ],
        [
          $$4('[reveal], [can-reveal]', content),
          {
            opacity: [1, 1],
            transform: [
              "translate3d(0,0,0)",
              "translate3d(0,0,0)"
            ]
          },
          {
            at: 0,
            duration: 0,
            delay: 0
          }
        ]
      ]);
    } else {
      //console.log(content)
      this.#controller?.abort();
      // document.removeEventListener("click", getterGet(_click_outside_handler, this));
      // this._details.removeEventListener("keydown", getterGet(_escape_handler, this));
      animate([
        [content, { clipPath: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)', visibility: ["visible", "hidden"] }, { duration: 0.25, ease: [0.25, 0.1, 0.25, 1.0] }],
      ]).then(() => {
        this._details.open = false;
        this._summary.setAttribute('aria-expanded', 'false');
       });
    }
  }
  setupHoverBehavior() {
    let openTimer = null,
        closeTimer = null;
    hover(this._details, () => {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      openTimer = setTimeout(() => {
        this.toggle(true);
      }, this.hoverDelay);
      return () => {
        clearTimeout(openTimer);
        closeTimer = setTimeout(() => {
          this.toggle(false);
        }, this.closeDelay);
      }
    })
  }
  #onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.toggle(false);
    });
  }
};
// click_outside_fn = function(event) {
//   if (this.event !== "click") return;
//   if (!this.contains(event.target)) {
//     this.toggle(false);
//     this._summary.focus();
//   }
// };
escape_fn = function(event) {
  if (event.code === "Escape") {
    const details = event.target.closest('details[open]');
    if (details ) {
      this.toggle(false);
      this._summary.focus();
      event.stopPropagation();
    }
  }
};

customElements.define("header-menu", HeaderMenu);


/**
* 13. Tab player list
* -----------------------------------------------------------------------------
*/

var _tabs_player = new WeakMap(),
_content_player = new WeakMap(),
_image_player = new WeakMap(),
_tabs_player_section = new WeakMap(),
_tabs_player_color = new WeakMap(),
_tabs_player_slelect = new WeakSet(), tabs_player_slelect_fn;

class TabPlayerList extends AutoplayElement {
  #controller;
  constructor() {
    super();
    this.currIndex = 0;

    getterAdd(_tabs_player, this, $$4('button', this));
    getterAdd(_content_player, this, $id4(this.getAttribute("aria-controls")));
    getterAdd(_image_player, this, $id4('imgs-' + this.getAttribute("aria-controls")));
    getterAdd(_tabs_player_slelect, this);
    getterAdd(_tabs_player_section, this, this.closest(".hdt-tab-block") || this.closest(".shopify-section"));
    getterAdd(_tabs_player_color, this, $4('[color-scheme]', getterGet(_tabs_player_section, this)));
  }
  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    super.connectedCallback();
    if (matchMediaQuery("motion") && this.hasAttribute('reveal-on-scroll')) {
      inView(getterGet(_tabs_player_section, this), () => {
        if (matchMediaQuery("motion") && this.hasAttribute('reveal-on-scroll')) getterRunFn(_tabs_player_slelect, this, tabs_player_slelect_fn).call(this, 0, false);
      }, { margin: "444px" });
    }

    getterGet(_tabs_player, this).forEach((tab, index) => {
      tab.index = index;
      tab.addEventListener('click', ()=> {
        this.stop();
        getterRunFn(_tabs_player_slelect, this, tabs_player_slelect_fn).call(this, index, !matchMediaQuery("motion"));
        this.play();
      }, { signal });
    });

    if (Shopify.designMode) {
      const dtAtrr = 'data-auto_switch',
      autoRotate = $4(`[${dtAtrr}]`, getterGet(_tabs_player_section, this));
      this.addEventListener(admEvts.select, (event) => {
        if (this.interval) autoRotate?.setAttribute(dtAtrr, 'false');
        this.pause();
        getterRunFn(_tabs_player_slelect, this, tabs_player_slelect_fn).call(this, event.target.index)
      }, { signal });
      this.addEventListener(admEvts.deselect, ()=> {
        if (this.interval) autoRotate?.setAttribute(dtAtrr, 'true');
        this.resume();
      }, { signal });
    }

  }
  disconnectedCallback() {
    super.disconnectedCallback();
  }
  get customPlayFn () {
    return ()=> {
      getterRunFn(_tabs_player_slelect, this, tabs_player_slelect_fn).call(this);
    }
  }
  // get customPauseFn () {
  //   return null;
  // }
  get nextIndex() {
    return (this.currIndex + 1) % getterGet(_tabs_player, this).length;
  }
};
tabs_player_slelect_fn = async function(index = null, instantly = false) {
  //console.log('tabs_player_slelect_fn', index)
  //console.log(index, getterGet(_tabs_player, this))
  this.currIndex = index != null ? index : this.nextIndex;
  const btn = getterGet(_tabs_player, this)[this.currIndex],
  content = getterGet(_content_player, this)?.children[this.currIndex];
  if (content) {
    //getterGet(_tabs_player, this)[this.lastIndex]?.setAttribute('aria-current', 'false');
    getterGet(_tabs_player, this).filter((btn) => btn.getAttribute('aria-current') == 'true').forEach((btn) => {
      btn.setAttribute('aria-current', 'false');
    });
    btn?.setAttribute('aria-current', 'true');
    if (btn?.getAttribute('color')) {
      //console.log(getterGet(_tabs_player_section, this))
      //console.log(getterGet(_tabs_player_color, this))
      getterGet(_tabs_player_color, this)?.setAttribute('color-scheme', btn.getAttribute('color'));
    }
    [...getterGet(_content_player, this)?.children]?.filter((content) => !content.hasAttribute('hidden')).forEach((content) => {
      content.setAttribute('hidden', '');
    });
    //getterGet(_content_player, this)?.children
    //getterGet(_content_player, this)?.children[this.lastIndex]?.setAttribute('hidden', '');
    content.removeAttribute('hidden');
    const contentHasAssignImg = $id4(content.getAttribute("assign-img")),
    sequence = [],
    assignImg = $4('img', contentHasAssignImg);
    if (contentHasAssignImg) {
      //getterGet(_image_player, this)?.children[this.lastIndex]?.setAttribute('hidden', '');
      [...getterGet(_image_player, this)?.children]?.filter((img) => !img.hasAttribute('hidden')).forEach((img) => {
        img.setAttribute('hidden', '');
      });
      contentHasAssignImg.removeAttribute('hidden');
      sequence.push([assignImg, { opacity: [0, 1], transform: ["scale(1.25) translateX(-50px)", "scale(1) translateX(0px)"] }, { ease: [0.19, 1, 0.22, 1], duration: 0.8 }]);
    }
    sequence.push([
      $$4('[reveal]', content),
      { opacity: [0, 1], transform: animationContent['ani1'] },
      {
        duration: 0.8,
        delay: stagger(0.1, { startDelay: 0.4, ease: [0.25, 0.1, 0.25, 1.0] }),
        ease: [0, 0.87, 0.58, 1],
        ...(assignImg && { at: "<" }) // add at: "<" if img is exists
      }
    ]);
    //this.lastIndex = index;
    if (this.hasAttribute('custom-effect')) return;
    await checkImagesLoaded(assignImg);
    const animation = animate(sequence);
    //console.log(instantly)
    if (instantly) {
      animation.complete();
    }
  }
};
customElements.define('hdt-tab-player-list', TabPlayerList);

/**
* 14. Copy button and share button
* -----------------------------------------------------------------------------
*/
var _copy_to_clipboard, copy_to_clipboard_fn;
class CopyButton extends HTMLElement {
  #controller;
  constructor() {
    super();
    getterAdd(_copy_to_clipboard, this);
    this.actionCopy = this.input?.hasAttribute('value') ? 'value' : 'textContent';
  }
  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.addEventListener("click", getterRunFn(_copy_to_clipboard, this, copy_to_clipboard_fn).bind(this, this.input), { signal });
    if (this.input && this.hasAttribute("get-doc-url")) {
      this.closest('hdt-popover')?.addEventListener(dialogOpening, () => {
        this.input[this.actionCopy] = this.textCopy;
      }, { signal });
    }
  }
  disconnectedCallback() {
    this.#controller.abort();
  }
  get input() {
    return $id4(this.getAttribute("text-id"));
  }
  get textCopy() {
    return this.hasAttribute("get-doc-url") ? document.location.href : (this.dataset.text || this.input[this.actionCopy] || "");
  }
};
_copy_to_clipboard = new WeakSet();
copy_to_clipboard_fn = async function(input) {
  if (!navigator.clipboard) return;
  await navigator.clipboard.writeText(this.textCopy);
  if (this.hasAttribute("data-success-message")) {
    input = input || this;
    const originalText = input[this.actionCopy];
    input[this.actionCopy] = this.getAttribute("data-success-message");
    setTimeout(() => {
      input[this.actionCopy] = originalText;
    }, 1500);
  }
};

// https://dev.to/timhuang/a-simple-way-to-detect-if-browser-is-on-a-mobile-device-with-javascript-44j3
var _native_share, native_share_fn;
class ShareButton extends HTMLElement {
  #controller;
  constructor() {
    super();
    getterAdd(_native_share, this);
    this.hidden = !navigator.share || window.matchMedia("screen and (pointer: fine)").matches;
  }
  connectedCallback() {
    this.#controller = new AbortController();
    if (!this.hidden) this.addEventListener("click", getterRunFn(_native_share, this, native_share_fn), { signal: this.#controller.signal });
  }
  disconnectedCallback() {
    this.#controller.abort();
  }
};
_native_share = new WeakSet();
native_share_fn = function() {
  navigator.share({
    title: this.getAttribute("share-title") || document.title,
    url: this.getAttribute("share-url") || document.location.href
  });
};
customElements.define("wrapp-hdt-copy-btn", CopyButton);
customElements.define("wrapp-hdt-share-btn", ShareButton);

/**
* 15. Lazy HTML
* -----------------------------------------------------------------------------
* https://web.dev/articles/fetch-priority
*/
class LazyHTML extends HTMLElement {
  #controller;
  check = true;
  constructor() {
    super();
  }
  connectedCallback() {
    this.#controller = new AbortController();
    const options = {
      priority: this.getAttribute('priority') || 'low',
      signal: this.#controller.signal
    },
    url = this.url || this.getAttribute('url') || `${Shopify.routes.root}?section_id=${this.getAttribute('section-id')}`;
    if (url) this.lazyFetch(url, options);
  }
  disconnectedCallback() {
    if (this.check) this.#controller.abort();
  }
  async lazyFetch(url, options) {
    const response = await fetchCache(url, '', options),
          tempDiv  = new DOMParser().parseFromString(await response.text(), "text/html");
    this.check = false;
    const formLocal = $4('.shopify-localization-form', tempDiv);
    if (formLocal) {
      const language = $id4('localization_form_language');
      $4('[name="return_to"]', formLocal).value = language && language.return_to ? language.return_to.value : location.pathname;
    }
    this._replace(tempDiv);
  }
  _replace(tempDiv) {
    this.replaceWith(...tempDiv.querySelector('.shopify-section').children);
    this.dispatchEvent(new CustomEvent("lazyhtml:added", { bubbles: true }));
  }
}
customElements.define("hdt-lazy-html", LazyHTML);

/**
* 16. Customer JS
* -----------------------------------------------------------------------------
*/
class ShowPassword extends HTMLElement {
  #controller;
  #input
  constructor() {
    super();
  }
  connectedCallback() {
    this.#controller = new AbortController();
    this.#input = document.getElementById(this.getAttribute('input-id'));
    if (this.#input) this.addEventListener('click', this.toggleType.bind(this), {signal: this.#controller.signal});
  }
  disconnectedCallback() {
    this.#controller.abort();
  }
  toggleType() {
    this.#input.type = this.#input.type == 'text' ? 'password' : 'text';
    this.toggleAttribute('display-password', this.#input.type == 'text');
  }
}
customElements.define("hdt-show-password", ShowPassword);

class CountryProvinceSelector extends HTMLElement {
  #controller;
  #countryEl;
  #provinceEl;
  #provinceContainer;
  constructor() {
    super();
  }
  connectedCallback() {
    this.#controller = new AbortController();
    this.#countryEl        = $4('[name="address[country]"]', this);
    this.#provinceEl       = $4('[name="address[province]"]', this);
    this.#provinceContainer = this.hasAttribute('hide-el') ? $4(this.getAttribute('hide-el'), this) : this.#provinceEl.parentElement;
    this.#countryEl.addEventListener('change', this.#renderProvinces.bind(this), {signal: this.#controller.signal});

    setTimeout(() => {
      // initCountry
      const countryVal = this.#countryEl.selectedIndex === 0 ? this.#countryEl.getAttribute('data-default') : this.#countryEl.value,
          value = this.#provinceEl.selectedIndex === 0 ? this.#provinceEl.getAttribute('data-default') : this.#provinceEl.value;

      if (countryVal) {
        this.#setSelectorByValue(this.#countryEl, countryVal);
        this.#countryEl.dispatchEvent(new Event("change"));
      }
      // initProvince
      if (value && this.#provinceEl.options.length > 0) {
        this.#setSelectorByValue(this.#provinceEl, value);
      }
    }, 88);
  }
  disconnectedCallback() {
    this.#controller.abort();
  }
  #setSelectorByValue(selector, value) {
    selector.selectedIndex = Math.max(0, [...selector.options].findIndex((opt) => value == opt.textContent || value == opt.value));
  }
  #renderProvinces() {
    const optSelected = this.#countryEl.options[this.#countryEl.selectedIndex],
    provinces = JSON.parse(optSelected.getAttribute('data-provinces'));

    this.#provinceContainer.hidden = provinces && provinces.length == 0;
    this.#provinceEl.innerHTML = `${provinces.map(([value, label]) => `<option value="${value}">${label}</option>`).join("")}`;
  }
}
customElements.define("hdt-province", CountryProvinceSelector);

class CustomerAvatar extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this), { once: true });
  }
  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) $4('.hdt-icon', this)?.replaceWith(event.detail.avatar.cloneNode());
  }
}
customElements.define('hdt-customer-avatar', CustomerAvatar);

class CircularText extends HTMLElement {
  constructor() {
    super();
    const radius = parseInt(this.dataset.width)/2;
    const text = this.#formartText(this.getAttribute('aria-label'));
    const circle = $4(".hdt-circular-text__circle", this);
    const chars = [...text];
    const total = chars.length;
    const step = 360 / total;

    chars.forEach((char, i) => {
      const el = document.createElement("span");
      el.setAttribute('aria-hidden', 'true');
      if (char === '|') {
        el.classList.add('hdt-large-dot')
        el.textContent = '•';
      } else {
        el.textContent = char;
      }
      const angle = i * step;
      el.style.transform = `rotate(${angle}deg) translate(${radius}px) rotate(90deg)`;
      circle.appendChild(el);
    });
  }
  #formartText(text) {
    let processedText = text.toUpperCase();
    if (processedText.includes(' ')) {
        processedText = processedText.replace(/ /g, ' | ') + ' | ';
    }
    return processedText;
  }
}
customElements.define('hdt-circular-text', CircularText);

// --------------------------
// Inactive tab message
// --------------------------
class inactiveTabMessage extends HTMLElement {
  #intervalId = null;
  #messageIndex = 0;
  #originalTitle = document.title;
  #messages = [];
  #delay;
  #onVisibilityChange;

  constructor() {
    super();
    this.#onVisibilityChange = this.#handleVisibilityChange.bind(this);
  }

  connectedCallback() {
    this.#parseConfig();
    if (!this.#messages.length) return;
    document.addEventListener('visibilitychange', this.#onVisibilityChange);
  }

  disconnectedCallback() {
    this.#stop();
    document.removeEventListener('visibilitychange', this.#onVisibilityChange);
  }

  #parseConfig() {
    let config = {delay: 500, message: ''};
    try {
      config = JSON.parse(this.getAttribute('config') || '{}');
      this.#delay = Number(config.delay);
      this.#messages = config.message.split(';').map(m => m.trim()).filter(Boolean);
    } catch {}
  }

  #handleVisibilityChange() {
    if (document.hidden) {
      this.#start();
    } else {
      this.#stop();
      document.title = this.#originalTitle;
    }
  }

  #start() {
    if (this.#intervalId) return;
    setTimeout(()=> this.#updateTitle(), 10);
    this.#intervalId = setInterval(() => this.#updateTitle(), this.#delay);
  }

  #stop() {
    if (!this.#intervalId) return;
    clearInterval(this.#intervalId);
    this.#intervalId = null;
    this.#messageIndex = 0;
  }

  #updateTitle() {
    document.title = this.#messages[this.#messageIndex];
    this.#messageIndex = (this.#messageIndex + 1) % this.#messages.length;
  }
}
customElements.define('hdt-inactive-tab', inactiveTabMessage);

class BackToTop extends DeclarativeShadowElement {
  #scroll;
  #offset;
  constructor() {
    super();
  }
  connectedCallback() {
    super.connectedCallback();
    this.#offset = Number(this.getAttribute('offset')) || 100;
    let y = null,
    clipPath = null;
    if (this.#water) {
      y = motionValue("0%");
      clipPath = motionValue(`inset(0% 0 0)`);
      styleEffect(this.#water, { y });
      styleEffect($4('.icon--inside', this.shadowRoot), { clipPath });
    }
    this.#scroll = scroll(progress => {
      this.toggleAttribute('show', !this.shouldHidden && (document.documentElement.scrollTop || document.body.scrollTop) > this.#offset);
      y?.set(`${100 * (1 - progress)}%`);
      clipPath?.set(`inset(${100 * (1 - progress)}% 0 0)`);
    });
    $4('button', this.shadowRoot)?.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  disconnectedCallback() {
    this.#scroll();
    $4('button', this.shadowRoot)?.removeEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }
  get #water() {
    return $4('.water', this.shadowRoot);
  }
}
customElements.define('hdt-back-to-top', BackToTop);

(() => {
  /**
   * Scrollbar Width
   * Table, iframe wrapper
   **/

  /* Scrollbar Width */
  // https://stackoverflow.com/questions/13382516/getting-scroll-bar-width-using-javascript
  function updateScrollbarVar() {
    if (!html.hasAttribute('scroll-lock')) html.style.setProperty('--scrollbar-w', `${Math.max(0, Math.min(20, window.innerWidth - html.clientWidth))}px`);
  }
  updateScrollbarVar();
  window.addEventListener("resize", throttle(updateScrollbarVar));

  /* Table, iframe wrapper */
  // Theme-specific selectors to make tables scrollable
  rteWrapTable();
  accessibleLinks();
  localeUrl();

  // ADDED: Kityfly and Nathan
  // https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
  // https://stackoverflow.com/questions/2915833/how-to-check-browser-for-touchstart-support-using-js-jquery
  // https://stackoverflow.com/questions/27173272/300ms-delay-removal-using-fastclick-js-vs-using-ontouchstart
  // if (navigator.userAgent && /iPad|iPhone|iPod/.test(navigator.userAgent)) {
  //   $4('meta[name="viewport"]', document.head).content = "width=device-width, initial-scale=1.0, height=device-height, minimum-scale=1.0, maximum-scale=1.0";
  // } else  if ("ontouchend" in document) {
  //   let indexFixFristClick = 0;
  //   const FixFristClick = () => { ++indexFixFristClick; if( indexFixFristClick > 1) document.removeEventListener('touchend', FixFristClick) };
  //   document.addEventListener('touchend', FixFristClick);
  // }
  if (navigator.userAgent && /iPad|iPhone|iPod/.test(navigator.userAgent)) {
    $4('meta[name="viewport"]', document.head).content = "width=device-width, initial-scale=1.0, height=device-height, minimum-scale=1.0, maximum-scale=1.0";
  }
  if ("ontouchend" in document) {
    let indexFixFristClick = 0;
    const FixFristClick = () => { ++indexFixFristClick; if( indexFixFristClick > 1) document.removeEventListener('touchend', FixFristClick) };
    document.addEventListener('touchend', FixFristClick);
  }
  const oneItemText = themeHDN?.strings?.cart?.items_added_to_cart_one || '1 item added to cart',
  itemsText = themeHDN?.strings?.cart?.items_added_to_cart_other || '{{ count }} items added to cart';
  document.addEventListener(cartUpdate, (event)=> {
    if ( event.detail.source !== 'product-form' ) return;
    const quantityAdded = event.detail?.formData?.quantity;
    announce(quantityAdded == 1 ? oneItemText : itemsText.replace('{{ count }}', quantityAdded.toString()));
    if ( !$4('hdt-cart-drawer') && themeHDN.settings.pageType != 'cart') {
      const actionAfterATC = event.detail.actionAfterATC || themeHDN.settings.actionAfterATC;
      if (actionAfterATC.indexOf('go_') > -1) window.location.href = actionAfterATC == 'go_custom_link' ? themeHDN.settings.cartCustomLink : `${Shopify.routes.root}${actionAfterATC == 'go_cart_page' ? 'cart' : 'checkout'}`;
    }
  });
  document.addEventListener(cartError, (event)=> {
    //console.log('cart error: ', event.detail);
    announce(event.detail.message, true);
  });
  // if ( !$4('hdt-cart-drawer') && themeHDN.settings.pageType != 'cart') {
  //   document.addEventListener(cartUpdate, (event) => {
  //     if ( event.detail.source !== 'product-form' ) return;
  //     const actionAfterATC = event.detail.actionAfterATC || themeHDN.settings.actionAfterATC;
  //     if (actionAfterATC.indexOf('go_') > -1) window.location.href = actionAfterATC == 'go_custom_link' ? themeHDN.settings.cartCustomLink : `${Shopify.routes.root}${actionAfterATC == 'go_cart_page' ? 'cart' : 'checkout'}`;
  //   });
  // }
  // Accessibility focus footer
  const footer = $4('.hdt-section-footer');
  if (footer && !matchMediaQuery("mobile")) {
    const footerHeading = $$4('summary.hdt-footer-block__heading', footer);
    footerHeading.forEach((heading)=> heading.tabIndex = -1);
    resize(({ width }) => {
      footerHeading.forEach((heading)=> heading.tabIndex = width <= 767 ? 0 : -1);
    })
    if ($4('[sticky-footer]', footer) && !Shopify.designMode ) {
      footer.addEventListener('focusin', () => {
        window.scrollTo({
          top: document.documentElement.scrollHeight,
          behavior: 'smooth'
        });
      });
    }
  }

})();

export {
  getterAdd, getterGet, getterRunFn, Modal, Drawer, Popover,
  isRTL,
  currency,
  rteWrapTable, accessibleLinks, localeUrl, Accordion
}
// var myWorker;
// testWorker();
// function testWorker() {
//   if (typeof(Worker) !== "undefined") {
//     if (typeof(myWorker) == "undefined") {
//       myWorker = new Worker(new URL("webworkertest.js", import.meta.url));
//     }
//     myWorker.onmessage = (event) => {
//         console.log(event)
//     }
//   } else {
//     document.getElementById("loopcount2").innerHTML = "Web Worker not supported";
//   }
// }
// function terminateWorker(){
//   myWorker.terminate();
//   myWorker = undefined;
// }
